export const autosservicoMock = [[
{
    "isSuccess": true,
    "data": [
        [
            {
                "id": 1237,
                "codigoVendedor": "272028",
                "nomeVendedor": "THAYNA FERREIRA OLIVEIRA",
                "basesAutosservico": [
                    {
                        "id": -1,
                        "tag": "Card-Rota",
                        "card": {
                            "totalPedidos": 5,
                            "percentTotalPedidos": -1,
                            "percentPedidosWebCliente": 0.8,
                            "mixPedidosWebCliente": 1,
                            "percentPedidosWebVendedor": 0.2,
                            "mixPedidosWebVendedor": 1,
                            "percentOutros": 0,
                            "mixOutros": 0
                        }
                    },
                    {
                        "id": -2,
                        "tag": "Card-Todos",
                        "card": {
                            "totalPedidos": 22,
                            "percentTotalPedidos": -1,
                            "percentPedidosWebCliente": 0.4090909090909091,
                            "mixPedidosWebCliente": 1.1428571428571428,
                            "percentPedidosWebVendedor": 0.5454545454545454,
                            "mixPedidosWebVendedor": 1.0833333333333333,
                            "percentOutros": 0.045454545454545456,
                            "mixOutros": 1
                        }
                    },
                    {
                        "id": 294783,
                        "codigo": "1510532",
                        "tag": "Rota",
                        "razaoSocial": "MARIA BAYERL DA SILVA 01994057785",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 295366,
                        "codigo": "1450856",
                        "tag": "Rota",
                        "razaoSocial": "KLIPPEL MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 3.6666666666666665,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 295385,
                        "codigo": "1450861",
                        "tag": "Rota",
                        "razaoSocial": "DIMEL DISTRIBUIDORA MEAIPE DE",
                        "media3Meses": 3.6666666666666665,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 311,
                        "codigo": "1495282",
                        "tag": "Todos",
                        "razaoSocial": "F  BRANDAO MARVILA ME",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 14327,
                        "codigo": "1732051",
                        "tag": "Todos",
                        "razaoSocial": "JOSE CARLOS ROCHA DA SILVA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 30609,
                        "codigo": "1769304",
                        "tag": "Todos",
                        "razaoSocial": "SAMUEL FERREIRA DA SILVA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 50297,
                        "codigo": "1764033",
                        "tag": "Todos",
                        "razaoSocial": "ICLEIR MATERIAL DE CONSTRUCAO E",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53132,
                        "codigo": "1756470",
                        "tag": "Todos",
                        "razaoSocial": "RUDHELYS RAMOS RONFIM 14789050777",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53354,
                        "codigo": "1633345",
                        "tag": "Todos",
                        "razaoSocial": "AGRO CONSTRUTORA MACHADO LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53368,
                        "codigo": "1629044",
                        "tag": "Todos",
                        "razaoSocial": "AGROPECUARIA MOINHO LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53383,
                        "codigo": "1632458",
                        "tag": "Todos",
                        "razaoSocial": "42.478.317 EDILSON GOMES COSTA",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53393,
                        "codigo": "1633344",
                        "tag": "Todos",
                        "razaoSocial": "EVANDRO MARCELO VANINI 00797060707",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53453,
                        "codigo": "1588658",
                        "tag": "Todos",
                        "razaoSocial": "LUCIMAR PEREIRA COELHO 09082881748",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53662,
                        "codigo": "1495926",
                        "tag": "Todos",
                        "razaoSocial": "CARLOS DE FREITAS FERNANDES EI",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53673,
                        "codigo": "1496342",
                        "tag": "Todos",
                        "razaoSocial": "MATERIAL DE CONSTRUCAO SANTA ROSA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53676,
                        "codigo": "1495974",
                        "tag": "Todos",
                        "razaoSocial": "CARLOS ADRIANO DA SILVA WINGLER",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53692,
                        "codigo": "1498275",
                        "tag": "Todos",
                        "razaoSocial": "VANINI MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53703,
                        "codigo": "1495991",
                        "tag": "Todos",
                        "razaoSocial": "JHON LENO CARVALHO MARVILA",
                        "media3Meses": 2,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 53711,
                        "codigo": "1473598",
                        "tag": "Todos",
                        "razaoSocial": "ANTONELI MATERIAIS DE CONSTRUCAO EI",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 5
                            }
                        ]
                    },
                    {
                        "id": 53738,
                        "codigo": "1481199",
                        "tag": "Todos",
                        "razaoSocial": "COMERCIAL FOSSE & SOUZA LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53757,
                        "codigo": "1461625",
                        "tag": "Todos",
                        "razaoSocial": "V F MAIFREDO",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53758,
                        "codigo": "1448343",
                        "tag": "Todos",
                        "razaoSocial": "CONSTRUSUL EMPREENDIMENTOS LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 53801,
                        "codigo": "1460999",
                        "tag": "Todos",
                        "razaoSocial": "FAVARIS & FILHOS MATERIAL DE",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53833,
                        "codigo": "1409184",
                        "tag": "Todos",
                        "razaoSocial": "LIMOAGRO PRODUTOS AGRICOLAS LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53844,
                        "codigo": "1409376",
                        "tag": "Todos",
                        "razaoSocial": "SAPAVINE MATERIAL DE CONSTRUCAO LTD",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53878,
                        "codigo": "1431633",
                        "tag": "Todos",
                        "razaoSocial": "SERWI MADEIRAS E MATERIAIS DE",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 53898,
                        "codigo": "1411155",
                        "tag": "Todos",
                        "razaoSocial": "TONETTO MATERIAIS DE CONSTRUCAO LTD",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53899,
                        "codigo": "1411806",
                        "tag": "Todos",
                        "razaoSocial": "KEMACOL MATERIAL DE CONSTRUCAO EIRE",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 55591,
                        "codigo": "1428530",
                        "tag": "Todos",
                        "razaoSocial": "J S BATISTA LTDA",
                        "media3Meses": 2.6666666666666665,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 55670,
                        "codigo": "1409210",
                        "tag": "Todos",
                        "razaoSocial": "L M D  ROSSETTO MATERIAL DE",
                        "media3Meses": 2,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 56332,
                        "codigo": "1199940",
                        "tag": "Todos",
                        "razaoSocial": "G N MATERIAL DE CONSTRUCAO LTDA   M",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 250492,
                        "codigo": "1797951",
                        "tag": "Todos",
                        "razaoSocial": "R. A. G. CONSTRUTORA LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253126,
                        "codigo": "1501651",
                        "tag": "Todos",
                        "razaoSocial": "M R S MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253349,
                        "codigo": "1799692",
                        "tag": "Todos",
                        "razaoSocial": "COUTINHO MATERIAL DE CONSTRUCAO LTD",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253351,
                        "codigo": "1799711",
                        "tag": "Todos",
                        "razaoSocial": "3R MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253363,
                        "codigo": "1578553",
                        "tag": "Todos",
                        "razaoSocial": "37 032 096 EVISSON DE LIMA COSTA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253364,
                        "codigo": "1650476",
                        "tag": "Todos",
                        "razaoSocial": "JOIL GOMES DA SILVA 15741487700",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253470,
                        "codigo": "1501604",
                        "tag": "Todos",
                        "razaoSocial": "POSTSUL HOME CENTER LTDA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253529,
                        "codigo": "1781375",
                        "tag": "Todos",
                        "razaoSocial": "FORTE MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 253637,
                        "codigo": "1759853",
                        "tag": "Todos",
                        "razaoSocial": "MADEIREIRA MIMOSO E MATERIAIS DE",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 271494,
                        "codigo": "1496334",
                        "tag": "Todos",
                        "razaoSocial": "COMERCIAL PARTELLI LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 293098,
                        "codigo": "1495288",
                        "tag": "Todos",
                        "razaoSocial": "SANTA BARBARA MATERIAL DE CONS",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 293876,
                        "codigo": "1408966",
                        "tag": "Todos",
                        "razaoSocial": "G G MATERIAL DE CONSTRUCAO LTDA M",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 294783,
                        "codigo": "1510532",
                        "tag": "Todos",
                        "razaoSocial": "MARIA BAYERL DA SILVA 01994057785",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 295108,
                        "codigo": "1464754",
                        "tag": "Todos",
                        "razaoSocial": "L F PIMENTEL ME",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 295127,
                        "codigo": "1536751",
                        "tag": "Todos",
                        "razaoSocial": "RANGEL MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 295285,
                        "codigo": "1462397",
                        "tag": "Todos",
                        "razaoSocial": "JONIL MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 295366,
                        "codigo": "1450856",
                        "tag": "Todos",
                        "razaoSocial": "KLIPPEL MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 3.6666666666666665,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 295385,
                        "codigo": "1450861",
                        "tag": "Todos",
                        "razaoSocial": "DIMEL DISTRIBUIDORA MEAIPE DE",
                        "media3Meses": 3.6666666666666665,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 588893,
                        "codigo": "1422133",
                        "tag": "Todos",
                        "razaoSocial": "C E C MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 641931,
                        "codigo": "1834352",
                        "tag": "Todos",
                        "razaoSocial": "60 072 306 CARLA ROSA MARTINS",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 641934,
                        "codigo": "1834361",
                        "tag": "Todos",
                        "razaoSocial": "CIMENTOS CAPARAO LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 655408,
                        "codigo": "1838468",
                        "tag": "Todos",
                        "razaoSocial": "JS CASA & CONSTRUCAO LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1047329,
                        "codigo": "1858584",
                        "tag": "Todos",
                        "razaoSocial": "CASA FEITA CONSTRUCAO LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1051310,
                        "codigo": "1861223",
                        "tag": "Todos",
                        "razaoSocial": "TCHE COMERCIO  REPRESENTACAO E",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1085037,
                        "codigo": "1879655",
                        "tag": "Todos",
                        "razaoSocial": "MARFIM CONSTRUCAO LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 0,
                        "codigo": "CreatedAt",
                        "createdAt": "2026-07-08T09:10:08.8942791"
                    }
                ]
            },
            {
                "id": 1219,
                "codigoVendedor": "250513",
                "nomeVendedor": "SILVIA APARECIDA MARTINS BUENO",
                "basesAutosservico": [
                    {
                        "id": -1,
                        "tag": "Card-Rota",
                        "card": {
                            "totalPedidos": 4,
                            "percentTotalPedidos": -1,
                            "percentPedidosWebCliente": 0,
                            "mixPedidosWebCliente": 0,
                            "percentPedidosWebVendedor": 0.25,
                            "mixPedidosWebVendedor": 1,
                            "percentOutros": 0.75,
                            "mixOutros": 1.6666666666666667
                        }
                    },
                    {
                        "id": -2,
                        "tag": "Card-Todos",
                        "card": {
                            "totalPedidos": 95,
                            "percentTotalPedidos": -1,
                            "percentPedidosWebCliente": 0.17894736842105263,
                            "mixPedidosWebCliente": 2.2666666666666666,
                            "percentPedidosWebVendedor": 0.021052631578947368,
                            "mixPedidosWebVendedor": 3,
                            "percentOutros": 0.8,
                            "mixOutros": 2.4225352112676055
                        }
                    },
                    {
                        "id": 70598,
                        "codigo": "1343393",
                        "tag": "Rota",
                        "razaoSocial": "RENIVALDO PEREIRA DE OLIVEIRA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 70677,
                        "codigo": "1522288",
                        "tag": "Rota",
                        "razaoSocial": "JOSE JONAS DOS SANTOS COSTA",
                        "media3Meses": 2.6666666666666665,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0.5,
                        "percentOutros": 0.5,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "SERVIÇOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 70944,
                        "codigo": "1435869",
                        "tag": "Rota",
                        "razaoSocial": "SOLANGE MOURA SOARES CONSTRUCAO LTD",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 70982,
                        "codigo": "1567226",
                        "tag": "Rota",
                        "razaoSocial": "GILVANIO SOARES DE OLIVEIRA FILHO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 71010,
                        "codigo": "1406512",
                        "tag": "Rota",
                        "razaoSocial": "A K V PESSOA",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1041167,
                        "codigo": "1855403",
                        "tag": "Rota",
                        "razaoSocial": "F F A DE S BITTENCOURT COMERCIO E",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 1076241,
                        "codigo": "1873769",
                        "tag": "Rota",
                        "razaoSocial": "RIACHINHO MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1088755,
                        "codigo": "1882398",
                        "tag": "Rota",
                        "razaoSocial": "62 500 093 JONAS LOBO SILVEIRA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1093513,
                        "codigo": "1885237",
                        "tag": "Rota",
                        "razaoSocial": "60 520 918 DAYANA MARTA BUENO",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 427,
                        "codigo": "1669120",
                        "tag": "Todos",
                        "razaoSocial": "JOSE DIAS DOS SANTOS FILHO",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 4391,
                        "codigo": "1436364",
                        "tag": "Todos",
                        "razaoSocial": "KLG  COMERCIO VAREJISTA DE MATERIAI",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 5261,
                        "codigo": "1806916",
                        "tag": "Todos",
                        "razaoSocial": "NEILTON DE MELO LIMA FILHO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 5402,
                        "codigo": "1525949",
                        "tag": "Todos",
                        "razaoSocial": "MALIBU MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 6100,
                        "codigo": "1769380",
                        "tag": "Todos",
                        "razaoSocial": "R A CONSTRUCAO ELETRICA E HIDRAULIC",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 12386,
                        "codigo": "1098488",
                        "tag": "Todos",
                        "razaoSocial": "JOSE CARLOS CAMARA ME",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 13843,
                        "codigo": "1067432",
                        "tag": "Todos",
                        "razaoSocial": "SIMOES E GONCALVES LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 13844,
                        "codigo": "1356577",
                        "tag": "Todos",
                        "razaoSocial": "MADEREIRA CAPELA COMERCIO DE MADEIR",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 13902,
                        "codigo": "1506403",
                        "tag": "Todos",
                        "razaoSocial": "ISABEL DA SILVA SANTOS DE XIQUE XIQ",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 14503,
                        "codigo": "1351435",
                        "tag": "Todos",
                        "razaoSocial": "TATIANA PASSOS SILVA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 16583,
                        "codigo": "1568298",
                        "tag": "Todos",
                        "razaoSocial": "AMB MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 16616,
                        "codigo": "1655108",
                        "tag": "Todos",
                        "razaoSocial": "KARIANY FELIX DA SILVA 09628268554",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 16642,
                        "codigo": "1639702",
                        "tag": "Todos",
                        "razaoSocial": "ALEIKA SANTOS PEDRA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 16741,
                        "codigo": "1718417",
                        "tag": "Todos",
                        "razaoSocial": "MAPEMA MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 16757,
                        "codigo": "1731150",
                        "tag": "Todos",
                        "razaoSocial": "FIEL MATERIAIS DE CONSTRUCAO E",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 19301,
                        "codigo": "1068715",
                        "tag": "Todos",
                        "razaoSocial": "MFCOSTA CONSTRUCOES LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 19765,
                        "codigo": "1314606",
                        "tag": "Todos",
                        "razaoSocial": "BARROS E OLIVEIRA CONSTRUCOES LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 19857,
                        "codigo": "1156654",
                        "tag": "Todos",
                        "razaoSocial": "SALVADOR LAJES LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 19886,
                        "codigo": "1080687",
                        "tag": "Todos",
                        "razaoSocial": "A E S BIAO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 20542,
                        "codigo": "1405004",
                        "tag": "Todos",
                        "razaoSocial": "EMANUEL BARBOSA DE OLIVEIRA",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 20758,
                        "codigo": "1808315",
                        "tag": "Todos",
                        "razaoSocial": "PJA COMERCIO DE MATERIAIS ELETRICOS",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 25670,
                        "codigo": "1068866",
                        "tag": "Todos",
                        "razaoSocial": "ROQUE FRAGA RIBEIRO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 25781,
                        "codigo": "1726531",
                        "tag": "Todos",
                        "razaoSocial": "MARLON DOS SANTOS PACHECO",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 26529,
                        "codigo": "1119593",
                        "tag": "Todos",
                        "razaoSocial": "AJGA MATERIAIS PARA CONSTRUCAO E",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 27564,
                        "codigo": "1808878",
                        "tag": "Todos",
                        "razaoSocial": "SOL NASCENTE MATERIAL PARA CONSTRUC",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 28039,
                        "codigo": "1735778",
                        "tag": "Todos",
                        "razaoSocial": "VIVALDO FERNANDES DA SILVA JUNIOR",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 29717,
                        "codigo": "1719226",
                        "tag": "Todos",
                        "razaoSocial": "J FERNANDES DOS SANTOS FILHO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 31163,
                        "codigo": "1483465",
                        "tag": "Todos",
                        "razaoSocial": "NOVA ERA COMERCIAL DE TINTAS LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 31192,
                        "codigo": "1336065",
                        "tag": "Todos",
                        "razaoSocial": "VAREJAO DAS TINTAS LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 32769,
                        "codigo": "1480957",
                        "tag": "Todos",
                        "razaoSocial": "MC DOS SANTOS COMERCIAL LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 40337,
                        "codigo": "1570567",
                        "tag": "Todos",
                        "razaoSocial": "37 546 986 VITOR FERREIRA RODRIGUES",
                        "media3Meses": 3,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 41096,
                        "codigo": "1269651",
                        "tag": "Todos",
                        "razaoSocial": "JUSCELINO DA COSTA PEREIRA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 41100,
                        "codigo": "1713870",
                        "tag": "Todos",
                        "razaoSocial": "HEBER EPIFANIO DO AMARAL",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 42406,
                        "codigo": "1034742",
                        "tag": "Todos",
                        "razaoSocial": "M G C COMERCIO DE MATERIAIS DE",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 49716,
                        "codigo": "1425178",
                        "tag": "Todos",
                        "razaoSocial": "BELO PISO MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 49724,
                        "codigo": "1285351",
                        "tag": "Todos",
                        "razaoSocial": "A M REVESTIR PISOS E ACABAMENTOS",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 51222,
                        "codigo": "1624584",
                        "tag": "Todos",
                        "razaoSocial": "COMERCIAL MADEIRA EIRELI",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 51669,
                        "codigo": "1140994",
                        "tag": "Todos",
                        "razaoSocial": "MADEIREIRA SERRA DOURADA LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 51952,
                        "codigo": "1339098",
                        "tag": "Todos",
                        "razaoSocial": "ANAILTON SANTANA SILVA ME",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 51970,
                        "codigo": "1386615",
                        "tag": "Todos",
                        "razaoSocial": "DANILO DE SOUZA SANTOS",
                        "media3Meses": 2.6666666666666665,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 56844,
                        "codigo": "1812092",
                        "tag": "Todos",
                        "razaoSocial": "MARLOS PEREGRINO MACIEL LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 60467,
                        "codigo": "1752183",
                        "tag": "Todos",
                        "razaoSocial": "37 658 167 LUIZ GOMES DE MELO JUNIO",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 60847,
                        "codigo": "1217698",
                        "tag": "Todos",
                        "razaoSocial": "FEIRA TINTAS LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 63811,
                        "codigo": "1588765",
                        "tag": "Todos",
                        "razaoSocial": "LUIZ CARLOS DE SOUZA JUNIOR 0167193",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 64063,
                        "codigo": "1718657",
                        "tag": "Todos",
                        "razaoSocial": "G R NETO LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 70169,
                        "codigo": "1713920",
                        "tag": "Todos",
                        "razaoSocial": "CAMPOS E MAFRA LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 70199,
                        "codigo": "1507451",
                        "tag": "Todos",
                        "razaoSocial": "MAURICEIA FERREIRA XAVIER",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 70208,
                        "codigo": "1598228",
                        "tag": "Todos",
                        "razaoSocial": "MUCURI CONSTRUCOES LTDA",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 70245,
                        "codigo": "1797033",
                        "tag": "Todos",
                        "razaoSocial": "MARIA LAURISANIA CHRYSOSTOMO DA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "SERVIÇOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 70427,
                        "codigo": "1352113",
                        "tag": "Todos",
                        "razaoSocial": "DIOGENES LINO DOS ANJOS",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 70546,
                        "codigo": "1080597",
                        "tag": "Todos",
                        "razaoSocial": "P A CONSTRUCAO E COMERCIO LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 70595,
                        "codigo": "1349019",
                        "tag": "Todos",
                        "razaoSocial": "TENORIO E OLIVEIRA MADEIRAS LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 70598,
                        "codigo": "1343393",
                        "tag": "Todos",
                        "razaoSocial": "RENIVALDO PEREIRA DE OLIVEIRA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 70658,
                        "codigo": "1126541",
                        "tag": "Todos",
                        "razaoSocial": "REJANE FERREIRA DA SILVA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 70671,
                        "codigo": "1384863",
                        "tag": "Todos",
                        "razaoSocial": "IVANILDA NASCIMENTO DOS SANTOS",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 70677,
                        "codigo": "1522288",
                        "tag": "Todos",
                        "razaoSocial": "JOSE JONAS DOS SANTOS COSTA",
                        "media3Meses": 2.6666666666666665,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0.5,
                        "percentOutros": 0.5,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "SERVIÇOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 70678,
                        "codigo": "1235359",
                        "tag": "Todos",
                        "razaoSocial": "E  S  COSTA DE ALMEIDA   CONSTRUCOE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 70840,
                        "codigo": "1720893",
                        "tag": "Todos",
                        "razaoSocial": "CLAUDIONOR DA SILVA JUNIOR ARMARINH",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 70944,
                        "codigo": "1435869",
                        "tag": "Todos",
                        "razaoSocial": "SOLANGE MOURA SOARES CONSTRUCAO LTD",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 70958,
                        "codigo": "1695937",
                        "tag": "Todos",
                        "razaoSocial": "S C COMERCIAL SAO CAETANO LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 70964,
                        "codigo": "1648440",
                        "tag": "Todos",
                        "razaoSocial": "ADRIANO CAVALCANTE ALVES FILHO",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 70965,
                        "codigo": "1636660",
                        "tag": "Todos",
                        "razaoSocial": "36.322.700 FERNANDO ANTONIO BASTOS",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 70966,
                        "codigo": "1633931",
                        "tag": "Todos",
                        "razaoSocial": "RJ TREVO CONSTRUCOES LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 70975,
                        "codigo": "1603485",
                        "tag": "Todos",
                        "razaoSocial": "JESSICA DESIREE RICARDO DE AQUINO",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 70980,
                        "codigo": "1576461",
                        "tag": "Todos",
                        "razaoSocial": "ARLETE LOPES COSTA DE MELO",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 70982,
                        "codigo": "1567226",
                        "tag": "Todos",
                        "razaoSocial": "GILVANIO SOARES DE OLIVEIRA FILHO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 70998,
                        "codigo": "1479061",
                        "tag": "Todos",
                        "razaoSocial": "ANDRENILDA DANTAS LTDA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 71010,
                        "codigo": "1406512",
                        "tag": "Todos",
                        "razaoSocial": "A K V PESSOA",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 71018,
                        "codigo": "1344558",
                        "tag": "Todos",
                        "razaoSocial": "M ANDRE DA SILVA",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 115048,
                        "codigo": "1766206",
                        "tag": "Todos",
                        "razaoSocial": "LUSO COMERCIO LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 121102,
                        "codigo": "1765890",
                        "tag": "Todos",
                        "razaoSocial": "JJI MATERIAS DE CONSTRUCAO LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 122076,
                        "codigo": "1437578",
                        "tag": "Todos",
                        "razaoSocial": "24 927 991 ISAIAS DE SOUSA TELES",
                        "media3Meses": 3.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 123759,
                        "codigo": "1067564",
                        "tag": "Todos",
                        "razaoSocial": "IRACI MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 158771,
                        "codigo": "1069531",
                        "tag": "Todos",
                        "razaoSocial": "JACKSON ARAUJO PIRES & CIA LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 175614,
                        "codigo": "1586467",
                        "tag": "Todos",
                        "razaoSocial": "LUCIDALVA DOS ANJOS DO ROSARIO 8367",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 175620,
                        "codigo": "1541216",
                        "tag": "Todos",
                        "razaoSocial": "JOSE DA SILVA 17746396534",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "SERVIÇOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 175954,
                        "codigo": "1805816",
                        "tag": "Todos",
                        "razaoSocial": "55 070 127 GUILHERME SOUZA DE",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "SERVIÇOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 205715,
                        "codigo": "1750614",
                        "tag": "Todos",
                        "razaoSocial": "MARCON MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 10.333333333333334,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 18
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 13
                            }
                        ]
                    },
                    {
                        "id": 208368,
                        "codigo": "1122688",
                        "tag": "Todos",
                        "razaoSocial": "VIVALDO FERREIRA DE FREITAS",
                        "media3Meses": 2.6666666666666665,
                        "pedidosMesAtual": 3,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 212136,
                        "codigo": "1557122",
                        "tag": "Todos",
                        "razaoSocial": "SAN MATEUS EMPREENDIMENTOS LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 215282,
                        "codigo": "1476897",
                        "tag": "Todos",
                        "razaoSocial": "NOVA ERA COMERCIAL DE TINTAS LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 216212,
                        "codigo": "1070736",
                        "tag": "Todos",
                        "razaoSocial": "ROGERIO SAO BERNARDO SIMOES",
                        "media3Meses": 6.333333333333333,
                        "pedidosMesAtual": 3,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 9
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 10
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 12
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 9
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 216369,
                        "codigo": "1473179",
                        "tag": "Todos",
                        "razaoSocial": "T A  REIS E CIA LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 216396,
                        "codigo": "1297071",
                        "tag": "Todos",
                        "razaoSocial": "GENIVALDO BORGES DE ARAUJO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 217950,
                        "codigo": "1483692",
                        "tag": "Todos",
                        "razaoSocial": "REGINA CERQUEIRA EVANGELISTA",
                        "media3Meses": 2.6666666666666665,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 217963,
                        "codigo": "1659592",
                        "tag": "Todos",
                        "razaoSocial": "ALMEIDA TELES JDL LTDA",
                        "media3Meses": 6.666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            }
                        ]
                    },
                    {
                        "id": 217978,
                        "codigo": "1352732",
                        "tag": "Todos",
                        "razaoSocial": "D CERQUEIRA DA SILVA CONSTRUCAO",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 217981,
                        "codigo": "1451745",
                        "tag": "Todos",
                        "razaoSocial": "NERIS NOVAIS MATERIAL DE CONSTRUCAO",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 217991,
                        "codigo": "1590250",
                        "tag": "Todos",
                        "razaoSocial": "MANOELITO DA SILVA SANTOS",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 217992,
                        "codigo": "1572939",
                        "tag": "Todos",
                        "razaoSocial": "GLEICE AQUINO MATIAS DO NASCIMENTO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 217994,
                        "codigo": "1623265",
                        "tag": "Todos",
                        "razaoSocial": "LAURICE ALVES DE SOUZA CAVALCANTE",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 217998,
                        "codigo": "1704083",
                        "tag": "Todos",
                        "razaoSocial": "JOAO NETO MATOS PIRES",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 217999,
                        "codigo": "1699978",
                        "tag": "Todos",
                        "razaoSocial": "M R DE SOUZA MATERIAIS DE CONSTRUCA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 218004,
                        "codigo": "1757766",
                        "tag": "Todos",
                        "razaoSocial": "O D S CONSTRUTORA SILVA LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 218480,
                        "codigo": "1237766",
                        "tag": "Todos",
                        "razaoSocial": "PAULO FERREIRA PINA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 218686,
                        "codigo": "1477492",
                        "tag": "Todos",
                        "razaoSocial": "REGINALDO OLIVEIRA SOUSA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 218688,
                        "codigo": "1515951",
                        "tag": "Todos",
                        "razaoSocial": "MARLINDO DO CARMO RODRIGUES",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 218795,
                        "codigo": "1646506",
                        "tag": "Todos",
                        "razaoSocial": "EVA MATERIAL PARA CONSTRUCOES LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 218874,
                        "codigo": "1197113",
                        "tag": "Todos",
                        "razaoSocial": "RONALDO YOHEI OZAWA EIRELI",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 218983,
                        "codigo": "1553071",
                        "tag": "Todos",
                        "razaoSocial": "ADRIANA MADEIREIRA E MATERIAIS DE C",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 218988,
                        "codigo": "1402326",
                        "tag": "Todos",
                        "razaoSocial": "WILLIAN MOREIRA DE OLIVEIRA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 219251,
                        "codigo": "1354147",
                        "tag": "Todos",
                        "razaoSocial": "DULCE OLIVEIRA BASTOS SANTANA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 219297,
                        "codigo": "1165327",
                        "tag": "Todos",
                        "razaoSocial": "JOSAFA MEIRA REGO",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 219334,
                        "codigo": "1478719",
                        "tag": "Todos",
                        "razaoSocial": "ALDO DA CUNHA OLIVEIRA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 219495,
                        "codigo": "1255336",
                        "tag": "Todos",
                        "razaoSocial": "N ARISTEU DOS SANTOS DE UNA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 219534,
                        "codigo": "1069807",
                        "tag": "Todos",
                        "razaoSocial": "FIGUEREDO MATERIAIS DE CONSTRUCAO L",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 219535,
                        "codigo": "1147577",
                        "tag": "Todos",
                        "razaoSocial": "ANDRE MEIRA REGO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 219574,
                        "codigo": "1686704",
                        "tag": "Todos",
                        "razaoSocial": "DANIELA SILVA DOS SANTOS DE COARACI",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 219579,
                        "codigo": "1374363",
                        "tag": "Todos",
                        "razaoSocial": "SILVANDRO PEREIRA SAMPAIO",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 219661,
                        "codigo": "1722533",
                        "tag": "Todos",
                        "razaoSocial": "EDNEI ARAUJO SANTANA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 219662,
                        "codigo": "1464712",
                        "tag": "Todos",
                        "razaoSocial": "J  C  FERREIRA CONCEICAO LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 221426,
                        "codigo": "1635794",
                        "tag": "Todos",
                        "razaoSocial": "ORLANDO CURSINO RIBEIRO LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 222172,
                        "codigo": "1714316",
                        "tag": "Todos",
                        "razaoSocial": "MPJ RECURSOS EM GERAL LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 222202,
                        "codigo": "1701453",
                        "tag": "Todos",
                        "razaoSocial": "48 075 012 CAIO FARIAS DE SOUZA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 224077,
                        "codigo": "1766303",
                        "tag": "Todos",
                        "razaoSocial": "JMGP MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 224078,
                        "codigo": "1700472",
                        "tag": "Todos",
                        "razaoSocial": "SILVIA CRUZ DE MELO SANTOS LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "0001-01-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 225572,
                        "codigo": "1067251",
                        "tag": "Todos",
                        "razaoSocial": "DILSON DE CERQUEIRA GOMES",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 225577,
                        "codigo": "1067977",
                        "tag": "Todos",
                        "razaoSocial": "ROGERIO SAO BERNARDO SIMOES",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 225584,
                        "codigo": "1069021",
                        "tag": "Todos",
                        "razaoSocial": "JOSE CLAUDIO DE SOUZA DE BONFIM",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 225585,
                        "codigo": "1065791",
                        "tag": "Todos",
                        "razaoSocial": "EDVALDO DE SOUZA GOMES DE SANTO EST",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 225589,
                        "codigo": "1068100",
                        "tag": "Todos",
                        "razaoSocial": "GERVASIO SILVA OLIVEIRA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 225920,
                        "codigo": "1501373",
                        "tag": "Todos",
                        "razaoSocial": "EDILSON PEREIRA PORTELA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 225991,
                        "codigo": "1734364",
                        "tag": "Todos",
                        "razaoSocial": "LEONARDO ARAUJO COSTA & CIA LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 226058,
                        "codigo": "1737159",
                        "tag": "Todos",
                        "razaoSocial": "NILZA SANTOS DA SILVA 05122993580",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 226066,
                        "codigo": "1734338",
                        "tag": "Todos",
                        "razaoSocial": "FERROIACO COMERCIAL LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 226166,
                        "codigo": "1700664",
                        "tag": "Todos",
                        "razaoSocial": "OZENILSON NERES SANTOS",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 226282,
                        "codigo": "1479462",
                        "tag": "Todos",
                        "razaoSocial": "ARNALDO PEREIRA SILVA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 226376,
                        "codigo": "1080806",
                        "tag": "Todos",
                        "razaoSocial": "MARCOS PALMEIRA MATERIAL DE CONSTRU",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 226383,
                        "codigo": "1605447",
                        "tag": "Todos",
                        "razaoSocial": "JUDELSON SILVA QUEIROZ",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 226418,
                        "codigo": "1473487",
                        "tag": "Todos",
                        "razaoSocial": "DERMIVAL BASTOS COSTA 17372131847",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 226422,
                        "codigo": "1413234",
                        "tag": "Todos",
                        "razaoSocial": "ADECIVAL DA CONCEICAO GOMES MENESES",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 226450,
                        "codigo": "1175009",
                        "tag": "Todos",
                        "razaoSocial": "Z  SOUZA DOS SANTOS MATERIAIS DE",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 226533,
                        "codigo": "1505833",
                        "tag": "Todos",
                        "razaoSocial": "ANTONIO ROQUE DA CRUZ FIGUEREDO",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 226545,
                        "codigo": "1314545",
                        "tag": "Todos",
                        "razaoSocial": "VALTECIO DA SILVA SANTO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 226598,
                        "codigo": "1559116",
                        "tag": "Todos",
                        "razaoSocial": "MARCIA OLIVEIRA DUARTE DE SOUZA",
                        "media3Meses": 3,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            }
                        ]
                    },
                    {
                        "id": 226624,
                        "codigo": "1184715",
                        "tag": "Todos",
                        "razaoSocial": "LINO CARNEIRO NETO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 226656,
                        "codigo": "1479018",
                        "tag": "Todos",
                        "razaoSocial": "TAPUIO MATERIAIS DE CONSTRUCAO EIRE",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 227705,
                        "codigo": "1472762",
                        "tag": "Todos",
                        "razaoSocial": "CHAPADA ATACADAO LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 227764,
                        "codigo": "1557032",
                        "tag": "Todos",
                        "razaoSocial": "ELIENE FERREIRA LIMA ALICRIM LTDA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 227783,
                        "codigo": "1592305",
                        "tag": "Todos",
                        "razaoSocial": "ELDO SANTANA SANTOS 05681765539",
                        "media3Meses": 3.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 227788,
                        "codigo": "1521345",
                        "tag": "Todos",
                        "razaoSocial": "W L DE SOUZA MACHADO MATERIAL DE CO",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 227789,
                        "codigo": "1516378",
                        "tag": "Todos",
                        "razaoSocial": "MARIENE DOS SANTOS CONCEICAO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 227791,
                        "codigo": "1497053",
                        "tag": "Todos",
                        "razaoSocial": "REBECCA MARIA NOGUEIRA REIS",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 227793,
                        "codigo": "1446061",
                        "tag": "Todos",
                        "razaoSocial": "VAGNER SANTOS DA ANUNCIACAO 0484562",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 227795,
                        "codigo": "1432370",
                        "tag": "Todos",
                        "razaoSocial": "EDERNOEL SILVA MACHADO",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 227797,
                        "codigo": "1431695",
                        "tag": "Todos",
                        "razaoSocial": "CASA DA CONSTRUCAO MENEZES LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 227805,
                        "codigo": "1558028",
                        "tag": "Todos",
                        "razaoSocial": "CLAUDIO ROBERTO FONTES SANTANA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 227809,
                        "codigo": "1521063",
                        "tag": "Todos",
                        "razaoSocial": "R MOREIRA DE SOUZA MATERIAIS PARA C",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 227813,
                        "codigo": "1461591",
                        "tag": "Todos",
                        "razaoSocial": "JABSON SOUZA DOS SANTOS",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 227816,
                        "codigo": "1359078",
                        "tag": "Todos",
                        "razaoSocial": "JOANA PIRES SAMPAIO",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 227831,
                        "codigo": "1309894",
                        "tag": "Todos",
                        "razaoSocial": "NOVA OPCAO MATERIAIS PARA CONSTRUCA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 227846,
                        "codigo": "1768211",
                        "tag": "Todos",
                        "razaoSocial": "50 449 318 LILIAN DE JESUS SALES",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 227849,
                        "codigo": "1748477",
                        "tag": "Todos",
                        "razaoSocial": "CEZAR MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 227854,
                        "codigo": "1672142",
                        "tag": "Todos",
                        "razaoSocial": "MARCELA OLIVEIRA SILVA DE IBIQUERA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 227855,
                        "codigo": "1759469",
                        "tag": "Todos",
                        "razaoSocial": "LUSTOSA MATERIAIS DE CONSTRUCAO LTD",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 227868,
                        "codigo": "1445934",
                        "tag": "Todos",
                        "razaoSocial": "IVAN BATISTA FREIRES DE UMBURANAS",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 227871,
                        "codigo": "1678094",
                        "tag": "Todos",
                        "razaoSocial": "VALDICE CIRIACO PEDRA BRITO",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 227878,
                        "codigo": "1631085",
                        "tag": "Todos",
                        "razaoSocial": "GUTO COMERCIO MATERIAL DE CONSTRUCA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 227880,
                        "codigo": "1416887",
                        "tag": "Todos",
                        "razaoSocial": "J M ALMEIDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 227888,
                        "codigo": "1373046",
                        "tag": "Todos",
                        "razaoSocial": "LG CENTRAL MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 227889,
                        "codigo": "1343459",
                        "tag": "Todos",
                        "razaoSocial": "RENATO ALMEIDA & CIA LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 227892,
                        "codigo": "1310991",
                        "tag": "Todos",
                        "razaoSocial": "RAMOS E OLIVEIRA COMERCIAL LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 227893,
                        "codigo": "1784024",
                        "tag": "Todos",
                        "razaoSocial": "WESLEI ALVES GONCALVES LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 227908,
                        "codigo": "1609648",
                        "tag": "Todos",
                        "razaoSocial": "JAC MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 227909,
                        "codigo": "1785344",
                        "tag": "Todos",
                        "razaoSocial": "55 254 963 ANANDA ARAUJO DE SOUZA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 227910,
                        "codigo": "1769837",
                        "tag": "Todos",
                        "razaoSocial": "C SOUZA DA SILVA LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 227911,
                        "codigo": "1787054",
                        "tag": "Todos",
                        "razaoSocial": "51 600 638 SHIRLEY FERREIRA DE SOUZ",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 227932,
                        "codigo": "1418497",
                        "tag": "Todos",
                        "razaoSocial": "ALMEIDA TELES JDL LTDA",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 227934,
                        "codigo": "1591889",
                        "tag": "Todos",
                        "razaoSocial": "J A SERRALHERIA DE ALMADINA LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 227943,
                        "codigo": "1762992",
                        "tag": "Todos",
                        "razaoSocial": "SAO FRANCISCO MADEIREIRA LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 229053,
                        "codigo": "1111257",
                        "tag": "Todos",
                        "razaoSocial": "FERNANDO ARAUJO BASTOS",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 229117,
                        "codigo": "1133240",
                        "tag": "Todos",
                        "razaoSocial": "ROBERTO PIMENTEL ALMEIDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 229181,
                        "codigo": "1159381",
                        "tag": "Todos",
                        "razaoSocial": "VANUSIA GOMES DA SILVA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 229258,
                        "codigo": "1254233",
                        "tag": "Todos",
                        "razaoSocial": "JOLENE PISOS E REVESTIMENTOS LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 229259,
                        "codigo": "1245181",
                        "tag": "Todos",
                        "razaoSocial": "BEATRIZ LEITE LEAL PREDILETA LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 234592,
                        "codigo": "1066393",
                        "tag": "Todos",
                        "razaoSocial": "J G FORTES COMERCIO VAREJISTA DE",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 235934,
                        "codigo": "1702646",
                        "tag": "Todos",
                        "razaoSocial": "COR E EMOCAO COMERCIAL DE TINTAS",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 236076,
                        "codigo": "1501920",
                        "tag": "Todos",
                        "razaoSocial": "A  J  PENA MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 237542,
                        "codigo": "1069666",
                        "tag": "Todos",
                        "razaoSocial": "GUSMAC GUSMAO MATERIAL DE CONSTRUCA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 237547,
                        "codigo": "1065640",
                        "tag": "Todos",
                        "razaoSocial": "CASA GARRIDO MATERIAIS DE CONSTRUCA",
                        "media3Meses": 3.3333333333333335,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 237557,
                        "codigo": "1739939",
                        "tag": "Todos",
                        "razaoSocial": "CASA DO CONSTRUTOR MATERIAIS DE",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 237887,
                        "codigo": "1714019",
                        "tag": "Todos",
                        "razaoSocial": "CHICAO COMERCIO DE MATERIAL PARA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 237913,
                        "codigo": "1714240",
                        "tag": "Todos",
                        "razaoSocial": "VANELES DE ASSIS RODRIGUES FERREIRA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 237921,
                        "codigo": "1714355",
                        "tag": "Todos",
                        "razaoSocial": "MIRIAM REIS DA LUZ DOS SANTOS",
                        "media3Meses": 2.6666666666666665,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 238413,
                        "codigo": "1399472",
                        "tag": "Todos",
                        "razaoSocial": "LM COMERCIO DE ALIMENTOS E",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 238417,
                        "codigo": "1750466",
                        "tag": "Todos",
                        "razaoSocial": "50 788 012 JOSEVALDO BARRETO",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 238418,
                        "codigo": "1553782",
                        "tag": "Todos",
                        "razaoSocial": "KASSIO TRINDADE DE OLIVEIRA",
                        "media3Meses": 3.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 238425,
                        "codigo": "1712861",
                        "tag": "Todos",
                        "razaoSocial": "48 424 405 MAILLANE LIMA GOMES DOS",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 238427,
                        "codigo": "1587911",
                        "tag": "Todos",
                        "razaoSocial": "FABIO JULIO DE JESUS MATERIAIS DE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 238455,
                        "codigo": "1586528",
                        "tag": "Todos",
                        "razaoSocial": "JESSICA ALMEIDA MAGALHAES 064628035",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 238472,
                        "codigo": "1480375",
                        "tag": "Todos",
                        "razaoSocial": "LEILA DE SOUZA SANTOS DE LENCOIS",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 238480,
                        "codigo": "1488663",
                        "tag": "Todos",
                        "razaoSocial": "DAP DISTRIBUIDORA DE AVES E PEIXES",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 238490,
                        "codigo": "1521123",
                        "tag": "Todos",
                        "razaoSocial": "GRACILIANO LEONE SARMENTO NETO & CI",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 238491,
                        "codigo": "1492221",
                        "tag": "Todos",
                        "razaoSocial": "LEAL COSTA COMERCIO DE MATERIAIS DE",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 238504,
                        "codigo": "1490226",
                        "tag": "Todos",
                        "razaoSocial": "JAB COMERCIO DE MATERIAIS DE",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 246778,
                        "codigo": "1219887",
                        "tag": "Todos",
                        "razaoSocial": "COM DE MATERIAL DE CONSTRUCAO PINTA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 248477,
                        "codigo": "1261542",
                        "tag": "Todos",
                        "razaoSocial": "05 649 432 NOLAI NAVARRO SILVA DE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 248569,
                        "codigo": "1260363",
                        "tag": "Todos",
                        "razaoSocial": "ORLANDO DOS SANTOS ANDRADE ME",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 248572,
                        "codigo": "1159094",
                        "tag": "Todos",
                        "razaoSocial": "M DE JESUS MESSIAS & CIA LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 248650,
                        "codigo": "1265969",
                        "tag": "Todos",
                        "razaoSocial": "PROVEMAC PRODUTOS VETERINARIOS E",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 248849,
                        "codigo": "1280094",
                        "tag": "Todos",
                        "razaoSocial": "HELDER PAIM GUSMAO",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 249668,
                        "codigo": "1489509",
                        "tag": "Todos",
                        "razaoSocial": "BRITO E SILVA MATERIAIS DE CONSTRUC",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250498,
                        "codigo": "1773287",
                        "tag": "Todos",
                        "razaoSocial": "50 770 539 TIAGO DOS SANTOS BAHIA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250526,
                        "codigo": "1614391",
                        "tag": "Todos",
                        "razaoSocial": "MARIA DA GLORIA DE ARAUJO PAULINO",
                        "media3Meses": 4,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 6
                            }
                        ]
                    },
                    {
                        "id": 250527,
                        "codigo": "1714252",
                        "tag": "Todos",
                        "razaoSocial": "TUDAO MATERIAIS E SERVICOS LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250671,
                        "codigo": "1754524",
                        "tag": "Todos",
                        "razaoSocial": "CONSTRUTUBOS BRUNELLI MATERIAIS DE",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250686,
                        "codigo": "1732846",
                        "tag": "Todos",
                        "razaoSocial": "50 244 008 LAILSON CARVALHO DOS",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250752,
                        "codigo": "1679316",
                        "tag": "Todos",
                        "razaoSocial": "JOSE GOMES DE OLIVEIRA 93844298568",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250827,
                        "codigo": "1789452",
                        "tag": "Todos",
                        "razaoSocial": "FORTES LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250878,
                        "codigo": "1789453",
                        "tag": "Todos",
                        "razaoSocial": "SUPER TINTAS MAIS COMERCIO VAREJIST",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 277820,
                        "codigo": "1458548",
                        "tag": "Todos",
                        "razaoSocial": "GEAN MUNIZ FERREIRA BISPO",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 277834,
                        "codigo": "1402127",
                        "tag": "Todos",
                        "razaoSocial": "23 347 847 JASSIARA NEVES DOS SANTO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 301344,
                        "codigo": "1626886",
                        "tag": "Todos",
                        "razaoSocial": "42645279 PRISCILA OLIVEIRA DE JES",
                        "media3Meses": 2,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 323831,
                        "codigo": "1068685",
                        "tag": "Todos",
                        "razaoSocial": "EDIFER MATERIAIS DE CONSTRUCAO E TR",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 331597,
                        "codigo": "1184065",
                        "tag": "Todos",
                        "razaoSocial": "ELIAN ARAUJO DA SILVA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 331924,
                        "codigo": "1169726",
                        "tag": "Todos",
                        "razaoSocial": "C SANTOS DE SOUZA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 332267,
                        "codigo": "1347021",
                        "tag": "Todos",
                        "razaoSocial": "A A  CARVALHO MASCARENHAS",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 333853,
                        "codigo": "1752156",
                        "tag": "Todos",
                        "razaoSocial": "RAIMUNDO DA HORA DO NASCIMENTO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 333914,
                        "codigo": "1763894",
                        "tag": "Todos",
                        "razaoSocial": "P M COMERCIO DE MATERIAIS DE",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 359684,
                        "codigo": "1816758",
                        "tag": "Todos",
                        "razaoSocial": "TALITA DE O CAVALCANTE LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 360365,
                        "codigo": "1817185",
                        "tag": "Todos",
                        "razaoSocial": "RENAN DA S  P  REBOUCAS",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 419892,
                        "codigo": "1822637",
                        "tag": "Todos",
                        "razaoSocial": "50 452 519 JOSE DA CONCEICAO SANTOS",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 424427,
                        "codigo": "1823510",
                        "tag": "Todos",
                        "razaoSocial": "GALEGO CONSTRUCOES LTDA",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 591986,
                        "codigo": "1736277",
                        "tag": "Todos",
                        "razaoSocial": "ALOISIO SILVA SANTANA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 598226,
                        "codigo": "1751291",
                        "tag": "Todos",
                        "razaoSocial": "FRANCISCO SILVA DOS SANTOS",
                        "media3Meses": 6.666666666666667,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 8
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 10
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 605104,
                        "codigo": "1777547",
                        "tag": "Todos",
                        "razaoSocial": "MATERIAL DE CONSTRUCAO SILLAS LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 639499,
                        "codigo": "1833193",
                        "tag": "Todos",
                        "razaoSocial": "OLIVIERE MATERIAS DE CONSTRUCAO LTD",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 639504,
                        "codigo": "1833208",
                        "tag": "Todos",
                        "razaoSocial": "NOVA CASA MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 640983,
                        "codigo": "1833867",
                        "tag": "Todos",
                        "razaoSocial": "DIGISERV SERVICOS EM GERAL LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 641598,
                        "codigo": "1834130",
                        "tag": "Todos",
                        "razaoSocial": "33 272 293 IZAIAS FRANCISCO DA SILV",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 646799,
                        "codigo": "1836637",
                        "tag": "Todos",
                        "razaoSocial": "57 317 237 MARIA APARECIDA ROSENDO",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 647180,
                        "codigo": "1837031",
                        "tag": "Todos",
                        "razaoSocial": "60 371 774 PRISCILA VITORIA SANTIAG",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 648442,
                        "codigo": "1837668",
                        "tag": "Todos",
                        "razaoSocial": "LS CONTRUCOES LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "SERVIÇOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 658129,
                        "codigo": "1839705",
                        "tag": "Todos",
                        "razaoSocial": "ARLETE LOPES COSTA DE MELO",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 663349,
                        "codigo": "1842821",
                        "tag": "Todos",
                        "razaoSocial": "ERISVANDO SANTOS FREITAS 0568988353",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 663699,
                        "codigo": "1843018",
                        "tag": "Todos",
                        "razaoSocial": "ADENILTON DE JESUS ANDRADE",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 667057,
                        "codigo": "1845271",
                        "tag": "Todos",
                        "razaoSocial": "SUPERMERCADO C D L LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 667113,
                        "codigo": "1845260",
                        "tag": "Todos",
                        "razaoSocial": "BRUNO SANTOS MENEZES",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 667539,
                        "codigo": "1567136",
                        "tag": "Todos",
                        "razaoSocial": "KATIA DE JESUS CRUZ 59797711587",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 670934,
                        "codigo": "1847277",
                        "tag": "Todos",
                        "razaoSocial": "MA FERREIRA MATERIAL DE CONSTRUCAO",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 674559,
                        "codigo": "1850287",
                        "tag": "Todos",
                        "razaoSocial": "58 281 010 ELYSHAMA LIMA BATISTA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 897245,
                        "codigo": "1378705",
                        "tag": "Todos",
                        "razaoSocial": "ELIANE REIS DO ESPIRITO SANTO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1035726,
                        "codigo": "1852237",
                        "tag": "Todos",
                        "razaoSocial": "JPS AUTONOMIA REPRESENTACAO E",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1041167,
                        "codigo": "1855403",
                        "tag": "Todos",
                        "razaoSocial": "F F A DE S BITTENCOURT COMERCIO E",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 1042818,
                        "codigo": "1856281",
                        "tag": "Todos",
                        "razaoSocial": "IEDA BOAVENTURA DE SOUZA LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1051122,
                        "codigo": "1861158",
                        "tag": "Todos",
                        "razaoSocial": "48 788 971 ADILSON DAS VIRGENS JESU",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1055261,
                        "codigo": "1862996",
                        "tag": "Todos",
                        "razaoSocial": "BARRETO MATERIAL DE CONSTRUCAO E",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1057006,
                        "codigo": "1863700",
                        "tag": "Todos",
                        "razaoSocial": "PAMAC ALMADINA MATERIAIS DE",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1069593,
                        "codigo": "1869282",
                        "tag": "Todos",
                        "razaoSocial": "CASARAO MATERIAIS DE CONSTRUCAO LTD",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1070498,
                        "codigo": "1869909",
                        "tag": "Todos",
                        "razaoSocial": "THIAGO SOUZA ALMEIDA CONSTRUTORA",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 1072625,
                        "codigo": "1871265",
                        "tag": "Todos",
                        "razaoSocial": "47 766 089 PEDRO LUIZ DA SILVA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1072761,
                        "codigo": "1871375",
                        "tag": "Todos",
                        "razaoSocial": "VANIA LUIZA SANTOS GONCALVES SILVA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1075762,
                        "codigo": "1873416",
                        "tag": "Todos",
                        "razaoSocial": "23 116 123 ANTONIO ASSIS DE JESUS",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1076241,
                        "codigo": "1873769",
                        "tag": "Todos",
                        "razaoSocial": "RIACHINHO MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1076684,
                        "codigo": "1874065",
                        "tag": "Todos",
                        "razaoSocial": "MANOEL JOSE CARDOSO",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 1076686,
                        "codigo": "1874070",
                        "tag": "Todos",
                        "razaoSocial": "KLEYHANE LEITE DAMACENO ROCHA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1078923,
                        "codigo": "1875577",
                        "tag": "Todos",
                        "razaoSocial": "ROSINALDO D DA SILVA ELETROCON LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1079501,
                        "codigo": "1876011",
                        "tag": "Todos",
                        "razaoSocial": "PINGO DE OURO DISTRIBUIDORA LTDA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 1079520,
                        "codigo": "1876025",
                        "tag": "Todos",
                        "razaoSocial": "62.072.794 LUCINEIDE SANTOS DE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1079562,
                        "codigo": "1876057",
                        "tag": "Todos",
                        "razaoSocial": "MCF DISTRIBUIDORA DE FERRO E CIMENT",
                        "media3Meses": 3,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 9
                            }
                        ]
                    },
                    {
                        "id": 1081422,
                        "codigo": "1877283",
                        "tag": "Todos",
                        "razaoSocial": "24 653 360 JOSEVALDO JESUS DA SILVA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1081429,
                        "codigo": "1877284",
                        "tag": "Todos",
                        "razaoSocial": "58 243 490 VANUSA PACHECO LIMA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "SERVIÇOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1081580,
                        "codigo": "1877397",
                        "tag": "Todos",
                        "razaoSocial": "53.691.995 ANTONIO JORGE ALMEIDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1081598,
                        "codigo": "1877404",
                        "tag": "Todos",
                        "razaoSocial": "24.955.483 ALEX SANDRO DE JESUS",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1082822,
                        "codigo": "1878296",
                        "tag": "Todos",
                        "razaoSocial": "R J M COMERCIO VAREJISTA DE MATERIA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1084889,
                        "codigo": "1879533",
                        "tag": "Todos",
                        "razaoSocial": "55.260.755 KEVIN DIAS DE CARVALHO",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1085599,
                        "codigo": "1880124",
                        "tag": "Todos",
                        "razaoSocial": "60.694.878 UILSON MARTINS DA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1085634,
                        "codigo": "1880173",
                        "tag": "Todos",
                        "razaoSocial": "61.495.643 JURACI LEAL OLIVEIRA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1085635,
                        "codigo": "1880182",
                        "tag": "Todos",
                        "razaoSocial": "55.561.348 JOSE MAIA SANTOS",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1085658,
                        "codigo": "1880189",
                        "tag": "Todos",
                        "razaoSocial": "EMERSON ALVES DE JESUS 51222973553",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1086758,
                        "codigo": "1880803",
                        "tag": "Todos",
                        "razaoSocial": "INOVACIVIL MATERIAIS ESPECIALIZADOS",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1087413,
                        "codigo": "1881460",
                        "tag": "Todos",
                        "razaoSocial": "60 497 800 MARTA SANTOS NASCIMENTO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1087420,
                        "codigo": "1881445",
                        "tag": "Todos",
                        "razaoSocial": "FLAGLEEZ ENERGIA FOTOVOLTAICO LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1088032,
                        "codigo": "1881936",
                        "tag": "Todos",
                        "razaoSocial": "49 269 712 MARCELO RIBEIRO DIAS",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 1088034,
                        "codigo": "1881923",
                        "tag": "Todos",
                        "razaoSocial": "RAFFI EDUARDO ANDRADE ALVES",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1088446,
                        "codigo": "1882165",
                        "tag": "Todos",
                        "razaoSocial": "IAN ANDRADE PROJETOS E CONSTRUCOES",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1088453,
                        "codigo": "1882200",
                        "tag": "Todos",
                        "razaoSocial": "54 834 019 MAILSON DOS SANTOS SOUSA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1088467,
                        "codigo": "1882222",
                        "tag": "Todos",
                        "razaoSocial": "BS PORTELA LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1088721,
                        "codigo": "1882361",
                        "tag": "Todos",
                        "razaoSocial": "59 400 477 JOSEVANDO BASTOS DOS",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1088755,
                        "codigo": "1882398",
                        "tag": "Todos",
                        "razaoSocial": "62 500 093 JONAS LOBO SILVEIRA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1090261,
                        "codigo": "1883472",
                        "tag": "Todos",
                        "razaoSocial": "58 510 532 ALAN SOUZA MOREIRA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1090877,
                        "codigo": "1883922",
                        "tag": "Todos",
                        "razaoSocial": "61 904 258 ROBERTO SOUZA BITTENCOUR",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1090903,
                        "codigo": "1883929",
                        "tag": "Todos",
                        "razaoSocial": "UBIRANEY CORDEIRO DA SILVA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1093460,
                        "codigo": "1885183",
                        "tag": "Todos",
                        "razaoSocial": "VIVAOBRA MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 3,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 1093478,
                        "codigo": "1885203",
                        "tag": "Todos",
                        "razaoSocial": "57 197 427 PAULO SERGIO LEITE ROCHA",
                        "media3Meses": 2.6666666666666665,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 1093497,
                        "codigo": "1885222",
                        "tag": "Todos",
                        "razaoSocial": "BEM LUZ COMERCIO DE MATERIAIS",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1093513,
                        "codigo": "1885237",
                        "tag": "Todos",
                        "razaoSocial": "60 520 918 DAYANA MARTA BUENO",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1101867,
                        "codigo": "1887023",
                        "tag": "Todos",
                        "razaoSocial": "EDIANA MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 1108126,
                        "codigo": "1888826",
                        "tag": "Todos",
                        "razaoSocial": "58 151 446 VANILDA SANTOS FERREIRA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1114617,
                        "codigo": "1883389",
                        "tag": "Todos",
                        "razaoSocial": "MPS MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 0,
                        "codigo": "CreatedAt",
                        "createdAt": "2026-07-08T09:10:08.8055648"
                    }
                ]
            },
            {
                "id": 587,
                "codigoVendedor": "00230368",
                "nomeVendedor": "LEANDRO MARTINS PEREIRA",
                "basesAutosservico": [
                    {
                        "id": -1,
                        "tag": "Card-Rota",
                        "card": {
                            "totalPedidos": 0,
                            "percentTotalPedidos": 1,
                            "percentPedidosWebCliente": 0,
                            "mixPedidosWebCliente": 0,
                            "percentPedidosWebVendedor": 0,
                            "mixPedidosWebVendedor": 0,
                            "percentOutros": 0,
                            "mixOutros": 0
                        }
                    },
                    {
                        "id": -2,
                        "tag": "Card-Todos",
                        "card": {
                            "totalPedidos": 126,
                            "percentTotalPedidos": -1,
                            "percentPedidosWebCliente": 0.746031746031746,
                            "mixPedidosWebCliente": 3.581818181818182,
                            "percentPedidosWebVendedor": 0.07936507936507936,
                            "mixPedidosWebVendedor": 3.8,
                            "percentOutros": 0.1746031746031746,
                            "mixOutros": 2.473684210526316
                        }
                    },
                    {
                        "id": 3713,
                        "codigo": "1059131",
                        "tag": "Todos",
                        "razaoSocial": "DIONE LUCIO PEREIRA LTDA",
                        "media3Meses": 11,
                        "pedidosMesAtual": 9,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 9
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 14
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 9
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 4260,
                        "codigo": "1049599",
                        "tag": "Todos",
                        "razaoSocial": "PAULO CESAR PEREIRA",
                        "media3Meses": 4,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 5423,
                        "codigo": "1057032",
                        "tag": "Todos",
                        "razaoSocial": "CASTELO BRANCO MATERIAIS DE",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 10688,
                        "codigo": "1738795",
                        "tag": "Todos",
                        "razaoSocial": "JV DISTRIBUIDORA DE MATERIAIS PARA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 13186,
                        "codigo": "1041640",
                        "tag": "Todos",
                        "razaoSocial": "SINVAL JOSE DOS SANTOS & CIA LTDA",
                        "media3Meses": 3,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 17833,
                        "codigo": "1456721",
                        "tag": "Todos",
                        "razaoSocial": "CASA FORTE MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 18898,
                        "codigo": "1062837",
                        "tag": "Todos",
                        "razaoSocial": "SHOP DO CONSTRUTOR FERRAGISTA LTDA",
                        "media3Meses": 2.6666666666666665,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0.5,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0.5,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 19924,
                        "codigo": "1491935",
                        "tag": "Todos",
                        "razaoSocial": "D  L    MATERIAIS DE CONSTRUCAO LTD",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 21055,
                        "codigo": "1058670",
                        "tag": "Todos",
                        "razaoSocial": "RHOUSE CLAIR CHAVES MENDANHA MOREIR",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 21252,
                        "codigo": "1360916",
                        "tag": "Todos",
                        "razaoSocial": "J C V P AMARAL",
                        "media3Meses": 4,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0.5,
                        "percentOutros": 0.5,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 26310,
                        "codigo": "1284273",
                        "tag": "Todos",
                        "razaoSocial": "CONSTRUARTE MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 3,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 26941,
                        "codigo": "1222263",
                        "tag": "Todos",
                        "razaoSocial": "H R RIBEIRO & CIA LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 30003,
                        "codigo": "1429734",
                        "tag": "Todos",
                        "razaoSocial": "G F  NETO E CIA LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 41387,
                        "codigo": "1742390",
                        "tag": "Todos",
                        "razaoSocial": "FERRAGISTA LOPES LTDA",
                        "media3Meses": 3.3333333333333335,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 41589,
                        "codigo": "1049779",
                        "tag": "Todos",
                        "razaoSocial": "CASA DO CONSTRUTOR MATERIAIS DE CON",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 66796,
                        "codigo": "1813879",
                        "tag": "Todos",
                        "razaoSocial": "AURA MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67196,
                        "codigo": "1744529",
                        "tag": "Todos",
                        "razaoSocial": "53 059 996 VALDIVINO GOMES",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67197,
                        "codigo": "1766020",
                        "tag": "Todos",
                        "razaoSocial": "54.296.098 GRACINETE DE OLIVEIRA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67200,
                        "codigo": "1523456",
                        "tag": "Todos",
                        "razaoSocial": "AQUINO EMPREENDIMENTOS IMOBILIARIOS",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67201,
                        "codigo": "1492364",
                        "tag": "Todos",
                        "razaoSocial": "WAGNER ARAUJO MOTA",
                        "media3Meses": 3.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67202,
                        "codigo": "1724982",
                        "tag": "Todos",
                        "razaoSocial": "FOX MATERIAIS PARA CONSTRUCAO LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 67203,
                        "codigo": "1683124",
                        "tag": "Todos",
                        "razaoSocial": "SOMA CASA E CONSTRUCAO LTDA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67204,
                        "codigo": "1480402",
                        "tag": "Todos",
                        "razaoSocial": "ILAMM HOUSE EMPREENDIMENTOS LTDA.",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 67205,
                        "codigo": "1049834",
                        "tag": "Todos",
                        "razaoSocial": "J MAGNO MATERIAIS DE CONSTRUCAO LTD",
                        "media3Meses": 4.333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67206,
                        "codigo": "1033206",
                        "tag": "Todos",
                        "razaoSocial": "FERRAGISTA ITAPURANGA LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67207,
                        "codigo": "1282413",
                        "tag": "Todos",
                        "razaoSocial": "JOAO LOPES DOS SANTOS",
                        "media3Meses": 4.333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67208,
                        "codigo": "1432583",
                        "tag": "Todos",
                        "razaoSocial": "MERCADAO DAS TINTAS DE GOIANESIA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67209,
                        "codigo": "1645455",
                        "tag": "Todos",
                        "razaoSocial": "TOP DISTRIBUIDORA DE CIMENTO LTDA",
                        "media3Meses": 6.333333333333333,
                        "pedidosMesAtual": 3,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 8
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 8
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 67210,
                        "codigo": "1064835",
                        "tag": "Todos",
                        "razaoSocial": "R G MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 3.6666666666666665,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 67211,
                        "codigo": "1647973",
                        "tag": "Todos",
                        "razaoSocial": "PX MATERIAS DE CONSTRUCAO LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 67212,
                        "codigo": "1457820",
                        "tag": "Todos",
                        "razaoSocial": "IMPERIO DA CONSTRUCAO JARAGUA LTDA",
                        "media3Meses": 12.666666666666666,
                        "pedidosMesAtual": 4,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 11
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 12
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 13
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 15
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 18
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 4
                            }
                        ]
                    },
                    {
                        "id": 67214,
                        "codigo": "1525944",
                        "tag": "Todos",
                        "razaoSocial": "IVANI A  CARDOSO CAVALCANTE",
                        "media3Meses": 2,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 67216,
                        "codigo": "1056772",
                        "tag": "Todos",
                        "razaoSocial": "COMERCIAL CONSTRUANA LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67217,
                        "codigo": "1055594",
                        "tag": "Todos",
                        "razaoSocial": "PAOLI MATERIAIS PARA CONSTRUCAO LTD",
                        "media3Meses": 4.333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67219,
                        "codigo": "1097359",
                        "tag": "Todos",
                        "razaoSocial": "GONZAGA ARANTES & SILVA LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67220,
                        "codigo": "1296625",
                        "tag": "Todos",
                        "razaoSocial": "JUSTINO FERREIRA DA SILVA & CIA LTD",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67221,
                        "codigo": "1048577",
                        "tag": "Todos",
                        "razaoSocial": "EDVALDO GOMES DE ALMEIDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67222,
                        "codigo": "1080316",
                        "tag": "Todos",
                        "razaoSocial": "PEDRO MARTINS DE MORAES",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67223,
                        "codigo": "1383677",
                        "tag": "Todos",
                        "razaoSocial": "RICHARDES CESAR DOS SANTOS LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67224,
                        "codigo": "1458438",
                        "tag": "Todos",
                        "razaoSocial": "JULIANA CARLA DOS SANTOS LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67225,
                        "codigo": "1401428",
                        "tag": "Todos",
                        "razaoSocial": "MARCINARIA E CARPINTARIA SERRA",
                        "media3Meses": 3.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67226,
                        "codigo": "1059031",
                        "tag": "Todos",
                        "razaoSocial": "MATERIAIS DE CONSTRUCAO ARAUJO LTDA",
                        "media3Meses": 3.3333333333333335,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 67227,
                        "codigo": "1050473",
                        "tag": "Todos",
                        "razaoSocial": "SAO CAETANO MATERIAIS PARA",
                        "media3Meses": 3,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 5
                            }
                        ]
                    },
                    {
                        "id": 67228,
                        "codigo": "1049777",
                        "tag": "Todos",
                        "razaoSocial": "OTACILMAR E. DE MORAIS LTDA",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 67229,
                        "codigo": "1657162",
                        "tag": "Todos",
                        "razaoSocial": "LUCIANA CAMARGO DA COSTA ALVES",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67230,
                        "codigo": "1049731",
                        "tag": "Todos",
                        "razaoSocial": "EDIMAR RAMALHO DOS SANTOS",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67231,
                        "codigo": "1049719",
                        "tag": "Todos",
                        "razaoSocial": "JOSE ANTONIO FILHO LIMITADA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 67232,
                        "codigo": "1049688",
                        "tag": "Todos",
                        "razaoSocial": "JM MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67233,
                        "codigo": "1210966",
                        "tag": "Todos",
                        "razaoSocial": "CONSTRUTORA CONSTRUMAIS LTDA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 67235,
                        "codigo": "1205560",
                        "tag": "Todos",
                        "razaoSocial": "DICASA FERRAGISTA E MATERIAL DE",
                        "media3Meses": 3,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67236,
                        "codigo": "1049832",
                        "tag": "Todos",
                        "razaoSocial": "LM   MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 2,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67237,
                        "codigo": "1622794",
                        "tag": "Todos",
                        "razaoSocial": "JW COMERCIO DE CIMENTO E ACO LTDA",
                        "media3Meses": 19.333333333333332,
                        "pedidosMesAtual": 4,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 16
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 8
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 19
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 18
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 21
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 6
                            }
                        ]
                    },
                    {
                        "id": 67240,
                        "codigo": "1156932",
                        "tag": "Todos",
                        "razaoSocial": "CONSTRUITA MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67241,
                        "codigo": "1309008",
                        "tag": "Todos",
                        "razaoSocial": "CLEUNICE MARIA DE SOUZA VITORINO",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67242,
                        "codigo": "1302160",
                        "tag": "Todos",
                        "razaoSocial": "GABRIEL VILELA MATERIAIS PARA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 67243,
                        "codigo": "1296984",
                        "tag": "Todos",
                        "razaoSocial": "FARIA MATERIAIS PARA CONSTRUCAO LTD",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 67245,
                        "codigo": "1290648",
                        "tag": "Todos",
                        "razaoSocial": "D  A  MATERIAIS PARA CONSTRUCAO",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            }
                        ]
                    },
                    {
                        "id": 67246,
                        "codigo": "1227342",
                        "tag": "Todos",
                        "razaoSocial": "M P A MATERIAIS PARA CONSTRUCAO EIR",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67247,
                        "codigo": "1366980",
                        "tag": "Todos",
                        "razaoSocial": "CENTER CASA DISTRIBUIDORA E",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67248,
                        "codigo": "1050467",
                        "tag": "Todos",
                        "razaoSocial": "QUEIROZ CARDOSO MATERIAIS PARA",
                        "media3Meses": 14,
                        "pedidosMesAtual": 4,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 10
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 12
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 10
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 15
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 17
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 67249,
                        "codigo": "1644387",
                        "tag": "Todos",
                        "razaoSocial": "CENTRAL MATERIAIS DE CONSTRUCAO LTD",
                        "media3Meses": 3.6666666666666665,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 67250,
                        "codigo": "1535710",
                        "tag": "Todos",
                        "razaoSocial": "JAMES FERNANDES FARINHA 96126680197",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67251,
                        "codigo": "1543230",
                        "tag": "Todos",
                        "razaoSocial": "SANITAO MATERIAIS DE CONSTRUCAO E",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67253,
                        "codigo": "1725247",
                        "tag": "Todos",
                        "razaoSocial": "TSR MATERIAIS PARA CONSTRUCAO LTDA",
                        "media3Meses": 4,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67255,
                        "codigo": "1659695",
                        "tag": "Todos",
                        "razaoSocial": "PEIXOTO CONSTRUTORA LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67256,
                        "codigo": "1542624",
                        "tag": "Todos",
                        "razaoSocial": "FLAMMARION GONCALVES DO NASCIMENTO",
                        "media3Meses": 3.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67259,
                        "codigo": "1221774",
                        "tag": "Todos",
                        "razaoSocial": "O M FERREIRA",
                        "media3Meses": 2,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67260,
                        "codigo": "1158021",
                        "tag": "Todos",
                        "razaoSocial": "SOUZA FILHO MATERIAL PARA CONSTRUCA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 67262,
                        "codigo": "1780270",
                        "tag": "Todos",
                        "razaoSocial": "ELIANE PEREIRA ARAUJO FERNANDES",
                        "media3Meses": 4.666666666666667,
                        "pedidosMesAtual": 3,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 10
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 67264,
                        "codigo": "1050706",
                        "tag": "Todos",
                        "razaoSocial": "M W S MADEIRA E MATERIAIS PARA",
                        "media3Meses": 16.666666666666668,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 9
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 35
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 12
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67265,
                        "codigo": "1056740",
                        "tag": "Todos",
                        "razaoSocial": "JRP MADEIRAS LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 67266,
                        "codigo": "1050617",
                        "tag": "Todos",
                        "razaoSocial": "JOAO DA SILVA RUIZ",
                        "media3Meses": 2.6666666666666665,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            }
                        ]
                    },
                    {
                        "id": 67267,
                        "codigo": "1055469",
                        "tag": "Todos",
                        "razaoSocial": "MADEIRANA MADEIREIRA URUANA LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67268,
                        "codigo": "1058674",
                        "tag": "Todos",
                        "razaoSocial": "JM   ENGENHARIA & CIA LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67269,
                        "codigo": "1060728",
                        "tag": "Todos",
                        "razaoSocial": "JOSE VIRGILIO DA SILVA O MINEIRO",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67270,
                        "codigo": "1058754",
                        "tag": "Todos",
                        "razaoSocial": "MAIA MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 67271,
                        "codigo": "1051626",
                        "tag": "Todos",
                        "razaoSocial": "PAULA E PEIXOTO LTDA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67272,
                        "codigo": "1056865",
                        "tag": "Todos",
                        "razaoSocial": "MACOSFAL MATERIAL DE CONSTRUCAO SAO",
                        "media3Meses": 3,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67273,
                        "codigo": "1049597",
                        "tag": "Todos",
                        "razaoSocial": "JOAQUIM ALVES FERREIRA O GOIANO",
                        "media3Meses": 2.6666666666666665,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 67274,
                        "codigo": "1465466",
                        "tag": "Todos",
                        "razaoSocial": "DEPOSITO DE MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 3,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67275,
                        "codigo": "1740726",
                        "tag": "Todos",
                        "razaoSocial": "LUI CASA E CONSTRUCAO LTDA",
                        "media3Meses": 3.6666666666666665,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 67279,
                        "codigo": "1300852",
                        "tag": "Todos",
                        "razaoSocial": "SOUTO E SANTOS LTDA",
                        "media3Meses": 9.333333333333334,
                        "pedidosMesAtual": 4,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 9
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 8
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 9
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 11
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 10
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67280,
                        "codigo": "1493045",
                        "tag": "Todos",
                        "razaoSocial": "RONIVALDO PEREIRA ALVES & CIA LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0.5,
                        "percentOutros": 0.5,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67281,
                        "codigo": "1492737",
                        "tag": "Todos",
                        "razaoSocial": "FUTURO COMERCIO DE MATERIAIS DE",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67282,
                        "codigo": "1078777",
                        "tag": "Todos",
                        "razaoSocial": "MAJOFER MATERIAIS DE CONSTRUCAO LTD",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 67283,
                        "codigo": "1562145",
                        "tag": "Todos",
                        "razaoSocial": "ENCASA UTILIDADES E DECORACAO LTDA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67284,
                        "codigo": "1373702",
                        "tag": "Todos",
                        "razaoSocial": "MARIA SIMONICA SCAPATICHI RUIZ",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67285,
                        "codigo": "1647449",
                        "tag": "Todos",
                        "razaoSocial": "CLEONICE SOARES DA SILVA 0060386215",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0.5,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0.5,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67286,
                        "codigo": "1338066",
                        "tag": "Todos",
                        "razaoSocial": "MARCOS H DIAS & CIA LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 67287,
                        "codigo": "1559923",
                        "tag": "Todos",
                        "razaoSocial": "CASA DA CONSTRUCAO ARAUJO LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67288,
                        "codigo": "1545817",
                        "tag": "Todos",
                        "razaoSocial": "CIMACO MATERIAIS PARA CONSTRUCAO",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67290,
                        "codigo": "1597765",
                        "tag": "Todos",
                        "razaoSocial": "PROMISSAO MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67291,
                        "codigo": "1658122",
                        "tag": "Todos",
                        "razaoSocial": "DJ CONSTRUTORA E INCORPORADORA E",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67293,
                        "codigo": "1644416",
                        "tag": "Todos",
                        "razaoSocial": "TENDTUDO CANAA LTDA",
                        "media3Meses": 4.333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 8
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67294,
                        "codigo": "1644324",
                        "tag": "Todos",
                        "razaoSocial": "LEANDRO ARAUJO DOS REIS LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67295,
                        "codigo": "1643893",
                        "tag": "Todos",
                        "razaoSocial": "AMARAL MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 2.6666666666666665,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 67296,
                        "codigo": "1642154",
                        "tag": "Todos",
                        "razaoSocial": "CASARAO MATERIAIS ELETRICOS E",
                        "media3Meses": 5,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 17
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67300,
                        "codigo": "1672919",
                        "tag": "Todos",
                        "razaoSocial": "MC MATERIAIS PARA CONSTRUCAO LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67301,
                        "codigo": "1718704",
                        "tag": "Todos",
                        "razaoSocial": "MJ MADEIRAS LTDA",
                        "media3Meses": 3.6666666666666665,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 67302,
                        "codigo": "1707109",
                        "tag": "Todos",
                        "razaoSocial": "MAIS CIMENTO LTDA",
                        "media3Meses": 6.333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 10
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 11
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 67304,
                        "codigo": "1741781",
                        "tag": "Todos",
                        "razaoSocial": "DEPOSITO DE MATERIAL DE CONSTRUCAO",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67305,
                        "codigo": "1626889",
                        "tag": "Todos",
                        "razaoSocial": "ELZA DOS SANTOS GOULART LTDA",
                        "media3Meses": 2.6666666666666665,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 67306,
                        "codigo": "1282151",
                        "tag": "Todos",
                        "razaoSocial": "CLG MATERIAIS PARA CONSTRUCAO LTDA",
                        "media3Meses": 7.333333333333333,
                        "pedidosMesAtual": 3,
                        "percentPedidosWebCliente": 0.6666666666666666,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0.3333333333333333,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 10
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 9
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 8
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 10
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 8
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 67307,
                        "codigo": "1356507",
                        "tag": "Todos",
                        "razaoSocial": "GVD MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67309,
                        "codigo": "1625316",
                        "tag": "Todos",
                        "razaoSocial": "P L S LIMA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67310,
                        "codigo": "1735537",
                        "tag": "Todos",
                        "razaoSocial": "HILDA DA SILVA GUERREIRO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67311,
                        "codigo": "1433304",
                        "tag": "Todos",
                        "razaoSocial": "CASA AGROPECUARIA E CONSTRUTORA JN",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67312,
                        "codigo": "1489439",
                        "tag": "Todos",
                        "razaoSocial": "PRODUTOS AGROPECUARIOS CAPOEIRAO LT",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67313,
                        "codigo": "1726175",
                        "tag": "Todos",
                        "razaoSocial": "V. L. M. DOS PASSOS ALMEIDA LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 67314,
                        "codigo": "1546009",
                        "tag": "Todos",
                        "razaoSocial": "SOMA MATERIAIS PARA CONSTRUCAO LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67316,
                        "codigo": "1620966",
                        "tag": "Todos",
                        "razaoSocial": "SAO PEDRO MATERIAIS PARA CONSTRUCAO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67317,
                        "codigo": "1659466",
                        "tag": "Todos",
                        "razaoSocial": "J  P  S  COELHO ENGENHARIA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67319,
                        "codigo": "1673929",
                        "tag": "Todos",
                        "razaoSocial": "JOAO VITOR SILVA ALVES 00750356189",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67321,
                        "codigo": "1243030",
                        "tag": "Todos",
                        "razaoSocial": "JOSE LUCIMAR DE MENEZES E CIA LTDA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 67322,
                        "codigo": "1300845",
                        "tag": "Todos",
                        "razaoSocial": "C  L  R  DE OLIVEIRA LTDA",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67323,
                        "codigo": "1211040",
                        "tag": "Todos",
                        "razaoSocial": "M  DE F  MENEZES E SILVA & CIA LTDA",
                        "media3Meses": 3.6666666666666665,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            }
                        ]
                    },
                    {
                        "id": 67324,
                        "codigo": "1442541",
                        "tag": "Todos",
                        "razaoSocial": "ENCASA MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67325,
                        "codigo": "1223977",
                        "tag": "Todos",
                        "razaoSocial": "E. S. MATERIAIS PARA CONSTRUCOES",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 67326,
                        "codigo": "1049737",
                        "tag": "Todos",
                        "razaoSocial": "COMERCIAL FREITAS MATERIAIS PARA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 67327,
                        "codigo": "1060621",
                        "tag": "Todos",
                        "razaoSocial": "COMERCIO DE MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 3,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 5
                            }
                        ]
                    },
                    {
                        "id": 67328,
                        "codigo": "1196492",
                        "tag": "Todos",
                        "razaoSocial": "MOURA E PEREIRA MATERIAIS PARA",
                        "media3Meses": 3.3333333333333335,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67329,
                        "codigo": "1222298",
                        "tag": "Todos",
                        "razaoSocial": "COMERCIAL URUANA DE MATERIAIS PARA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67330,
                        "codigo": "1063250",
                        "tag": "Todos",
                        "razaoSocial": "CLAUDIO MARCIO MARQUES SEVERINO &",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67333,
                        "codigo": "1316276",
                        "tag": "Todos",
                        "razaoSocial": "MATUSKELLA COMERCIO IMPORTACAO",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67334,
                        "codigo": "1674282",
                        "tag": "Todos",
                        "razaoSocial": "EDSON DONIZETT DE OLIVEIRA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67337,
                        "codigo": "1693129",
                        "tag": "Todos",
                        "razaoSocial": "QUEIROZ CARDOSO MATERIAIS PARA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67340,
                        "codigo": "1671738",
                        "tag": "Todos",
                        "razaoSocial": "G SILVA MATERIAL PARA CONSTRUCAO",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67341,
                        "codigo": "1058272",
                        "tag": "Todos",
                        "razaoSocial": "MATERIAL PARA CONSTRUCAO JARAGUA",
                        "media3Meses": 5.333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 67342,
                        "codigo": "1059023",
                        "tag": "Todos",
                        "razaoSocial": "M W S MADEIRA E MATERIAIS PARA",
                        "media3Meses": 6.333333333333333,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 13
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 67343,
                        "codigo": "1059224",
                        "tag": "Todos",
                        "razaoSocial": "COMATEL   COMERCIO DE MATERIAIS PAR",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 67344,
                        "codigo": "1049602",
                        "tag": "Todos",
                        "razaoSocial": "M W S MADEIRA E MATERIAIS PARA",
                        "media3Meses": 8.333333333333334,
                        "pedidosMesAtual": 4,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 18
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 9
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 12
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67345,
                        "codigo": "1423945",
                        "tag": "Todos",
                        "razaoSocial": "BRUNO RODRIGUES GOMES",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67346,
                        "codigo": "1736636",
                        "tag": "Todos",
                        "razaoSocial": "M W S MADEIRA E MATERIAIS PARA",
                        "media3Meses": 3.3333333333333335,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 13
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 23
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 8
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67347,
                        "codigo": "1626011",
                        "tag": "Todos",
                        "razaoSocial": "PORTAL DO SOL MATERIAIS DE",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67348,
                        "codigo": "1290184",
                        "tag": "Todos",
                        "razaoSocial": "VIVENDA MATERIAIS PARA CONSTRUCAO",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67349,
                        "codigo": "1481385",
                        "tag": "Todos",
                        "razaoSocial": "TELHAS E TIJOLOS GOMES MATERIAIS",
                        "media3Meses": 3.6666666666666665,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67350,
                        "codigo": "1512746",
                        "tag": "Todos",
                        "razaoSocial": "ANDREIA CORDEIRO DE SOUZA MOTA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67351,
                        "codigo": "1424895",
                        "tag": "Todos",
                        "razaoSocial": "RATINHO MATERIAIS PARA CONSTRUCAO",
                        "media3Meses": 9,
                        "pedidosMesAtual": 3,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 11
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 12
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 12
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 11
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 12
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 67352,
                        "codigo": "1701927",
                        "tag": "Todos",
                        "razaoSocial": "50 323 820 MARCOS IURY SOARES DE",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67353,
                        "codigo": "1587435",
                        "tag": "Todos",
                        "razaoSocial": "CM   CERRADO MATERIAIS DE CONSTRUCA",
                        "media3Meses": 3,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67355,
                        "codigo": "1693114",
                        "tag": "Todos",
                        "razaoSocial": "QUEIROZ CARDOSO MATERIAIS PARA",
                        "media3Meses": 5,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67356,
                        "codigo": "1562309",
                        "tag": "Todos",
                        "razaoSocial": "ENCASA FAINA MATERIAIS DE CONSTRUCA",
                        "media3Meses": 3,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 5
                            }
                        ]
                    },
                    {
                        "id": 67357,
                        "codigo": "1271433",
                        "tag": "Todos",
                        "razaoSocial": "FERNANDO RIBEIRO DA SILVA MATERIAIS",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67358,
                        "codigo": "1228396",
                        "tag": "Todos",
                        "razaoSocial": "MOREIRA CAMARGO MATERIAIS PARA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67359,
                        "codigo": "1119946",
                        "tag": "Todos",
                        "razaoSocial": "M W S MADEIRA E MATERIAIS PARA",
                        "media3Meses": 9.666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 9
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 15
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 17
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 11
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67360,
                        "codigo": "1418888",
                        "tag": "Todos",
                        "razaoSocial": "M W S MADEIRA E MATERIAIS PARA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CONTRATO",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67361,
                        "codigo": "1323023",
                        "tag": "Todos",
                        "razaoSocial": "FERRAZ MATERIAIS PARA CONSTRUCAO",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67362,
                        "codigo": "1260590",
                        "tag": "Todos",
                        "razaoSocial": "MC MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67363,
                        "codigo": "1264197",
                        "tag": "Todos",
                        "razaoSocial": "A J  DA SILVA COM  DE MAT  PARA",
                        "media3Meses": 7.333333333333333,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0.5,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0.5,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 8
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 9
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67364,
                        "codigo": "1228657",
                        "tag": "Todos",
                        "razaoSocial": "VALDEMAR JOSE DAS CHAGAS LTDA",
                        "media3Meses": 2,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 67365,
                        "codigo": "1112100",
                        "tag": "Todos",
                        "razaoSocial": "ITAPUA COM DE PROD ALIM E MAT DE",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 111621,
                        "codigo": "1814289",
                        "tag": "Todos",
                        "razaoSocial": "BETSAIDA MATERIAIS PARA CONSTRUCAO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 114552,
                        "codigo": "1774092",
                        "tag": "Todos",
                        "razaoSocial": "CONSTRULAR ATACADISTA DE MATERIAIS",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 115498,
                        "codigo": "1762504",
                        "tag": "Todos",
                        "razaoSocial": "P R A MATERIAIS PARA CONSTRUCAO LTD",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 122289,
                        "codigo": "1723814",
                        "tag": "Todos",
                        "razaoSocial": "27 416 741 VANESSA GUIMARAES DE",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 178980,
                        "codigo": "1522844",
                        "tag": "Todos",
                        "razaoSocial": "SOMA CONSTRUTORA LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 357654,
                        "codigo": "1795769",
                        "tag": "Todos",
                        "razaoSocial": "35 973 477 MAXWEL JONAS LOPES SANTO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 358033,
                        "codigo": "1815840",
                        "tag": "Todos",
                        "razaoSocial": "L F DE OLIVEIRA CONSTRUTORA",
                        "media3Meses": 3.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 394511,
                        "codigo": "1479243",
                        "tag": "Todos",
                        "razaoSocial": "PAIVA MATERIAIS DE CONSTRUCAO   EIR",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 446017,
                        "codigo": "1825803",
                        "tag": "Todos",
                        "razaoSocial": "CASARAO MATERIAIS PARA CONSTRUCAO",
                        "media3Meses": 3.3333333333333335,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            }
                        ]
                    },
                    {
                        "id": 466021,
                        "codigo": "1827473",
                        "tag": "Todos",
                        "razaoSocial": "N J G RIBEIRO",
                        "media3Meses": 3.6666666666666665,
                        "pedidosMesAtual": 3,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 471055,
                        "codigo": "1828287",
                        "tag": "Todos",
                        "razaoSocial": "SOL A SOL DISTRIBUIDORA DE MATERIAL",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 474665,
                        "codigo": "1829167",
                        "tag": "Todos",
                        "razaoSocial": "REAL MATERIAIS DE CONTRUCAO LTDA",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 588803,
                        "codigo": "1830390",
                        "tag": "Todos",
                        "razaoSocial": "LPS VAREJO E ATACADO DE PISOS E",
                        "media3Meses": 3,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 601489,
                        "codigo": "1767770",
                        "tag": "Todos",
                        "razaoSocial": "S  N  DOS SANTOS MATERIAIS PARA",
                        "media3Meses": 2.6666666666666665,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 660328,
                        "codigo": "1840835",
                        "tag": "Todos",
                        "razaoSocial": "NACIONAL TINTAS E FERRAGISTA LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 660669,
                        "codigo": "1841151",
                        "tag": "Todos",
                        "razaoSocial": "MIX PORCELANATOS E ACABAMENTOS LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 665291,
                        "codigo": "1844054",
                        "tag": "Todos",
                        "razaoSocial": "DIONE LUCIO PEREIRA LTDA",
                        "media3Meses": 8.666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 13
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 14
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 18
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 671802,
                        "codigo": "1847811",
                        "tag": "Todos",
                        "razaoSocial": "REINALDO FRANCISCO FILHO 9447138012",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 1037193,
                        "codigo": "1853256",
                        "tag": "Todos",
                        "razaoSocial": "59 787 587 VITOR GABRIEL CAMPOS",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            }
                        ]
                    },
                    {
                        "id": 1039854,
                        "codigo": "1854798",
                        "tag": "Todos",
                        "razaoSocial": "DISTRIBUIDORA DE MANTA LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1045125,
                        "codigo": "1857155",
                        "tag": "Todos",
                        "razaoSocial": "EDIFIC EMPREENDIMENTOS IMOBILIARIOS",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1047601,
                        "codigo": "1858765",
                        "tag": "Todos",
                        "razaoSocial": "MATERIAIS DE CONSTRUCAO E",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1060893,
                        "codigo": "1865212",
                        "tag": "Todos",
                        "razaoSocial": "CASA ITALIA LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1078288,
                        "codigo": "1875204",
                        "tag": "Todos",
                        "razaoSocial": "63.090.469 MARIA EDUARDA PEREIRA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1083296,
                        "codigo": "1878552",
                        "tag": "Todos",
                        "razaoSocial": "MS RODRIGUES CONSTRUTORA LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1092018,
                        "codigo": "1884613",
                        "tag": "Todos",
                        "razaoSocial": "CIMENTOS MULTIMARCAS LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1092140,
                        "codigo": "1884657",
                        "tag": "Todos",
                        "razaoSocial": "63 990 997 LUCAS CHAGAS MENDONCA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 0,
                        "codigo": "CreatedAt",
                        "createdAt": "2026-07-08T09:10:08.7964971"
                    }
                ]
            },
            {
                "id": 1596,
                "codigoVendedor": "278521",
                "nomeVendedor": "PAULA FERREIRA DOS SANTOS",
                "basesAutosservico": [
                    {
                        "id": -1,
                        "tag": "Card-Rota",
                        "card": {
                            "totalPedidos": 0,
                            "percentTotalPedidos": -1,
                            "percentPedidosWebCliente": 0,
                            "mixPedidosWebCliente": 0,
                            "percentPedidosWebVendedor": 0,
                            "mixPedidosWebVendedor": 0,
                            "percentOutros": 0,
                            "mixOutros": 0
                        }
                    },
                    {
                        "id": -2,
                        "tag": "Card-Todos",
                        "card": {
                            "totalPedidos": 9,
                            "percentTotalPedidos": -1,
                            "percentPedidosWebCliente": 0.2222222222222222,
                            "mixPedidosWebCliente": 1,
                            "percentPedidosWebVendedor": 0.4444444444444444,
                            "mixPedidosWebVendedor": 1.5,
                            "percentOutros": 0.3333333333333333,
                            "mixOutros": 1
                        }
                    },
                    {
                        "id": 51702,
                        "codigo": "1489121",
                        "tag": "Rota",
                        "razaoSocial": "COMERCIAL SHEKINAH LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 218198,
                        "codigo": "1492798",
                        "tag": "Rota",
                        "razaoSocial": "CJC MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 239223,
                        "codigo": "1658008",
                        "tag": "Rota",
                        "razaoSocial": "BOM PRECO INDUSTRIA E MATERAIL DE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 673373,
                        "codigo": "1848747",
                        "tag": "Rota",
                        "razaoSocial": "MD LAJES E MUROS PRE-MOLDADOS LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 5301,
                        "codigo": "1488183",
                        "tag": "Todos",
                        "razaoSocial": "KAMP MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 6689,
                        "codigo": "1548836",
                        "tag": "Todos",
                        "razaoSocial": "LEROY MERLIN COMPANHIA BRASILEIRA D",
                        "media3Meses": 3.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "SERVIÇOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "SERVIÇOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "SERVIÇOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "SERVIÇOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "SERVIÇOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 8621,
                        "codigo": "1724299",
                        "tag": "Todos",
                        "razaoSocial": "GG COMERCIO E CONSTRUCOES LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 24964,
                        "codigo": "1708597",
                        "tag": "Todos",
                        "razaoSocial": "CIMENTO JA LTDA",
                        "media3Meses": 6.666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 11
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 8
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 9
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 28491,
                        "codigo": "1447991",
                        "tag": "Todos",
                        "razaoSocial": "JOSE ALBERTO BREMENKAMP",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 29091,
                        "codigo": "1722585",
                        "tag": "Todos",
                        "razaoSocial": "46 517 555 VALERIO CARDOSO RIBEIRO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 43902,
                        "codigo": "1578720",
                        "tag": "Todos",
                        "razaoSocial": "SAMUEL RIBEIRO SOARES",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 50655,
                        "codigo": "1606250",
                        "tag": "Todos",
                        "razaoSocial": "ALEX LIPEK SPALA DEBOSSAN",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 51702,
                        "codigo": "1489121",
                        "tag": "Todos",
                        "razaoSocial": "COMERCIAL SHEKINAH LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 51857,
                        "codigo": "1700224",
                        "tag": "Todos",
                        "razaoSocial": "COMERCIAL POLYANE LIMITADA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 51866,
                        "codigo": "1699838",
                        "tag": "Todos",
                        "razaoSocial": "BOA PRACA MATERIAL DE CONSTRUCAO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 51871,
                        "codigo": "1712451",
                        "tag": "Todos",
                        "razaoSocial": "COIMBRA MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53394,
                        "codigo": "1644155",
                        "tag": "Todos",
                        "razaoSocial": "MATEROL MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53644,
                        "codigo": "1487131",
                        "tag": "Todos",
                        "razaoSocial": "L COLODETTI MATERIAL DE CONSTRUCAO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 55085,
                        "codigo": "1491194",
                        "tag": "Todos",
                        "razaoSocial": "CASA BIS MATERIAL DE CONSTRUCAO LTD",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 55661,
                        "codigo": "1412976",
                        "tag": "Todos",
                        "razaoSocial": "GAROTINHOS MATERIAL DE CONSTRUCAO L",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58089,
                        "codigo": "1501274",
                        "tag": "Todos",
                        "razaoSocial": "CENTRAL NORTE COMERCIAL LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58550,
                        "codigo": "1727945",
                        "tag": "Todos",
                        "razaoSocial": "ALEXSANDRO PEREIRA DA SILVA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 60528,
                        "codigo": "1704413",
                        "tag": "Todos",
                        "razaoSocial": "COMPLETA MATERIAL DE CONSTRUCAO LTD",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 114513,
                        "codigo": "1799874",
                        "tag": "Todos",
                        "razaoSocial": "46 320 116 SIDNEY ALMEIDA SIQUEIRA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 205072,
                        "codigo": "1775665",
                        "tag": "Todos",
                        "razaoSocial": "REDE C&D SUPER ATACADO LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 218182,
                        "codigo": "1488202",
                        "tag": "Todos",
                        "razaoSocial": "INOVE MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 218195,
                        "codigo": "1532184",
                        "tag": "Todos",
                        "razaoSocial": "ANA NEUZA ZANOLI EIRELI",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 218198,
                        "codigo": "1492798",
                        "tag": "Todos",
                        "razaoSocial": "CJC MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 224400,
                        "codigo": "1625722",
                        "tag": "Todos",
                        "razaoSocial": "M A  UTILIDADES DA CONSTRUCAO LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 224403,
                        "codigo": "1674895",
                        "tag": "Todos",
                        "razaoSocial": "JOANILSON RIBEIRO LOPES",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 224921,
                        "codigo": "1505732",
                        "tag": "Todos",
                        "razaoSocial": "PEDRAO MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 230856,
                        "codigo": "1490942",
                        "tag": "Todos",
                        "razaoSocial": "MEC COMERCIO DE MATERIAL DE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 236493,
                        "codigo": "1639428",
                        "tag": "Todos",
                        "razaoSocial": "VAMOS CONSTRUIR MATERIAL DE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 239219,
                        "codigo": "1491195",
                        "tag": "Todos",
                        "razaoSocial": "VISTA MAR MATERIAL DE CONSTRUCAO",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "SERVIÇOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 239223,
                        "codigo": "1658008",
                        "tag": "Todos",
                        "razaoSocial": "BOM PRECO INDUSTRIA E MATERAIL DE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 395426,
                        "codigo": "1818813",
                        "tag": "Todos",
                        "razaoSocial": "BMB MATERIAL DE CONSTRUCAO S A",
                        "media3Meses": 2,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "SERVIÇOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "SERVIÇOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "SERVIÇOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "SERVIÇOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 397425,
                        "codigo": "1819904",
                        "tag": "Todos",
                        "razaoSocial": "JEFERSON CARLOS FONSECA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 673373,
                        "codigo": "1848747",
                        "tag": "Todos",
                        "razaoSocial": "MD LAJES E MUROS PRE-MOLDADOS LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1045573,
                        "codigo": "1857463",
                        "tag": "Todos",
                        "razaoSocial": "BUENO E FONSECA MATERIAL DE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 0,
                        "codigo": "CreatedAt",
                        "createdAt": "2026-07-08T09:10:09.0221997"
                    }
                ]
            },
            {
                "id": 1200,
                "codigoVendedor": "266516",
                "nomeVendedor": "ROMULO FADEL DUARTE",
                "basesAutosservico": [
                    {
                        "id": -1,
                        "tag": "Card-Rota",
                        "card": {
                            "totalPedidos": 10,
                            "percentTotalPedidos": -1,
                            "percentPedidosWebCliente": 1,
                            "mixPedidosWebCliente": 1,
                            "percentPedidosWebVendedor": 0,
                            "mixPedidosWebVendedor": 0,
                            "percentOutros": 0,
                            "mixOutros": 0
                        }
                    },
                    {
                        "id": -2,
                        "tag": "Card-Todos",
                        "card": {
                            "totalPedidos": 45,
                            "percentTotalPedidos": -1,
                            "percentPedidosWebCliente": 0.4,
                            "mixPedidosWebCliente": 1.5555555555555556,
                            "percentPedidosWebVendedor": 0.4444444444444444,
                            "mixPedidosWebVendedor": 1.2352941176470589,
                            "percentOutros": 0.15555555555555556,
                            "mixOutros": 2
                        }
                    },
                    {
                        "id": 57897,
                        "codigo": "1051695",
                        "tag": "Rota",
                        "razaoSocial": "INDUSTRIA E COMERCIO RIO VERMELHO L",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 59769,
                        "codigo": "1143992",
                        "tag": "Rota",
                        "razaoSocial": "A L PEREIRA MELLO MATERIAIS DE CONS",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 59947,
                        "codigo": "1574492",
                        "tag": "Rota",
                        "razaoSocial": "ALDO CARDOZO DE CARVALHO 0751837873",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250515,
                        "codigo": "1684245",
                        "tag": "Rota",
                        "razaoSocial": "SANDRA FRANCO VIEIRA",
                        "media3Meses": 12,
                        "pedidosMesAtual": 5,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 10
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 18
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 16
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 18
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 13
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 5
                            }
                        ]
                    },
                    {
                        "id": 293943,
                        "codigo": "1254015",
                        "tag": "Rota",
                        "razaoSocial": "JO & JUNIOR MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 15.333333333333334,
                        "pedidosMesAtual": 5,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 14
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 21
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 26
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 21
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 20
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 5
                            }
                        ]
                    },
                    {
                        "id": 6152,
                        "codigo": "1582453",
                        "tag": "Todos",
                        "razaoSocial": "JORCIL INDUSTRIA E COMERCIO DE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 7156,
                        "codigo": "1807155",
                        "tag": "Todos",
                        "razaoSocial": "28 096 127 EDUARDO CIDNEY CAMPOS DA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 13859,
                        "codigo": "1058707",
                        "tag": "Todos",
                        "razaoSocial": "SO BRUTOS MATERIAL DE CONSTRUCAO",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 14225,
                        "codigo": "1663781",
                        "tag": "Todos",
                        "razaoSocial": "G  COSTA NF LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 26337,
                        "codigo": "1287344",
                        "tag": "Todos",
                        "razaoSocial": "EDIMAC MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 27038,
                        "codigo": "1159753",
                        "tag": "Todos",
                        "razaoSocial": "OPCAO DE IBIPEBA MATERIAL DE",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 29140,
                        "codigo": "1527601",
                        "tag": "Todos",
                        "razaoSocial": "BIANCA DE OLIVEIRA ROLANDI 13096245",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 29917,
                        "codigo": "1467804",
                        "tag": "Todos",
                        "razaoSocial": "MATERIAIS DE CONSTRUCAO STO ANTONIO",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 30495,
                        "codigo": "1609488",
                        "tag": "Todos",
                        "razaoSocial": "CASA FORTE CANTAGALO LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 48901,
                        "codigo": "1257892",
                        "tag": "Todos",
                        "razaoSocial": "HERFALTZ MADEIRAS LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 49985,
                        "codigo": "1110119",
                        "tag": "Todos",
                        "razaoSocial": "AGROSUL AGROPECUARIA SUMIDOURO LTDA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            }
                        ]
                    },
                    {
                        "id": 52138,
                        "codigo": "1111762",
                        "tag": "Todos",
                        "razaoSocial": "BRANTES MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 52506,
                        "codigo": "1546280",
                        "tag": "Todos",
                        "razaoSocial": "ALMEK CENTER CONSTRUCOES LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53279,
                        "codigo": "1694431",
                        "tag": "Todos",
                        "razaoSocial": "PRECO BOM VAREJAO DA CONSTRUCAO LTD",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53431,
                        "codigo": "1606892",
                        "tag": "Todos",
                        "razaoSocial": "CARVALHO BONAN INDUSTRIA, COMERCIO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53834,
                        "codigo": "1390119",
                        "tag": "Todos",
                        "razaoSocial": "RIMACOM MATERIAIS DE CONSTRUCAO LTD",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53845,
                        "codigo": "1389996",
                        "tag": "Todos",
                        "razaoSocial": "GUERRA COMERCIO VAREJISTA DE",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 54057,
                        "codigo": "1262560",
                        "tag": "Todos",
                        "razaoSocial": "MATERIAL DE CONSTRUCAO SANTA RITA D",
                        "media3Meses": 3.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 54225,
                        "codigo": "1151870",
                        "tag": "Todos",
                        "razaoSocial": "SERRARIA SAO CAETANO DE SUMIDOURO",
                        "media3Meses": 2.6666666666666665,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 54428,
                        "codigo": "1059674",
                        "tag": "Todos",
                        "razaoSocial": "CASTROMAR MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 54455,
                        "codigo": "1059899",
                        "tag": "Todos",
                        "razaoSocial": "RIRROFER MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 54897,
                        "codigo": "1527624",
                        "tag": "Todos",
                        "razaoSocial": "E F  SANTOS MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 55275,
                        "codigo": "1467670",
                        "tag": "Todos",
                        "razaoSocial": "CASA SAO JORGE LUMIAR MATERIAL DE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 55280,
                        "codigo": "1467851",
                        "tag": "Todos",
                        "razaoSocial": "LOUBACK 13 MATERIAL DE CONSTRUCAO",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 55516,
                        "codigo": "1446661",
                        "tag": "Todos",
                        "razaoSocial": "SALVAN DE FRIBURGO MATERIAIS DE",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 55606,
                        "codigo": "1431610",
                        "tag": "Todos",
                        "razaoSocial": "REJANE VITORIO DE OLIVEIRA MATERIAL",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 55610,
                        "codigo": "1435231",
                        "tag": "Todos",
                        "razaoSocial": "VANESSA MARTINS DA SILVEIRA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 55882,
                        "codigo": "1357118",
                        "tag": "Todos",
                        "razaoSocial": "S M FERREIRA MATERIAIS DE CONSTRUCA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 55902,
                        "codigo": "1344492",
                        "tag": "Todos",
                        "razaoSocial": "IRMAOS BLAUDT MATERIAIS DE",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 56131,
                        "codigo": "1283347",
                        "tag": "Todos",
                        "razaoSocial": "DISTRIBUIDORA TIJOTELHAS DE",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 56174,
                        "codigo": "1263818",
                        "tag": "Todos",
                        "razaoSocial": "TREVO MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 56195,
                        "codigo": "1263816",
                        "tag": "Todos",
                        "razaoSocial": "CONSTRUCASA DE PAPUCAIA LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 56235,
                        "codigo": "1263707",
                        "tag": "Todos",
                        "razaoSocial": "J MONTEIRO COMERCIO E SERVICOS LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 57038,
                        "codigo": "1059690",
                        "tag": "Todos",
                        "razaoSocial": "J. A. F. QUINTIERI - MATERIAIS DE",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 57548,
                        "codigo": "1048243",
                        "tag": "Todos",
                        "razaoSocial": "VAREJAO DA CONSTRUCAO LTDA   EPP",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 57616,
                        "codigo": "1007535",
                        "tag": "Todos",
                        "razaoSocial": "LOJAO DO ABREU MATERIAIS DE",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 57746,
                        "codigo": "1003515",
                        "tag": "Todos",
                        "razaoSocial": "CONCREBLOK COMERCIO DE MATERIAIS DE",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 57748,
                        "codigo": "1003563",
                        "tag": "Todos",
                        "razaoSocial": "AREAL MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 57750,
                        "codigo": "1003598",
                        "tag": "Todos",
                        "razaoSocial": "COFERTRIL COMERCIO DE FERROS TRES",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 57876,
                        "codigo": "1056688",
                        "tag": "Todos",
                        "razaoSocial": "R V F  REAL MATERIAL DE CONSTRUCAO",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 57897,
                        "codigo": "1051695",
                        "tag": "Todos",
                        "razaoSocial": "INDUSTRIA E COMERCIO RIO VERMELHO L",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 57930,
                        "codigo": "1009690",
                        "tag": "Todos",
                        "razaoSocial": "A M MAGALHAES MATERIAIS DE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58443,
                        "codigo": "1748997",
                        "tag": "Todos",
                        "razaoSocial": "CORDEIRO & FALTZ ARMARINHO E",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58835,
                        "codigo": "1664817",
                        "tag": "Todos",
                        "razaoSocial": "MATERIAIS DE CONSTRUCAO DIONE DE",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58871,
                        "codigo": "1667423",
                        "tag": "Todos",
                        "razaoSocial": "OTIMA PARAFUSOS E FERRAMENTAS LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58876,
                        "codigo": "1665215",
                        "tag": "Todos",
                        "razaoSocial": "CASA ARRAIS MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58905,
                        "codigo": "1671759",
                        "tag": "Todos",
                        "razaoSocial": "40 430 085 JOILSON SANTOS DAS CHAGA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58921,
                        "codigo": "1665719",
                        "tag": "Todos",
                        "razaoSocial": "KAMILA DE OLIVEIRA LOPES MATERIAIS",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 59379,
                        "codigo": "1590310",
                        "tag": "Todos",
                        "razaoSocial": "DINIZ SENDAO MATERIAL DE CONSTRUCAO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 59513,
                        "codigo": "1570658",
                        "tag": "Todos",
                        "razaoSocial": "14 786 998 MARCIELE DA SILVA BRANDT",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 59769,
                        "codigo": "1143992",
                        "tag": "Todos",
                        "razaoSocial": "A L PEREIRA MELLO MATERIAIS DE CONS",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 59890,
                        "codigo": "1625973",
                        "tag": "Todos",
                        "razaoSocial": "ELIELSON RIBEIRO FRANCISCO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 59913,
                        "codigo": "1609755",
                        "tag": "Todos",
                        "razaoSocial": "ADRIVA MATERIAIS DE CONSTRUCOES LTD",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 59922,
                        "codigo": "1596275",
                        "tag": "Todos",
                        "razaoSocial": "PAULO CESAR RAMOS DE SOUZA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 59947,
                        "codigo": "1574492",
                        "tag": "Todos",
                        "razaoSocial": "ALDO CARDOZO DE CARVALHO 0751837873",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 59975,
                        "codigo": "1561949",
                        "tag": "Todos",
                        "razaoSocial": "POP MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 60213,
                        "codigo": "1419266",
                        "tag": "Todos",
                        "razaoSocial": "IPITUNA MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 112504,
                        "codigo": "1792944",
                        "tag": "Todos",
                        "razaoSocial": "ANTONIO CARLOS DO NASCIMENTO",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 139248,
                        "codigo": "1122884",
                        "tag": "Todos",
                        "razaoSocial": "A  P  VASCONCELLOS",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 249873,
                        "codigo": "1434140",
                        "tag": "Todos",
                        "razaoSocial": "COMERCIAL SERRA FLUMINENSE MATERIAL",
                        "media3Meses": 3.3333333333333335,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 8
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            }
                        ]
                    },
                    {
                        "id": 250282,
                        "codigo": "1410310",
                        "tag": "Todos",
                        "razaoSocial": "NOVA MACUCO MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250515,
                        "codigo": "1684245",
                        "tag": "Todos",
                        "razaoSocial": "SANDRA FRANCO VIEIRA",
                        "media3Meses": 12,
                        "pedidosMesAtual": 5,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 10
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 18
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 16
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 18
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 13
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 5
                            }
                        ]
                    },
                    {
                        "id": 250716,
                        "codigo": "1479430",
                        "tag": "Todos",
                        "razaoSocial": "HELIO DUTRA CONSTRUCAO E ACABAMENTO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 251891,
                        "codigo": "1707399",
                        "tag": "Todos",
                        "razaoSocial": "JUNIOR MATERIAL E CONTRUCAO LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 251997,
                        "codigo": "1708585",
                        "tag": "Todos",
                        "razaoSocial": "IVAN RAMOS DA COSTA 09213470738",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 252060,
                        "codigo": "1768873",
                        "tag": "Todos",
                        "razaoSocial": "A DE SOUZA   MATERIAIS DE CONSTRUCA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 252063,
                        "codigo": "1748165",
                        "tag": "Todos",
                        "razaoSocial": "MATERIAL DE CONSTRUCAO CONCHA DA LU",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 252065,
                        "codigo": "1592292",
                        "tag": "Todos",
                        "razaoSocial": "JORGE MAYKE BARROS DE MELO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 252963,
                        "codigo": "1631509",
                        "tag": "Todos",
                        "razaoSocial": "P TELLES NUNES MATERIAIS DE",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253281,
                        "codigo": "1493900",
                        "tag": "Todos",
                        "razaoSocial": "CONSTROI LOPES MATERIAIS DE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253853,
                        "codigo": "1773611",
                        "tag": "Todos",
                        "razaoSocial": "EDIMAC 3 MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 292861,
                        "codigo": "1059626",
                        "tag": "Todos",
                        "razaoSocial": "NOMIDI MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 293577,
                        "codigo": "1486680",
                        "tag": "Todos",
                        "razaoSocial": "SAMENSE MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 293943,
                        "codigo": "1254015",
                        "tag": "Todos",
                        "razaoSocial": "JO & JUNIOR MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 15.333333333333334,
                        "pedidosMesAtual": 5,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 14
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 21
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 26
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 21
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 20
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 5
                            }
                        ]
                    },
                    {
                        "id": 294379,
                        "codigo": "1058624",
                        "tag": "Todos",
                        "razaoSocial": "E C REGO E CIA LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 294472,
                        "codigo": "1293358",
                        "tag": "Todos",
                        "razaoSocial": "JOELMA OLIVEIRA GUIMARAES",
                        "media3Meses": 7.333333333333333,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 9
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 9
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 294870,
                        "codigo": "1467691",
                        "tag": "Todos",
                        "razaoSocial": "CRF MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 295099,
                        "codigo": "1454748",
                        "tag": "Todos",
                        "razaoSocial": "CASA WALTER MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 295174,
                        "codigo": "1289288",
                        "tag": "Todos",
                        "razaoSocial": "PROJECT BRASIL MATERIAIS DE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 295226,
                        "codigo": "1481198",
                        "tag": "Todos",
                        "razaoSocial": "ANDREA S RODRIGUES MATERIAIS DE",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 295275,
                        "codigo": "1451989",
                        "tag": "Todos",
                        "razaoSocial": "GG ROZA COMERCIO LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 295310,
                        "codigo": "1344459",
                        "tag": "Todos",
                        "razaoSocial": "CONSTRUMACKER DE FRIBURGO MATERIAIS",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 372049,
                        "codigo": "1454749",
                        "tag": "Todos",
                        "razaoSocial": "28 817 872 JOSE MAURICIO MENDES",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 380859,
                        "codigo": "1048451",
                        "tag": "Todos",
                        "razaoSocial": "VIMACOL VITORIA MATERIAIS DE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 471529,
                        "codigo": "1828543",
                        "tag": "Todos",
                        "razaoSocial": "ADRIANA DA COSTA NEVES 07717727773",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 627369,
                        "codigo": "1831725",
                        "tag": "Todos",
                        "razaoSocial": "58 962 279 LUCIANO ARAUJO SILVA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 627381,
                        "codigo": "1831763",
                        "tag": "Todos",
                        "razaoSocial": "52 899 278 ADRIANA OLIVEIRA DA SILV",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 630811,
                        "codigo": "1832157",
                        "tag": "Todos",
                        "razaoSocial": "59 565 083 KRISTIAN CESAR",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 643740,
                        "codigo": "1835385",
                        "tag": "Todos",
                        "razaoSocial": "COMERCIAL RIO BRAVO MATERIAL DE",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 660823,
                        "codigo": "1841250",
                        "tag": "Todos",
                        "razaoSocial": "59 879 060 ESIO BARBOSA DE OLIVEIRA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1037471,
                        "codigo": "1853389",
                        "tag": "Todos",
                        "razaoSocial": "CONSTRUCAMPOS MATERIAIS DE",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1049365,
                        "codigo": "1859951",
                        "tag": "Todos",
                        "razaoSocial": "STORCK DISTRIBUIDORA E TRANSPORTES",
                        "media3Meses": 9,
                        "pedidosMesAtual": 7,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 14
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 7
                            }
                        ]
                    },
                    {
                        "id": 1053374,
                        "codigo": "1862141",
                        "tag": "Todos",
                        "razaoSocial": "61 829 711 SERGIO VITOR MARTINS",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1053381,
                        "codigo": "1862210",
                        "tag": "Todos",
                        "razaoSocial": "HP MATERIAL DE CONSTRUCAO E SERVICO",
                        "media3Meses": 4,
                        "pedidosMesAtual": 3,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 1076057,
                        "codigo": "1873646",
                        "tag": "Todos",
                        "razaoSocial": "53 595 895 VERA LUCIA DA SILVA",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1087280,
                        "codigo": "1881390",
                        "tag": "Todos",
                        "razaoSocial": "63 574 310 MARIA EDUARDA GOMES",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 0,
                        "codigo": "CreatedAt",
                        "createdAt": "2026-07-08T09:10:08.9436924"
                    }
                ]
            },
            {
                "id": 1301,
                "codigoVendedor": "90122490",
                "nomeVendedor": "Carteira Provisória1 SE",
                "basesAutosservico": [
                    {
                        "id": -1,
                        "tag": "Card-Rota",
                        "card": {
                            "totalPedidos": 0,
                            "percentTotalPedidos": 1,
                            "percentPedidosWebCliente": 0,
                            "mixPedidosWebCliente": 0,
                            "percentPedidosWebVendedor": 0,
                            "mixPedidosWebVendedor": 0,
                            "percentOutros": 0,
                            "mixOutros": 0
                        }
                    },
                    {
                        "id": -2,
                        "tag": "Card-Todos",
                        "card": {
                            "totalPedidos": 45,
                            "percentTotalPedidos": -1,
                            "percentPedidosWebCliente": 0.17777777777777778,
                            "mixPedidosWebCliente": 1.7142857142857142,
                            "percentPedidosWebVendedor": 0.044444444444444446,
                            "mixPedidosWebVendedor": 3,
                            "percentOutros": 0.7777777777777778,
                            "mixOutros": 1.6875
                        }
                    },
                    {
                        "id": 6188,
                        "codigo": "1675519",
                        "tag": "Todos",
                        "razaoSocial": "ANA CAROLINE LOUREIRO DA SILVA",
                        "media3Meses": 2,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            }
                        ]
                    },
                    {
                        "id": 6221,
                        "codigo": "1454327",
                        "tag": "Todos",
                        "razaoSocial": "CSF MATERIAIS DE CONSTRUCOES EIRELI",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 6246,
                        "codigo": "1048222",
                        "tag": "Todos",
                        "razaoSocial": "VIEIRA E RODRIGUES MATERIAL DE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 7627,
                        "codigo": "1579665",
                        "tag": "Todos",
                        "razaoSocial": "VALDINEI PEREIRA DE OLIVEIRA 289287",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 8511,
                        "codigo": "1559124",
                        "tag": "Todos",
                        "razaoSocial": "IRMAOS MELLO MATERIAL DE CONSTRUCAO",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 14168,
                        "codigo": "1577886",
                        "tag": "Todos",
                        "razaoSocial": "PONTO LEGAL BAZAR E MATERIAIS DE CO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 16821,
                        "codigo": "1785431",
                        "tag": "Todos",
                        "razaoSocial": "54 409 160 TARCISO DE PAULO DESSOTT",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 19392,
                        "codigo": "1481217",
                        "tag": "Todos",
                        "razaoSocial": "I P R MATERIAL DE CONSTRUCAO E TRAN",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 19824,
                        "codigo": "1439148",
                        "tag": "Todos",
                        "razaoSocial": "J  L  DE ARAUJO MARQUES MATERIAIS D",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 25849,
                        "codigo": "1538955",
                        "tag": "Todos",
                        "razaoSocial": "N R MATERIAIS DE CONSTRUCOES EIRELI",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 25896,
                        "codigo": "1555509",
                        "tag": "Todos",
                        "razaoSocial": "NIVEBRA FERRAGENS LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 25979,
                        "codigo": "1485560",
                        "tag": "Todos",
                        "razaoSocial": "HIDRAULICA ESPINHENSE LTDA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 29661,
                        "codigo": "1435217",
                        "tag": "Todos",
                        "razaoSocial": "ANDERSON RODRIGUES GARCIA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 30952,
                        "codigo": "1514660",
                        "tag": "Todos",
                        "razaoSocial": "LAYLA BESSA PEDROZA MATERIAIS DE CO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 31047,
                        "codigo": "1427966",
                        "tag": "Todos",
                        "razaoSocial": "LIUTH MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 33291,
                        "codigo": "1528707",
                        "tag": "Todos",
                        "razaoSocial": "SELMA ROSALVE DA SILVA FARIAS 03615",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 33984,
                        "codigo": "1003677",
                        "tag": "Todos",
                        "razaoSocial": "CASA BANDEIRANTE DE FERRAGENS LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 34716,
                        "codigo": "1699590",
                        "tag": "Todos",
                        "razaoSocial": "CAMANDUCAIA MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 34934,
                        "codigo": "1750107",
                        "tag": "Todos",
                        "razaoSocial": "GONCALVES DIAS COMERCIO DE MATERIAI",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 34973,
                        "codigo": "1728978",
                        "tag": "Todos",
                        "razaoSocial": "JORGE ADOLFO DIAS",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 34997,
                        "codigo": "1720951",
                        "tag": "Todos",
                        "razaoSocial": "PRISCILA DE PAULA ANDRADE SOUZA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 35648,
                        "codigo": "1658728",
                        "tag": "Todos",
                        "razaoSocial": "PRISCILLA DE ARAUJO DE SENA 1324294",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 36141,
                        "codigo": "1769459",
                        "tag": "Todos",
                        "razaoSocial": "RICAFEX MADEIRAS MATERIAIS DE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 36217,
                        "codigo": "1713661",
                        "tag": "Todos",
                        "razaoSocial": "OBRAZEM MATERIAIS DE CONSTRUCAO LTD",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 36259,
                        "codigo": "1678251",
                        "tag": "Todos",
                        "razaoSocial": "IFS COMERCIO DE MATERIAIS DE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 36272,
                        "codigo": "1662539",
                        "tag": "Todos",
                        "razaoSocial": "MARCELO DA SILVA RIBEIRO 0123551170",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 36371,
                        "codigo": "1622375",
                        "tag": "Todos",
                        "razaoSocial": "CONSTRULIDICE MATERIAL DE CONSTRUCA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 36403,
                        "codigo": "1591558",
                        "tag": "Todos",
                        "razaoSocial": "FRANCISCO MATERIAL DE CONSTRUCAO LT",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 36425,
                        "codigo": "1589206",
                        "tag": "Todos",
                        "razaoSocial": "MATERIAL DE CONSTRUCAO X   TUDAO LT",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 36449,
                        "codigo": "1573572",
                        "tag": "Todos",
                        "razaoSocial": "35 638 735 ROZIMERO ROCHA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 36473,
                        "codigo": "1565534",
                        "tag": "Todos",
                        "razaoSocial": "MICHELLE AMARAL DE CARVALHO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 36619,
                        "codigo": "1462852",
                        "tag": "Todos",
                        "razaoSocial": "ELIANE DOS SANTOS RODRIGUES 0715544",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 36656,
                        "codigo": "1456924",
                        "tag": "Todos",
                        "razaoSocial": "PASSA TRES COMERCIO LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 36739,
                        "codigo": "1424635",
                        "tag": "Todos",
                        "razaoSocial": "B S C   COMERCIO VAREJISTA DE",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 36824,
                        "codigo": "1361164",
                        "tag": "Todos",
                        "razaoSocial": "BAMBU MATERIAIS DE CONSTRUCAO EIREL",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 36846,
                        "codigo": "1348985",
                        "tag": "Todos",
                        "razaoSocial": "A L P MATURANA MATERIAIS DE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 36913,
                        "codigo": "1284416",
                        "tag": "Todos",
                        "razaoSocial": "SAULINA MATERIAIS DE CONSTRUCAO LTD",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 36945,
                        "codigo": "1233364",
                        "tag": "Todos",
                        "razaoSocial": "BAZAR LONDRES MATERIAIS DE",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 36946,
                        "codigo": "1254432",
                        "tag": "Todos",
                        "razaoSocial": "MSC COMERCIO DE MATERIAIS DE CONSTR",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 36958,
                        "codigo": "1192427",
                        "tag": "Todos",
                        "razaoSocial": "PAGUE POUCO DE MARICA MATERIAIS DE",
                        "media3Meses": 2.6666666666666665,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 37037,
                        "codigo": "1132051",
                        "tag": "Todos",
                        "razaoSocial": "ESCOBAR E MARABA MATERIAIS DE CONST",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 37074,
                        "codigo": "1050540",
                        "tag": "Todos",
                        "razaoSocial": "FAROLIMA COMERCIO DE MATERIAIS DE C",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 37081,
                        "codigo": "1049298",
                        "tag": "Todos",
                        "razaoSocial": "VARGAS MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 37092,
                        "codigo": "1057839",
                        "tag": "Todos",
                        "razaoSocial": "KHALKARIUM MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 37100,
                        "codigo": "1057866",
                        "tag": "Todos",
                        "razaoSocial": "MATERIAL DE CONSTRUCAO EDILEUZA VIL",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 37113,
                        "codigo": "1059365",
                        "tag": "Todos",
                        "razaoSocial": "MATERIAL DE CONSTRUCAO NAZARENO DA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 37126,
                        "codigo": "1059691",
                        "tag": "Todos",
                        "razaoSocial": "SIMONICA MATERIAIS DE CONSTRUCAO LT",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 37167,
                        "codigo": "1064931",
                        "tag": "Todos",
                        "razaoSocial": "SECRET FIGHTR BAZAR  FERRAGENS E MA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 37206,
                        "codigo": "1000591",
                        "tag": "Todos",
                        "razaoSocial": "FERRAGENS SHALON A ALMEIDA S DE REA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 37227,
                        "codigo": "1003831",
                        "tag": "Todos",
                        "razaoSocial": "FORTE 210 MATERIAIS DE CONSTRUCAO L",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 37324,
                        "codigo": "1061492",
                        "tag": "Todos",
                        "razaoSocial": "CASA MACHADO MATERIAIS DE CONSTRUCA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 40321,
                        "codigo": "1061254",
                        "tag": "Todos",
                        "razaoSocial": "CASA VIEIRA 1201 MATERIAIS DE",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 40323,
                        "codigo": "1039513",
                        "tag": "Todos",
                        "razaoSocial": "BAZAR E FERRAGENS VILA NOVA DE GAIA",
                        "media3Meses": 3.6666666666666665,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 40324,
                        "codigo": "1106065",
                        "tag": "Todos",
                        "razaoSocial": "MATERIAIS DE CONSTRUCAO E BAZAR",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 40327,
                        "codigo": "1231063",
                        "tag": "Todos",
                        "razaoSocial": "RAMAR MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 3,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 40338,
                        "codigo": "1626602",
                        "tag": "Todos",
                        "razaoSocial": "JORGE LUIZ DE OLIVEIRA LOMBA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 40341,
                        "codigo": "1630560",
                        "tag": "Todos",
                        "razaoSocial": "12 977 520 THIAGO DA SILVEIRA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 40343,
                        "codigo": "1713847",
                        "tag": "Todos",
                        "razaoSocial": "M A  DE FARIAS CONSTRUCOES E",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 52363,
                        "codigo": "1461947",
                        "tag": "Todos",
                        "razaoSocial": "EDNEI BARBOSA DOS SANTOS   ME",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53807,
                        "codigo": "1446175",
                        "tag": "Todos",
                        "razaoSocial": "CONSTRUINDO O PARAISO MATERIAL DE C",
                        "media3Meses": 2,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53860,
                        "codigo": "1408617",
                        "tag": "Todos",
                        "razaoSocial": "MARCELLE LUCAS ALVES DE SOUZA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 54028,
                        "codigo": "1287356",
                        "tag": "Todos",
                        "razaoSocial": "LANDIM MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 54536,
                        "codigo": "1056311",
                        "tag": "Todos",
                        "razaoSocial": "SAMUEL MIQUELOTI",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 54912,
                        "codigo": "1527116",
                        "tag": "Todos",
                        "razaoSocial": "CASA ROJER MATERIAL DE CONSTRU",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 54913,
                        "codigo": "1525807",
                        "tag": "Todos",
                        "razaoSocial": "JORGE MICHEL OLIVEIRA CUNHA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 55002,
                        "codigo": "1510467",
                        "tag": "Todos",
                        "razaoSocial": "ADILSON PEREIRA DO ROSARIO   BAZAR",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 55117,
                        "codigo": "1490996",
                        "tag": "Todos",
                        "razaoSocial": "GEOVANI MOREIRA ZANDRE",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 55125,
                        "codigo": "1493849",
                        "tag": "Todos",
                        "razaoSocial": "PORTELA VINTE E UM FERRAGENS LTDA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 55339,
                        "codigo": "1475344",
                        "tag": "Todos",
                        "razaoSocial": "TURIUBA MATERIAIS DE CONSTRUCAO LTD",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 55584,
                        "codigo": "1432385",
                        "tag": "Todos",
                        "razaoSocial": "JOSE DONIZETTI DA SILVA CPF 507 016",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 55634,
                        "codigo": "1428374",
                        "tag": "Todos",
                        "razaoSocial": "ELIANE DE BARROS DOS SANTOS",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 55745,
                        "codigo": "1398843",
                        "tag": "Todos",
                        "razaoSocial": "FELIPE MATERIAIS PARA CONSTRUCAO LT",
                        "media3Meses": 4.666666666666667,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 55824,
                        "codigo": "1378653",
                        "tag": "Todos",
                        "razaoSocial": "ALFAMAR MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 55845,
                        "codigo": "1378285",
                        "tag": "Todos",
                        "razaoSocial": "ANGELA YUMI KONNO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 55937,
                        "codigo": "1349908",
                        "tag": "Todos",
                        "razaoSocial": "BMC MATERIAIS PARA CONSTRUCAO LTDA",
                        "media3Meses": 3,
                        "pedidosMesAtual": 3,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 56015,
                        "codigo": "1337190",
                        "tag": "Todos",
                        "razaoSocial": "FERRAGENS E BAZAR CONSTRUSHOW LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 56039,
                        "codigo": "1314302",
                        "tag": "Todos",
                        "razaoSocial": "NELSON ANGELO ALVES COSTA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 56105,
                        "codigo": "1307907",
                        "tag": "Todos",
                        "razaoSocial": "CONSTRURAMOS MATERIAIS DE CONS",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 56205,
                        "codigo": "1254997",
                        "tag": "Todos",
                        "razaoSocial": "FERNANDO CESAR SOARES",
                        "media3Meses": 2.6666666666666665,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 56390,
                        "codigo": "1159412",
                        "tag": "Todos",
                        "razaoSocial": "BAZAR JUMIRIM LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 56472,
                        "codigo": "1143300",
                        "tag": "Todos",
                        "razaoSocial": "RAVALY MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 56491,
                        "codigo": "1142335",
                        "tag": "Todos",
                        "razaoSocial": "BAZAR GRACITTI LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 56501,
                        "codigo": "1144055",
                        "tag": "Todos",
                        "razaoSocial": "R P DE ANDRADE CONSTRUCAO LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 56519,
                        "codigo": "1134504",
                        "tag": "Todos",
                        "razaoSocial": "MACOBEN MATERIAIS PARA CONSTRUCAO B",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 56529,
                        "codigo": "1110678",
                        "tag": "Todos",
                        "razaoSocial": "CORDOMAT MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 56587,
                        "codigo": "1116966",
                        "tag": "Todos",
                        "razaoSocial": "CRISMAR MADEIRAS LTDA   ME",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 56678,
                        "codigo": "1065169",
                        "tag": "Todos",
                        "razaoSocial": "SIQUEIRA E REIS MATERIAIS DE CONSTR",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 56748,
                        "codigo": "1061653",
                        "tag": "Todos",
                        "razaoSocial": "S B F  MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 56783,
                        "codigo": "1061771",
                        "tag": "Todos",
                        "razaoSocial": "ELEXANDRO DARIO PANIZO",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 56821,
                        "codigo": "1061258",
                        "tag": "Todos",
                        "razaoSocial": "EDERA BAZAR E FERRAGENS LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 57123,
                        "codigo": "1054363",
                        "tag": "Todos",
                        "razaoSocial": "PROJETO MATERIAIS PARA CONSTRUCAO L",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 57149,
                        "codigo": "1054513",
                        "tag": "Todos",
                        "razaoSocial": "SGAVIOLI  OLIVEIRA & CIA LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 57804,
                        "codigo": "1000204",
                        "tag": "Todos",
                        "razaoSocial": "AGAI MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58315,
                        "codigo": "1761913",
                        "tag": "Todos",
                        "razaoSocial": "CONSTRUSHOW MATERIAL DE CONSTRUCAO",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58459,
                        "codigo": "1752797",
                        "tag": "Todos",
                        "razaoSocial": "ZN MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 7
                            }
                        ]
                    },
                    {
                        "id": 58916,
                        "codigo": "1676278",
                        "tag": "Todos",
                        "razaoSocial": "CIRLENE DA COSTA OLIVEIRA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 59044,
                        "codigo": "1659555",
                        "tag": "Todos",
                        "razaoSocial": "37 479 519 ANDERSON VARGAS BOLORINI",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 59122,
                        "codigo": "1664319",
                        "tag": "Todos",
                        "razaoSocial": "IZALDO BONFIM DA SILVA 04067352476",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 59359,
                        "codigo": "1592995",
                        "tag": "Todos",
                        "razaoSocial": "SEVEN TINTAS LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 59516,
                        "codigo": "1578619",
                        "tag": "Todos",
                        "razaoSocial": "JOSE JORGE PACHECO EIRELI",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 114432,
                        "codigo": "1792356",
                        "tag": "Todos",
                        "razaoSocial": "PAGANI MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 114467,
                        "codigo": "1792866",
                        "tag": "Todos",
                        "razaoSocial": "VDM PEREIRA COMERCIO MATERIAL DE",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 114493,
                        "codigo": "1793938",
                        "tag": "Todos",
                        "razaoSocial": "CICERA MARIA TAVARES DOS SANTOS",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 114540,
                        "codigo": "1800064",
                        "tag": "Todos",
                        "razaoSocial": "MATERIAIS PARA TODA OBRA LTDA",
                        "media3Meses": 6,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 6
                            }
                        ]
                    },
                    {
                        "id": 124277,
                        "codigo": "1798903",
                        "tag": "Todos",
                        "razaoSocial": "27 144 596 LUCIANO BRAGA BRITO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 131652,
                        "codigo": "1108605",
                        "tag": "Todos",
                        "razaoSocial": "FERRAGENS CHARRUA LTDA",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 131763,
                        "codigo": "1284383",
                        "tag": "Todos",
                        "razaoSocial": "ALEXANDRE L SILVA & CIA LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 132113,
                        "codigo": "1659965",
                        "tag": "Todos",
                        "razaoSocial": "PATRICK RODRIGUES CHAVES SIQUEIRA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 137093,
                        "codigo": "1451335",
                        "tag": "Todos",
                        "razaoSocial": "RVO CORREIA BAZAR E MATERIAL DE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 217740,
                        "codigo": "1504803",
                        "tag": "Todos",
                        "razaoSocial": "CASA GUARARAPES COMERCIAL LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 217794,
                        "codigo": "1712388",
                        "tag": "Todos",
                        "razaoSocial": "CIMENTACO DISTRIBUIDORA LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 218400,
                        "codigo": "1130357",
                        "tag": "Todos",
                        "razaoSocial": "ANTONIO CARLOS DE ALMEIDA CPF 55594",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 227448,
                        "codigo": "1367988",
                        "tag": "Todos",
                        "razaoSocial": "CIMIX COMERCIAL LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 237818,
                        "codigo": "1700698",
                        "tag": "Todos",
                        "razaoSocial": "OLIVEIRA MATERIAL DE CONSTRUCAO E",
                        "media3Meses": 3.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 248480,
                        "codigo": "1229357",
                        "tag": "Todos",
                        "razaoSocial": "MARCOS SEBASTIAO DIAS CPF 395 915 4",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 360172,
                        "codigo": "1817094",
                        "tag": "Todos",
                        "razaoSocial": "KLEBER DUARTE DE SOUZA REI DO",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 417153,
                        "codigo": "1821432",
                        "tag": "Todos",
                        "razaoSocial": "SERRAMIX MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 589080,
                        "codigo": "1830438",
                        "tag": "Todos",
                        "razaoSocial": "48 520 637 SHAUANNA JULIA GOUVEA DE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 630532,
                        "codigo": "1832038",
                        "tag": "Todos",
                        "razaoSocial": "ACAVIM MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 630803,
                        "codigo": "1832127",
                        "tag": "Todos",
                        "razaoSocial": "57 127 622 ATILA JUVANHOL VALADARES",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 631848,
                        "codigo": "1832228",
                        "tag": "Todos",
                        "razaoSocial": "ACIR MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 663671,
                        "codigo": "1842968",
                        "tag": "Todos",
                        "razaoSocial": "MATRACON MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 666683,
                        "codigo": "1845025",
                        "tag": "Todos",
                        "razaoSocial": "ANDREA FERREIRA BRACO 03202700766",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 941679,
                        "codigo": "1692654",
                        "tag": "Todos",
                        "razaoSocial": "C & S MATERIAIS PARA CONSTRUCOES",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1064790,
                        "codigo": "1867904",
                        "tag": "Todos",
                        "razaoSocial": "YTALO VINICIOS DELFINO TOMAZ LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1072582,
                        "codigo": "1871232",
                        "tag": "Todos",
                        "razaoSocial": "49.302.968 NILMACIO DE SOUZA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1073602,
                        "codigo": "1871935",
                        "tag": "Todos",
                        "razaoSocial": "MEDEIROS  TRINDADE & CIA MATERIAL D",
                        "media3Meses": 3.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1074147,
                        "codigo": "1872274",
                        "tag": "Todos",
                        "razaoSocial": "SF MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1074289,
                        "codigo": "1872435",
                        "tag": "Todos",
                        "razaoSocial": "REI DAS LAJES E MATERIAIS DE",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1074462,
                        "codigo": "1872503",
                        "tag": "Todos",
                        "razaoSocial": "46 459 680 JARBAS FERNANDES CUNHA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1074563,
                        "codigo": "1872544",
                        "tag": "Todos",
                        "razaoSocial": "JOAO DE OLIVEIRA CUNHA COMERCIO DE",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1074576,
                        "codigo": "1872577",
                        "tag": "Todos",
                        "razaoSocial": "C N DE PROENCA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1074854,
                        "codigo": "1872742",
                        "tag": "Todos",
                        "razaoSocial": "FELIPE DA SILVA DE SA 14018708726",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1074921,
                        "codigo": "1872830",
                        "tag": "Todos",
                        "razaoSocial": "LEONARDO BERTOLO MEZA 42125504820",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 1075579,
                        "codigo": "1873253",
                        "tag": "Todos",
                        "razaoSocial": "BHL CONSTRUCOES LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1075795,
                        "codigo": "1873423",
                        "tag": "Todos",
                        "razaoSocial": "53 389 122 ERNANI DA SILVA LOURENCO",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1076816,
                        "codigo": "1874161",
                        "tag": "Todos",
                        "razaoSocial": "MATERIAS DE CONSTRUCAO E BAZAR TEM",
                        "media3Meses": 2,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 1077337,
                        "codigo": "1874490",
                        "tag": "Todos",
                        "razaoSocial": "R&A FORTES CONSTRUCOES LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 1079474,
                        "codigo": "1875977",
                        "tag": "Todos",
                        "razaoSocial": "MAIS BARATO MATERIAL DE CONSTRUCAO",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1081732,
                        "codigo": "1877523",
                        "tag": "Todos",
                        "razaoSocial": "62.613.269 TATIANE BRUM CASTELLO",
                        "media3Meses": 3,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 4
                            }
                        ]
                    },
                    {
                        "id": 1082633,
                        "codigo": "1878101",
                        "tag": "Todos",
                        "razaoSocial": "54 399 721 JOSE PAULO DOS SANTOS",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 1082634,
                        "codigo": "1878102",
                        "tag": "Todos",
                        "razaoSocial": "59.849.659 GILLIANE DA SILVA MOREIR",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1082793,
                        "codigo": "1878206",
                        "tag": "Todos",
                        "razaoSocial": "JANDERSON FELICIANO DE LIMA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1082947,
                        "codigo": "1878298",
                        "tag": "Todos",
                        "razaoSocial": "51.482.850 LUANA ABREU DE OLIVEIRA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1082969,
                        "codigo": "1878331",
                        "tag": "Todos",
                        "razaoSocial": "ANDERSON LUCAS DA FONSECA",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 1085578,
                        "codigo": "1880103",
                        "tag": "Todos",
                        "razaoSocial": "V. DE OLIVEIRA CRUZ",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 1085618,
                        "codigo": "1880161",
                        "tag": "Todos",
                        "razaoSocial": "ANDREA SILVA DE AMORIM 07263662426",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 1085653,
                        "codigo": "1880188",
                        "tag": "Todos",
                        "razaoSocial": "55.297.971 GABRIEL HENRIQUE",
                        "media3Meses": 3,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 1085675,
                        "codigo": "1880221",
                        "tag": "Todos",
                        "razaoSocial": "23 205 286 ROGERIO ASSIS DA SILVA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1087447,
                        "codigo": "1881449",
                        "tag": "Todos",
                        "razaoSocial": "62 761 268 JOSE LOPES DE MAGALHAES",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 1088766,
                        "codigo": "1882385",
                        "tag": "Todos",
                        "razaoSocial": "56 659 408 JEAN CARLOS DA COSTA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1088775,
                        "codigo": "1882407",
                        "tag": "Todos",
                        "razaoSocial": "48 128 510 ROSICLEIA DE CASSIA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1090840,
                        "codigo": "1883892",
                        "tag": "Todos",
                        "razaoSocial": "57 707 666 ALYNE FLEURY PEREIRA DA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1090883,
                        "codigo": "1883931",
                        "tag": "Todos",
                        "razaoSocial": "A O DOS SANTOS MATERIAIS DE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1090898,
                        "codigo": "1883948",
                        "tag": "Todos",
                        "razaoSocial": "BAZAR DA PATY COMERCIO DE MATERIAIS",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1090901,
                        "codigo": "1883933",
                        "tag": "Todos",
                        "razaoSocial": "55 264 190 EDNALDO JOSE DA SILVA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1093408,
                        "codigo": "1885121",
                        "tag": "Todos",
                        "razaoSocial": "CARLOS EDUAR LIRIO RODRIGUES",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1093473,
                        "codigo": "1885185",
                        "tag": "Todos",
                        "razaoSocial": "L R H DA SILVA & CIA  LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 1101864,
                        "codigo": "1887000",
                        "tag": "Todos",
                        "razaoSocial": "BARUK MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1115190,
                        "codigo": "1883377",
                        "tag": "Todos",
                        "razaoSocial": "DUCOUTINHO BAZAR E MATERIAL DE",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1115199,
                        "codigo": "1884476",
                        "tag": "Todos",
                        "razaoSocial": "DOX BAZAR E MATERIAIS LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1115200,
                        "codigo": "1883331",
                        "tag": "Todos",
                        "razaoSocial": "C ALBERTO MAFRA CORREA LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 0,
                        "codigo": "CreatedAt",
                        "createdAt": "2026-07-08T09:10:09.083685"
                    }
                ]
            },
            {
                "id": 1041,
                "codigoVendedor": "272642",
                "nomeVendedor": "GUILHERME FELIPE DE SOUZA",
                "basesAutosservico": [
                    {
                        "id": -1,
                        "tag": "Card-Rota",
                        "card": {
                            "totalPedidos": 1,
                            "percentTotalPedidos": -1,
                            "percentPedidosWebCliente": 0,
                            "mixPedidosWebCliente": 0,
                            "percentPedidosWebVendedor": 1,
                            "mixPedidosWebVendedor": 1,
                            "percentOutros": 0,
                            "mixOutros": 0
                        }
                    },
                    {
                        "id": -2,
                        "tag": "Card-Todos",
                        "card": {
                            "totalPedidos": 90,
                            "percentTotalPedidos": -1,
                            "percentPedidosWebCliente": 0.32222222222222224,
                            "mixPedidosWebCliente": 1.8695652173913044,
                            "percentPedidosWebVendedor": 0.022222222222222223,
                            "mixPedidosWebVendedor": 2,
                            "percentOutros": 0.6555555555555556,
                            "mixOutros": 2.019607843137255
                        }
                    },
                    {
                        "id": 19206,
                        "codigo": "1719197",
                        "tag": "Rota",
                        "razaoSocial": "HENRIQUE CARLOS JULIO",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 6232,
                        "codigo": "1289531",
                        "tag": "Todos",
                        "razaoSocial": "SOLANGE FRANCISCA DA SILVA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 7596,
                        "codigo": "1807135",
                        "tag": "Todos",
                        "razaoSocial": "NOVA CANAA MATERIAIS PARA CONSTRUCA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 13852,
                        "codigo": "1373926",
                        "tag": "Todos",
                        "razaoSocial": "JJE MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 13888,
                        "codigo": "1232609",
                        "tag": "Todos",
                        "razaoSocial": "H  S  COMERCIO E SERVICOS   EIRELI",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 14481,
                        "codigo": "1518528",
                        "tag": "Todos",
                        "razaoSocial": "CRISTIANE SANTOS CORREIA 15144",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 14539,
                        "codigo": "1555651",
                        "tag": "Todos",
                        "razaoSocial": "CASTRO MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 16613,
                        "codigo": "1763413",
                        "tag": "Todos",
                        "razaoSocial": "DEPOSITO S A  DO BASICO AO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 16763,
                        "codigo": "1762654",
                        "tag": "Todos",
                        "razaoSocial": "50 080 677 MARINILZA BARBOSA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 19009,
                        "codigo": "1062278",
                        "tag": "Todos",
                        "razaoSocial": "CASA DE FERRAGENS E CHAVEIRO  O PER",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 19018,
                        "codigo": "1008840",
                        "tag": "Todos",
                        "razaoSocial": "SILVA & SILVA MATERIAIS PARA CONSTR",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 19206,
                        "codigo": "1719197",
                        "tag": "Todos",
                        "razaoSocial": "HENRIQUE CARLOS JULIO",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 19351,
                        "codigo": "1720708",
                        "tag": "Todos",
                        "razaoSocial": "EDSON DE OLIVEIRA 12823286896",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 19677,
                        "codigo": "1278313",
                        "tag": "Todos",
                        "razaoSocial": "P  C  DE OLIVEIRA ALVES CONSTRUCAO",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 19823,
                        "codigo": "1059414",
                        "tag": "Todos",
                        "razaoSocial": "R  DE A  PONTES",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 20401,
                        "codigo": "1444204",
                        "tag": "Todos",
                        "razaoSocial": "LUIZ MORALES SIMAO",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 20821,
                        "codigo": "1489426",
                        "tag": "Todos",
                        "razaoSocial": "NEW ESPERANCA FERRAMENTAS E",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 26080,
                        "codigo": "1785258",
                        "tag": "Todos",
                        "razaoSocial": "MAIS QUE ELETRICA LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 26376,
                        "codigo": "1699607",
                        "tag": "Todos",
                        "razaoSocial": "COMERCIAL DE TINTAS E FERRAGENS",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 26411,
                        "codigo": "1201817",
                        "tag": "Todos",
                        "razaoSocial": "CIRO PEREIRA DA SILVA JUNIOR",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 26809,
                        "codigo": "1724944",
                        "tag": "Todos",
                        "razaoSocial": "ANTOFAB COMERCIO DE MATERIAIS DE",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 27957,
                        "codigo": "1166791",
                        "tag": "Todos",
                        "razaoSocial": "IRMAOS BONIFACIO COMERCIO DE MATERI",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 28800,
                        "codigo": "1145708",
                        "tag": "Todos",
                        "razaoSocial": "OKAMOTO MATERIAIS PARA CONSTRUCAO L",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 28956,
                        "codigo": "1707152",
                        "tag": "Todos",
                        "razaoSocial": "JOSE ALVES DE LIMA 49213512600",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 29079,
                        "codigo": "1682916",
                        "tag": "Todos",
                        "razaoSocial": "34 863 453 THIAGO FERREIRA NETO",
                        "media3Meses": 4,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 29105,
                        "codigo": "1741810",
                        "tag": "Todos",
                        "razaoSocial": "JOSE NILTON SANTANA OLIVEIRA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 29342,
                        "codigo": "1060418",
                        "tag": "Todos",
                        "razaoSocial": "ROSANGELA ESTEVAM DE ARAUJO SIQUEIR",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 29625,
                        "codigo": "1508819",
                        "tag": "Todos",
                        "razaoSocial": "MARIA HELENA CAMARA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 29778,
                        "codigo": "1809390",
                        "tag": "Todos",
                        "razaoSocial": "NOVA TOMORI LAR & CONSTRUCAO LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 31156,
                        "codigo": "1714670",
                        "tag": "Todos",
                        "razaoSocial": "FABIOLA DINIZ AUGUSTO 34295641820",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 31184,
                        "codigo": "1685439",
                        "tag": "Todos",
                        "razaoSocial": "MERCIA LUIZA RIBEIRO PEREIRA DA",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 31185,
                        "codigo": "1688589",
                        "tag": "Todos",
                        "razaoSocial": "DIAS ENGENHARIA E CONSTRUCAO LTDA",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 31222,
                        "codigo": "1614409",
                        "tag": "Todos",
                        "razaoSocial": "M L GOMES MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 31285,
                        "codigo": "1488830",
                        "tag": "Todos",
                        "razaoSocial": "CASA DE FERRAGENS J F LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 31332,
                        "codigo": "1460604",
                        "tag": "Todos",
                        "razaoSocial": "RIBEIRO & CESAR LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 31450,
                        "codigo": "1384163",
                        "tag": "Todos",
                        "razaoSocial": "E S X MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 31457,
                        "codigo": "1387605",
                        "tag": "Todos",
                        "razaoSocial": "LUIZ CARLOS REIS LORENA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 31498,
                        "codigo": "1363052",
                        "tag": "Todos",
                        "razaoSocial": "DPJ MATERIAIS PARA CONSTRUCAO LTDA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            }
                        ]
                    },
                    {
                        "id": 31526,
                        "codigo": "1362381",
                        "tag": "Todos",
                        "razaoSocial": "ADEMARIO SOARES MEDEIROS 1519145489",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 31543,
                        "codigo": "1343108",
                        "tag": "Todos",
                        "razaoSocial": "MARCO ANTONIO MARIANO FILHO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 31547,
                        "codigo": "1326767",
                        "tag": "Todos",
                        "razaoSocial": "TAVARES & TAVARES CONSTRUCAO LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 31615,
                        "codigo": "1283406",
                        "tag": "Todos",
                        "razaoSocial": "CARINA PEREIRA MATERIAIS DE CONSTRU",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 31633,
                        "codigo": "1278129",
                        "tag": "Todos",
                        "razaoSocial": "A T K MINAMIGUTI & J H MINAMIGUTI L",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 31665,
                        "codigo": "1251926",
                        "tag": "Todos",
                        "razaoSocial": "MIRIAM ROSA DA SILVA MATERIAIS PARA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 31688,
                        "codigo": "1227534",
                        "tag": "Todos",
                        "razaoSocial": "FAMA MATERIAIS PARA CONSTRUCAO LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 31712,
                        "codigo": "1221147",
                        "tag": "Todos",
                        "razaoSocial": "ROSANA DE CAMPOS SIQUEIRA CESAR",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 31715,
                        "codigo": "1222247",
                        "tag": "Todos",
                        "razaoSocial": "J C  VIEIRA & OLIVEIRA MATERIAIS DE",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 31757,
                        "codigo": "1194548",
                        "tag": "Todos",
                        "razaoSocial": "L M DE JESUS CONSTRUCOES",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 31767,
                        "codigo": "1189320",
                        "tag": "Todos",
                        "razaoSocial": "MARCO GREINER EIRELI",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 31807,
                        "codigo": "1132829",
                        "tag": "Todos",
                        "razaoSocial": "JULIO CARDOSO LEAL",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 31818,
                        "codigo": "1080496",
                        "tag": "Todos",
                        "razaoSocial": "SCARPINI & SCARPINI LTDA",
                        "media3Meses": 3,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 31836,
                        "codigo": "1049066",
                        "tag": "Todos",
                        "razaoSocial": "JAIME PROCOPIO DA SILVA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 31853,
                        "codigo": "1055559",
                        "tag": "Todos",
                        "razaoSocial": "COIMBRA MATERIAIS PARA CONSTRUCOES",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 31863,
                        "codigo": "1060436",
                        "tag": "Todos",
                        "razaoSocial": "PROJETO MATERIAIS PARA CONSTRUCAO C",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 31880,
                        "codigo": "1061442",
                        "tag": "Todos",
                        "razaoSocial": "ERCILIO LESCURA FRANCA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 31894,
                        "codigo": "1061303",
                        "tag": "Todos",
                        "razaoSocial": "N A ROCHA & CIA LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 31925,
                        "codigo": "1000713",
                        "tag": "Todos",
                        "razaoSocial": "SIZENANDO E DENISE   BAZAR LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 32031,
                        "codigo": "1002290",
                        "tag": "Todos",
                        "razaoSocial": "MARE MANSA MATERIAIS PARA CONSTRUCA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 32413,
                        "codigo": "1794615",
                        "tag": "Todos",
                        "razaoSocial": "J E SANTOS MATERIAIS PARA CONSTRUCA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 32598,
                        "codigo": "1749917",
                        "tag": "Todos",
                        "razaoSocial": "JOAO PAULO MARQUES PAIVA MATERIAIS",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 32690,
                        "codigo": "1709132",
                        "tag": "Todos",
                        "razaoSocial": "50 937 706 DEBORA APARECIDA OLIVEIR",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 32691,
                        "codigo": "1710547",
                        "tag": "Todos",
                        "razaoSocial": "CELEIRO DA CONSTRUCAO LTDA",
                        "media3Meses": 2.6666666666666665,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            }
                        ]
                    },
                    {
                        "id": 32700,
                        "codigo": "1702246",
                        "tag": "Todos",
                        "razaoSocial": "SIDNEY SALES MATERIAIS PARA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 32724,
                        "codigo": "1701330",
                        "tag": "Todos",
                        "razaoSocial": "MARIA DA CONCEICAO ARAUJO SANTOS",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 32749,
                        "codigo": "1697258",
                        "tag": "Todos",
                        "razaoSocial": "T R DE CARVALHO COMERCIO DE",
                        "media3Meses": 4,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 32860,
                        "codigo": "1614361",
                        "tag": "Todos",
                        "razaoSocial": "LUIZ FELIPE LIMA DE LIRA",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 32871,
                        "codigo": "1623429",
                        "tag": "Todos",
                        "razaoSocial": "KIKO MATERIAIS PARA CONSTRUCAO EIRE",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 32893,
                        "codigo": "1607396",
                        "tag": "Todos",
                        "razaoSocial": "CASA E CONSTRUCAO NOSSA SENHORA DE",
                        "media3Meses": 3.3333333333333335,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 32910,
                        "codigo": "1604013",
                        "tag": "Todos",
                        "razaoSocial": "A RAMOS SANTOS",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 32914,
                        "codigo": "1570089",
                        "tag": "Todos",
                        "razaoSocial": "PAMELA LEAL ROCHA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 32916,
                        "codigo": "1605187",
                        "tag": "Todos",
                        "razaoSocial": "SEBASTIAO FERREIRA NETO COMERCIO DE",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 32925,
                        "codigo": "1564924",
                        "tag": "Todos",
                        "razaoSocial": "M FIGUEIRA DE FARIA & CIA LTDA",
                        "media3Meses": 3.6666666666666665,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 32936,
                        "codigo": "1534860",
                        "tag": "Todos",
                        "razaoSocial": "JENAILDA DOS ANJOS SANTOS",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 32963,
                        "codigo": "1511595",
                        "tag": "Todos",
                        "razaoSocial": "ANTONIO ALVES SOARES",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 32984,
                        "codigo": "1507829",
                        "tag": "Todos",
                        "razaoSocial": "VILA RICA MATERIAIS PARA CONSTRUCAO",
                        "media3Meses": 2,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 33011,
                        "codigo": "1507836",
                        "tag": "Todos",
                        "razaoSocial": "CASA DE FERRAGENS PONTA DA PRA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 33027,
                        "codigo": "1503803",
                        "tag": "Todos",
                        "razaoSocial": "FRANCISCA MAISA SILVA GOMES 1214393",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33055,
                        "codigo": "1485267",
                        "tag": "Todos",
                        "razaoSocial": "MARIA DAS GRACAS FIALHO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33078,
                        "codigo": "1499948",
                        "tag": "Todos",
                        "razaoSocial": "BRAZAO & CIA COMERCIO DE PLANTAS E",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33097,
                        "codigo": "1472264",
                        "tag": "Todos",
                        "razaoSocial": "MJM DE JESUS MATERIAIS",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33102,
                        "codigo": "1473462",
                        "tag": "Todos",
                        "razaoSocial": "AHMAD MOHAMAD HAMMOUD 09780735844",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33122,
                        "codigo": "1462849",
                        "tag": "Todos",
                        "razaoSocial": "CORES DA VILA COMERCIO DE TINTAS E",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33148,
                        "codigo": "1460973",
                        "tag": "Todos",
                        "razaoSocial": "NELSON MEDEIROS",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33168,
                        "codigo": "1451540",
                        "tag": "Todos",
                        "razaoSocial": "ANA PAULA FERREIRA SCHITTINI",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33213,
                        "codigo": "1446155",
                        "tag": "Todos",
                        "razaoSocial": "L M   MATERIAIS PARA CONSTRUCAO E S",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33257,
                        "codigo": "1417164",
                        "tag": "Todos",
                        "razaoSocial": "T K V MATERIAIS PARA CONSTRUCAO LTD",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33315,
                        "codigo": "1393852",
                        "tag": "Todos",
                        "razaoSocial": "S. J. DA SILVA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 33428,
                        "codigo": "1329967",
                        "tag": "Todos",
                        "razaoSocial": "CASA 51 COMERCIAL LTDA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0.5,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0.5,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33432,
                        "codigo": "1341578",
                        "tag": "Todos",
                        "razaoSocial": "CAROL CAROL   MATERIAIS PARA CONSTR",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33454,
                        "codigo": "1326027",
                        "tag": "Todos",
                        "razaoSocial": "MOHAMED ALI ABOU HAMIA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33460,
                        "codigo": "1317729",
                        "tag": "Todos",
                        "razaoSocial": "JOSE MARINHO SANTANA MATERIAIS PARA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 33477,
                        "codigo": "1298372",
                        "tag": "Todos",
                        "razaoSocial": "FABIO DOMINGOS PROCOPIO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33478,
                        "codigo": "1302048",
                        "tag": "Todos",
                        "razaoSocial": "CRYSLEY PUPO ROSARIO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33479,
                        "codigo": "1312682",
                        "tag": "Todos",
                        "razaoSocial": "ALECIO CAITANO CONSTRUCOES",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 33487,
                        "codigo": "1299538",
                        "tag": "Todos",
                        "razaoSocial": "FERRAGENS CANAL 7 LTDA",
                        "media3Meses": 2.6666666666666665,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33500,
                        "codigo": "1293072",
                        "tag": "Todos",
                        "razaoSocial": "J L BORGES MATERIAIS PARA CONSTRUCA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33571,
                        "codigo": "1197514",
                        "tag": "Todos",
                        "razaoSocial": "METHA PARAFUSOS E FERRAMENTAS LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33611,
                        "codigo": "1165728",
                        "tag": "Todos",
                        "razaoSocial": "ANTONIO CARLOS DE MORAIS   BAZAR E",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33612,
                        "codigo": "1182793",
                        "tag": "Todos",
                        "razaoSocial": "J  P  MENDES MATERIAIS PARA CONSTRU",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33642,
                        "codigo": "1164232",
                        "tag": "Todos",
                        "razaoSocial": "HIROSHIMA  MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 33695,
                        "codigo": "1097543",
                        "tag": "Todos",
                        "razaoSocial": "JOAO B  L  DOS SANTOS & CIA  LTDA",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33697,
                        "codigo": "1122498",
                        "tag": "Todos",
                        "razaoSocial": "R  C  FIGUEIRA MATERIAIS PARA CONST",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33722,
                        "codigo": "1091743",
                        "tag": "Todos",
                        "razaoSocial": "COMERCIAL AFONSO PENA MATERIAIS PAR",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 33747,
                        "codigo": "1078694",
                        "tag": "Todos",
                        "razaoSocial": "SABRINA DOURADO",
                        "media3Meses": 2,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 33763,
                        "codigo": "1049538",
                        "tag": "Todos",
                        "razaoSocial": "MARCELINO MATERIAS PARA CONSTRUCAO",
                        "media3Meses": 3.3333333333333335,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 5
                            }
                        ]
                    },
                    {
                        "id": 33770,
                        "codigo": "1050881",
                        "tag": "Todos",
                        "razaoSocial": "AGC DE OLIVEIRA CONSTRUCAO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33774,
                        "codigo": "1050129",
                        "tag": "Todos",
                        "razaoSocial": "J  L  DOS SANTOS   GUARUJA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33796,
                        "codigo": "1057728",
                        "tag": "Todos",
                        "razaoSocial": "DANIEL BRUNO PRAIA GRANDE",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33797,
                        "codigo": "1052057",
                        "tag": "Todos",
                        "razaoSocial": "MARTINS & MOLEIRO LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33798,
                        "codigo": "1055168",
                        "tag": "Todos",
                        "razaoSocial": "SABRINA ROCHA RIBEIRO ARRUDA",
                        "media3Meses": 4,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 8
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 33828,
                        "codigo": "1059676",
                        "tag": "Todos",
                        "razaoSocial": "MARCOS MOURA GUEDES",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33841,
                        "codigo": "1059736",
                        "tag": "Todos",
                        "razaoSocial": "SEVERINO SIMPLICIO MOREIRA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33865,
                        "codigo": "1061740",
                        "tag": "Todos",
                        "razaoSocial": "DOMINGOS BASTOS DOS SANTOS",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33890,
                        "codigo": "1062415",
                        "tag": "Todos",
                        "razaoSocial": "F S GOMES",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33892,
                        "codigo": "1062541",
                        "tag": "Todos",
                        "razaoSocial": "VALENTIM AUGUSTO MARTINS SOARES",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33907,
                        "codigo": "1046008",
                        "tag": "Todos",
                        "razaoSocial": "NATHALIA DE ANDRADE MARTINS",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 33927,
                        "codigo": "1039369",
                        "tag": "Todos",
                        "razaoSocial": "ELIANA ANGELICA FONTES MARTINEZ",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 33930,
                        "codigo": "1039351",
                        "tag": "Todos",
                        "razaoSocial": "ROGERIO Z. DE LIMA - BAZAR",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 33955,
                        "codigo": "1030538",
                        "tag": "Todos",
                        "razaoSocial": "CRUZ DE MALTA MATERIAIS PARA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 34168,
                        "codigo": "1002897",
                        "tag": "Todos",
                        "razaoSocial": "DAVID M  GUARDA COMERCIO DE MATERIA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 34523,
                        "codigo": "1745412",
                        "tag": "Todos",
                        "razaoSocial": "CARLOS DE SOUZA MAGALHAES MODU",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 34538,
                        "codigo": "1484539",
                        "tag": "Todos",
                        "razaoSocial": "COMERCIO DE MATERIAL PARA CONS",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 34539,
                        "codigo": "1766702",
                        "tag": "Todos",
                        "razaoSocial": "FAMAX MATERIAIS PARA CONSTRUCOES",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 37946,
                        "codigo": "1695682",
                        "tag": "Todos",
                        "razaoSocial": "CASA & ALICERCE MATERIAIS PARA",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 37971,
                        "codigo": "1647932",
                        "tag": "Todos",
                        "razaoSocial": "DEPOSITO ZR COMERCIO DE MATERIAIS D",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 37982,
                        "codigo": "1644883",
                        "tag": "Todos",
                        "razaoSocial": "ALLAN FREITAS DA FONSECA 4208606185",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 37985,
                        "codigo": "1591606",
                        "tag": "Todos",
                        "razaoSocial": "LINDONALDO FRANCISCO DE SOUZA 26664",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 38003,
                        "codigo": "1520836",
                        "tag": "Todos",
                        "razaoSocial": "WAGNER DE ANDRADE SAMPAIO 312691408",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 38005,
                        "codigo": "1559963",
                        "tag": "Todos",
                        "razaoSocial": "UNIVERSO ESTRELAR MATERIAIS PARA CO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 38006,
                        "codigo": "1557019",
                        "tag": "Todos",
                        "razaoSocial": "SKINA COMERCIO DE MATERIAIS DE CONS",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 38019,
                        "codigo": "1483614",
                        "tag": "Todos",
                        "razaoSocial": "SAURO LAREDONDO FIGUEIREDO 03781539",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 38028,
                        "codigo": "1455088",
                        "tag": "Todos",
                        "razaoSocial": "AGUA AZUL COMERCIO DE MATERIAIS PAR",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 38037,
                        "codigo": "1449698",
                        "tag": "Todos",
                        "razaoSocial": "LOJA DE MATERIAIS PARA CONSTRUCAO H",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 38044,
                        "codigo": "1450079",
                        "tag": "Todos",
                        "razaoSocial": "BRITOS COMERCIO DE MATERIAIS PARA C",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 38055,
                        "codigo": "1354148",
                        "tag": "Todos",
                        "razaoSocial": "JOAO EVANGELISTA FONTENELE",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 38057,
                        "codigo": "1387995",
                        "tag": "Todos",
                        "razaoSocial": "I L DE SOUZA MATERIAIS DE CONSTRUCA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 38066,
                        "codigo": "1240976",
                        "tag": "Todos",
                        "razaoSocial": "J.E. SENA COMERCIO DE MATERIAIS PAR",
                        "media3Meses": 3.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 38068,
                        "codigo": "1246189",
                        "tag": "Todos",
                        "razaoSocial": "RIO VERDE MADEIRA & CONSTRUCOES LTD",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 38096,
                        "codigo": "1214854",
                        "tag": "Todos",
                        "razaoSocial": "LILIAN KELLY VIEIRA DE SOUZA MATERI",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 38104,
                        "codigo": "1053281",
                        "tag": "Todos",
                        "razaoSocial": "KM 12 DEPOSITO DE MATERIAIS PARA CO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 38105,
                        "codigo": "1082613",
                        "tag": "Todos",
                        "razaoSocial": "DINO LAR SUL MATERIAIS PARA CONSTRU",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 38112,
                        "codigo": "1054961",
                        "tag": "Todos",
                        "razaoSocial": "CENTER PRIMAX MATERIAIS PARA CONSTR",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 38126,
                        "codigo": "1795969",
                        "tag": "Todos",
                        "razaoSocial": "MATERIAIS GAIVOTAS LTDA",
                        "media3Meses": 2.6666666666666665,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 40326,
                        "codigo": "1227595",
                        "tag": "Todos",
                        "razaoSocial": "DEPOSITO 24 HORAS MATERIAIS DE",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 40328,
                        "codigo": "1243038",
                        "tag": "Todos",
                        "razaoSocial": "COMERCIO DE FERRAGENS SANTA RITA",
                        "media3Meses": 3.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 42707,
                        "codigo": "1460147",
                        "tag": "Todos",
                        "razaoSocial": "DISTRIBUIDORA TEVAL DE MATERIAIS P/",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 43746,
                        "codigo": "1700905",
                        "tag": "Todos",
                        "razaoSocial": "COMERCIO DE MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 50307,
                        "codigo": "1755683",
                        "tag": "Todos",
                        "razaoSocial": "VAREJAO TINTAS LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 52343,
                        "codigo": "1703943",
                        "tag": "Todos",
                        "razaoSocial": "COMERCIO DE FERRAGENS SHIROMA LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53556,
                        "codigo": "1546111",
                        "tag": "Todos",
                        "razaoSocial": "GMF COMERCIO DE MATERIAIS PARA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53708,
                        "codigo": "1503765",
                        "tag": "Todos",
                        "razaoSocial": "CONSTRUMIX DEPOSITO DE MATERIAIS DE",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53742,
                        "codigo": "1484015",
                        "tag": "Todos",
                        "razaoSocial": "COMERCIAL DECOVAN LTDA",
                        "media3Meses": 4.666666666666667,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 54885,
                        "codigo": "1534999",
                        "tag": "Todos",
                        "razaoSocial": "CONTINENTAL CENTER MATERIAIS E",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 54944,
                        "codigo": "1519921",
                        "tag": "Todos",
                        "razaoSocial": "JOSE DE FATIMA TEIXEIRA   MATE",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 54954,
                        "codigo": "1514482",
                        "tag": "Todos",
                        "razaoSocial": "VALDINEI DOS SANTOS 30256752842",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 55600,
                        "codigo": "1436133",
                        "tag": "Todos",
                        "razaoSocial": "JOSE DA COSTA GANDRA 17300206824",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 55799,
                        "codigo": "1396780",
                        "tag": "Todos",
                        "razaoSocial": "HELOU COMERCIAL LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 57207,
                        "codigo": "1054082",
                        "tag": "Todos",
                        "razaoSocial": "DEPOSITO CATARINENSE MATERIAIS PARA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 57222,
                        "codigo": "1053829",
                        "tag": "Todos",
                        "razaoSocial": "MATERIAIS DE CONSTRUCAO CENTOFANTE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 57718,
                        "codigo": "1001605",
                        "tag": "Todos",
                        "razaoSocial": "EMPORIO REBELO LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 57725,
                        "codigo": "1001980",
                        "tag": "Todos",
                        "razaoSocial": "J  P  MENDES CONSTRUCAO",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58224,
                        "codigo": "1780126",
                        "tag": "Todos",
                        "razaoSocial": "38.280.413 LETICIA REIS DE FREITAS",
                        "media3Meses": 3,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 58247,
                        "codigo": "1779853",
                        "tag": "Todos",
                        "razaoSocial": "N S PAES",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58453,
                        "codigo": "1734175",
                        "tag": "Todos",
                        "razaoSocial": "50.691.224 GABRIEL CARDOSO DE BRITO",
                        "media3Meses": 4,
                        "pedidosMesAtual": 3,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 58492,
                        "codigo": "1720522",
                        "tag": "Todos",
                        "razaoSocial": "GONZALES ELETRICA E HIDRAULICA LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58499,
                        "codigo": "1730725",
                        "tag": "Todos",
                        "razaoSocial": "WM-SUL MATERIAIS PARA CONSTRUCAO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58506,
                        "codigo": "1725440",
                        "tag": "Todos",
                        "razaoSocial": "BOLIBRAS COMERCIO DE FERRAMENTAS",
                        "media3Meses": 3.6666666666666665,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58530,
                        "codigo": "1729071",
                        "tag": "Todos",
                        "razaoSocial": "LAJES VIGAL COMERCIO LTDA.",
                        "media3Meses": 2,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58543,
                        "codigo": "1728766",
                        "tag": "Todos",
                        "razaoSocial": "LOJAO DO TURCO COMERCIO DE MATERIAS",
                        "media3Meses": 2,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 58544,
                        "codigo": "1725881",
                        "tag": "Todos",
                        "razaoSocial": "LOJAO DO TURCO COMERCIO DE MATERIAS",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58596,
                        "codigo": "1703927",
                        "tag": "Todos",
                        "razaoSocial": "BERMAPACK MATERIAIS PARA CONSTRUCAO",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 58603,
                        "codigo": "1713852",
                        "tag": "Todos",
                        "razaoSocial": "DENI SUTOPO",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58610,
                        "codigo": "1713909",
                        "tag": "Todos",
                        "razaoSocial": "M DO CARMO MARQUES RIBEIRO MATERIAL",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58637,
                        "codigo": "1716484",
                        "tag": "Todos",
                        "razaoSocial": "EMERSON MARTINS 22517055890",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58724,
                        "codigo": "1688215",
                        "tag": "Todos",
                        "razaoSocial": "CAIRES & PESSOA   MATERIAL PARA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58748,
                        "codigo": "1469992",
                        "tag": "Todos",
                        "razaoSocial": "PEDRO ANDE CAVALCANTE - COMERCIO",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58788,
                        "codigo": "1696447",
                        "tag": "Todos",
                        "razaoSocial": "7FL COMERCIO DE MATERIAIS PARA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58895,
                        "codigo": "1686189",
                        "tag": "Todos",
                        "razaoSocial": "38 255 447 MAURICIO DIAS DA SILVA",
                        "media3Meses": 6.666666666666667,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 8
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 8
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 59224,
                        "codigo": "1618029",
                        "tag": "Todos",
                        "razaoSocial": "CONSTRU BA MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 59348,
                        "codigo": "1597908",
                        "tag": "Todos",
                        "razaoSocial": "AVANCAR MATERIAIS PARA CONSTRUCAO L",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 59366,
                        "codigo": "1594657",
                        "tag": "Todos",
                        "razaoSocial": "NDP MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 59417,
                        "codigo": "1602740",
                        "tag": "Todos",
                        "razaoSocial": "LEYLAND COMERCIO DE MATERIAIS PARA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 59556,
                        "codigo": "1561974",
                        "tag": "Todos",
                        "razaoSocial": "VALERIA FERREIRA BRITO 46812602825",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 59594,
                        "codigo": "1569179",
                        "tag": "Todos",
                        "razaoSocial": "ANTONIO ALMIR BATISTA 48832618168",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 59817,
                        "codigo": "1682041",
                        "tag": "Todos",
                        "razaoSocial": "IRMAOS ARCANJO MATERIAIS PARA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 59867,
                        "codigo": "1651523",
                        "tag": "Todos",
                        "razaoSocial": "FERRAGENS ANA COSTA LTDA",
                        "media3Meses": 6,
                        "pedidosMesAtual": 3,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 10
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 9
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 12
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 9
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 107737,
                        "codigo": "1769112",
                        "tag": "Todos",
                        "razaoSocial": "MIX AREIA E PEDRA LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 107759,
                        "codigo": "1699831",
                        "tag": "Todos",
                        "razaoSocial": "FRANCIELI ISIS RESENDE SILVA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 107765,
                        "codigo": "1686959",
                        "tag": "Todos",
                        "razaoSocial": "RYI 2 MATERIAIS PARA CONSTRUCAO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 108018,
                        "codigo": "1329398",
                        "tag": "Todos",
                        "razaoSocial": "MARIA GORETTI LEME DA SILVA D ELEUT",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 114478,
                        "codigo": "1792893",
                        "tag": "Todos",
                        "razaoSocial": "J A  PEREIRA MATERIAL DE CONSTRUCOE",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 175806,
                        "codigo": "1711821",
                        "tag": "Todos",
                        "razaoSocial": "NOVA CONSTRUFORT SANTOS MATERIAIS",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 197437,
                        "codigo": "1060103",
                        "tag": "Todos",
                        "razaoSocial": "LUCI GUARISI STRINGARI",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 218414,
                        "codigo": "1377075",
                        "tag": "Todos",
                        "razaoSocial": "DIOGO GILBERTO PAULINI HELOU",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 226276,
                        "codigo": "1614246",
                        "tag": "Todos",
                        "razaoSocial": "VIZIL COMERCIO DE MATERIAIS PARA CO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 360325,
                        "codigo": "1817197",
                        "tag": "Todos",
                        "razaoSocial": "PRA TRANSPORTES & COMERCIO DE",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 642526,
                        "codigo": "1834696",
                        "tag": "Todos",
                        "razaoSocial": "52 942 048 SOLANGE DE MIRANDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 642757,
                        "codigo": "1834790",
                        "tag": "Todos",
                        "razaoSocial": "HAMILTON DE JESUS CONCEICAO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 646951,
                        "codigo": "1731894",
                        "tag": "Todos",
                        "razaoSocial": "CONSTROI MADEIREIRA E CONSTRUCAO",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 647614,
                        "codigo": "1837088",
                        "tag": "Todos",
                        "razaoSocial": "RAINHA DA CONSTRUCAO LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 647983,
                        "codigo": "1837345",
                        "tag": "Todos",
                        "razaoSocial": "SALLES COMERCIO DE TINTAS E",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 664855,
                        "codigo": "1843839",
                        "tag": "Todos",
                        "razaoSocial": "ALEXANDRE RIBEIRO DE OLIVEIRA",
                        "media3Meses": 3.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 669580,
                        "codigo": "1846452",
                        "tag": "Todos",
                        "razaoSocial": "57 376 187 GABRIELLE CRISTINE",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 676039,
                        "codigo": "1851292",
                        "tag": "Todos",
                        "razaoSocial": "VICTORIA C D DE ARAUJO",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 753682,
                        "codigo": "1482100",
                        "tag": "Todos",
                        "razaoSocial": "NICK COMERCIO DE MATERIAIS PARA CON",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 905925,
                        "codigo": "1329383",
                        "tag": "Todos",
                        "razaoSocial": "MARILAINE M M DE AZEVEDO LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 921817,
                        "codigo": "1196836",
                        "tag": "Todos",
                        "razaoSocial": "AURORA DA MANTIQUEIRA MATERIAIS LTD",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 932473,
                        "codigo": "1624949",
                        "tag": "Todos",
                        "razaoSocial": "O GRANDE MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1062981,
                        "codigo": "1866536",
                        "tag": "Todos",
                        "razaoSocial": "A J D ABDENOR MATERIAL DE CONSTRUCA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 1063642,
                        "codigo": "1867020",
                        "tag": "Todos",
                        "razaoSocial": "ANTONIO FRANCISCO DOS SANTOS",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1066840,
                        "codigo": "1868425",
                        "tag": "Todos",
                        "razaoSocial": "JULIO & SANTOS E COMMERCE LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1068761,
                        "codigo": "1868698",
                        "tag": "Todos",
                        "razaoSocial": "LORENFER INDUSTRIA E COMERCIO DE",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1069691,
                        "codigo": "1869343",
                        "tag": "Todos",
                        "razaoSocial": "HADUAN ABES MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1072834,
                        "codigo": "1871414",
                        "tag": "Todos",
                        "razaoSocial": "AURECI PEDRO DA SILVA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1074037,
                        "codigo": "1872215",
                        "tag": "Todos",
                        "razaoSocial": "12 369 483 RICARDO BASTOS DE MATOS",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1074048,
                        "codigo": "1872241",
                        "tag": "Todos",
                        "razaoSocial": "ARIZEU JANUARIO DOS SANTOS",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1074515,
                        "codigo": "1872517",
                        "tag": "Todos",
                        "razaoSocial": "58 912 934 DAVI NUNIS BATISTA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1074529,
                        "codigo": "1872532",
                        "tag": "Todos",
                        "razaoSocial": "61 058 394 DANIEL DE SIQUEIRA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 1074578,
                        "codigo": "1872575",
                        "tag": "Todos",
                        "razaoSocial": "DENIVALDO DA SILVA TEIXEIRA SARAPUI",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1074703,
                        "codigo": "1872634",
                        "tag": "Todos",
                        "razaoSocial": "61 350 141 LUCILENE APARECIDA DE",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1075277,
                        "codigo": "1873061",
                        "tag": "Todos",
                        "razaoSocial": "61 106 991 WANDERLEI ROCHA PEREIRA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 1075312,
                        "codigo": "1873069",
                        "tag": "Todos",
                        "razaoSocial": "50 109 582 FLAVIO ALBERTO GHISINI",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 1075470,
                        "codigo": "1873191",
                        "tag": "Todos",
                        "razaoSocial": "48 923 105 MARCOS RIBEIRO TUPAN",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 1075695,
                        "codigo": "1873436",
                        "tag": "Todos",
                        "razaoSocial": "LJT DO TURCO COMERCIO DE MATERIAIS",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1075738,
                        "codigo": "1873397",
                        "tag": "Todos",
                        "razaoSocial": "NASCIMENTO MARQUES E FERREIRA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1076640,
                        "codigo": "1874042",
                        "tag": "Todos",
                        "razaoSocial": "61 087 299 APARECIDA DE FATIMA SILV",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1078597,
                        "codigo": "1875356",
                        "tag": "Todos",
                        "razaoSocial": "EMERGENCY HOUSE COMERCIAL LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 1079477,
                        "codigo": "1875986",
                        "tag": "Todos",
                        "razaoSocial": "ADELMO MATERIAIS PARA CONSTRUCAO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1079847,
                        "codigo": "1876229",
                        "tag": "Todos",
                        "razaoSocial": "JOSE GONCALO DE JACOB FILHO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1079851,
                        "codigo": "1876251",
                        "tag": "Todos",
                        "razaoSocial": "49.598.482 GILSON PEDREIRA DOS",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1082638,
                        "codigo": "1878097",
                        "tag": "Todos",
                        "razaoSocial": "ANTONIA MICAELE DA SILVA PAIVA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1082952,
                        "codigo": "1878305",
                        "tag": "Todos",
                        "razaoSocial": "61.133.900 VANDA DIAS ARANHA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1085572,
                        "codigo": "1880102",
                        "tag": "Todos",
                        "razaoSocial": "JN ConstruCenter LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1085591,
                        "codigo": "1880146",
                        "tag": "Todos",
                        "razaoSocial": "EVANDRO JANUARIO DA SILVA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1085602,
                        "codigo": "1880152",
                        "tag": "Todos",
                        "razaoSocial": "18.108.382 ALINE JORGE DA SILVA",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1085620,
                        "codigo": "1880145",
                        "tag": "Todos",
                        "razaoSocial": "CARLOS ALBERTO DE SOUZA 10166944823",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1086118,
                        "codigo": "1880543",
                        "tag": "Todos",
                        "razaoSocial": "MOREIRA MATERIAL PARA CONSTRUCAO",
                        "media3Meses": 3.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1088454,
                        "codigo": "1882216",
                        "tag": "Todos",
                        "razaoSocial": "55 698 851 EDILSON DA TRINDADE DIAS",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1088457,
                        "codigo": "1882218",
                        "tag": "Todos",
                        "razaoSocial": "47 681 492 MILAR NUNES ALVES MARTIN",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1088725,
                        "codigo": "1882358",
                        "tag": "Todos",
                        "razaoSocial": "E S P   MATERIAIS ELETRICOS LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1088744,
                        "codigo": "1882374",
                        "tag": "Todos",
                        "razaoSocial": "BETEL MATERIAIS ELETRICOS E",
                        "media3Meses": 2,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 1088770,
                        "codigo": "1882405",
                        "tag": "Todos",
                        "razaoSocial": "58 119 473 ANA PAULA GONCALVES DA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1090913,
                        "codigo": "1883964",
                        "tag": "Todos",
                        "razaoSocial": "JOAO ALVES DA SILVA 71328327434",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 1093479,
                        "codigo": "1885169",
                        "tag": "Todos",
                        "razaoSocial": "C  J  QUEIROZ DO O   COMERCIO DE",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1093507,
                        "codigo": "1885214",
                        "tag": "Todos",
                        "razaoSocial": "58 866 197 JOAO VICTOR FERREIRA DA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1106546,
                        "codigo": "1887457",
                        "tag": "Todos",
                        "razaoSocial": "TADEU COMERCIO DE MATERIAL ELETRICO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1107789,
                        "codigo": "1888512",
                        "tag": "Todos",
                        "razaoSocial": "J&M MATERIAIS PARA CONSTRUCAO LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1108152,
                        "codigo": "1888774",
                        "tag": "Todos",
                        "razaoSocial": "GERSON RIBEIRO DOS SANTOS",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 0,
                        "codigo": "CreatedAt",
                        "createdAt": "2026-07-08T09:10:08.9063978"
                    }
                ]
            },
            {
                "id": 1415,
                "codigoVendedor": "90122447",
                "nomeVendedor": "Magalhães Representações",
                "basesAutosservico": [
                    {
                        "id": -1,
                        "tag": "Card-Rota",
                        "card": {
                            "totalPedidos": 0,
                            "percentTotalPedidos": 1,
                            "percentPedidosWebCliente": 0,
                            "mixPedidosWebCliente": 0,
                            "percentPedidosWebVendedor": 0,
                            "mixPedidosWebVendedor": 0,
                            "percentOutros": 0,
                            "mixOutros": 0
                        }
                    },
                    {
                        "id": -2,
                        "tag": "Card-Todos",
                        "card": {
                            "totalPedidos": 10,
                            "percentTotalPedidos": -1,
                            "percentPedidosWebCliente": 0.1,
                            "mixPedidosWebCliente": 1,
                            "percentPedidosWebVendedor": 0.8,
                            "mixPedidosWebVendedor": 1.5,
                            "percentOutros": 0.1,
                            "mixOutros": 1
                        }
                    },
                    {
                        "id": 6329,
                        "codigo": "1442511",
                        "tag": "Todos",
                        "razaoSocial": "INDUSTRIA E COMERCIO DE PRE-MOLDADO",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 6374,
                        "codigo": "1802567",
                        "tag": "Todos",
                        "razaoSocial": "SSG PRE MOLDADOS E SERVICOS LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "SERVIÇOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 6432,
                        "codigo": "1738297",
                        "tag": "Todos",
                        "razaoSocial": "GRUPO SOLO CONSTRUTORA E MATERIAL D",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 8134,
                        "codigo": "1489015",
                        "tag": "Todos",
                        "razaoSocial": "SCHAEFFER MATERIAL DE CONSTRUCAO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 13256,
                        "codigo": "1501585",
                        "tag": "Todos",
                        "razaoSocial": "JM NEGRIS MATERIAL DE CONSTRUCAO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 16518,
                        "codigo": "1727288",
                        "tag": "Todos",
                        "razaoSocial": "GUSTAVO ASSIS ROSSI 16156964746",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 27135,
                        "codigo": "1790870",
                        "tag": "Todos",
                        "razaoSocial": "BASE COMERCIO E LOCACAO DE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 29368,
                        "codigo": "1636338",
                        "tag": "Todos",
                        "razaoSocial": "EVANDRO ARAUJO SAMPAIO",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 60727,
                        "codigo": "1783053",
                        "tag": "Todos",
                        "razaoSocial": "52 806 855 JANDUI HUPP SOUZA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 249543,
                        "codigo": "1501359",
                        "tag": "Todos",
                        "razaoSocial": "CASA MATERIAL DE CONSTRUCAO LT",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 249748,
                        "codigo": "1469308",
                        "tag": "Todos",
                        "razaoSocial": "MARCOS BUSSU LIMA LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250415,
                        "codigo": "1506220",
                        "tag": "Todos",
                        "razaoSocial": "THAIZ LIMA ROCHA DA SILVA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250516,
                        "codigo": "1781627",
                        "tag": "Todos",
                        "razaoSocial": "GAMA PRE-MOLDADOS LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250519,
                        "codigo": "1749990",
                        "tag": "Todos",
                        "razaoSocial": "SIVAL TRAMES",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250561,
                        "codigo": "1492402",
                        "tag": "Todos",
                        "razaoSocial": "MEGA MONT LAJES E PRE MOLDADOS LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250563,
                        "codigo": "1440980",
                        "tag": "Todos",
                        "razaoSocial": "MATERIAL DE CONSTRUCAO CM LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250565,
                        "codigo": "1632011",
                        "tag": "Todos",
                        "razaoSocial": "NORTRON MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250569,
                        "codigo": "1495783",
                        "tag": "Todos",
                        "razaoSocial": "TIAGO TEIXEIRA DA SILVA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250642,
                        "codigo": "1650732",
                        "tag": "Todos",
                        "razaoSocial": "M M  CONSTRUCOES E EDIFICACOES   EI",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250647,
                        "codigo": "1669676",
                        "tag": "Todos",
                        "razaoSocial": "AMARAL MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 250648,
                        "codigo": "1639260",
                        "tag": "Todos",
                        "razaoSocial": "MARCUS ROGERIO FAGUNDES",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250651,
                        "codigo": "1702435",
                        "tag": "Todos",
                        "razaoSocial": "JAQUELINE SOUZA BOLDRINI",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250653,
                        "codigo": "1427179",
                        "tag": "Todos",
                        "razaoSocial": "PINDUCAS ACABAMENTOS LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250655,
                        "codigo": "1625645",
                        "tag": "Todos",
                        "razaoSocial": "ELIO BATISTA CARVALHO",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250657,
                        "codigo": "1722211",
                        "tag": "Todos",
                        "razaoSocial": "LORENZONI CONSTRUCAO LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250658,
                        "codigo": "1469306",
                        "tag": "Todos",
                        "razaoSocial": "NORTON MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 3,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 5
                            }
                        ]
                    },
                    {
                        "id": 250702,
                        "codigo": "1501808",
                        "tag": "Todos",
                        "razaoSocial": "FERMACON   FERNANDES MATERIAIS DE",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 250732,
                        "codigo": "1427201",
                        "tag": "Todos",
                        "razaoSocial": "PINAFFO CONSTRUCAO E ACABAMENTOS",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 251310,
                        "codigo": "1746374",
                        "tag": "Todos",
                        "razaoSocial": "Z  M  MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253328,
                        "codigo": "1430970",
                        "tag": "Todos",
                        "razaoSocial": "CACHIMBAL MATERIAL DE CONSTRUCAO E",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253362,
                        "codigo": "1795797",
                        "tag": "Todos",
                        "razaoSocial": "FERMACON CONSTRUTORA LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 253415,
                        "codigo": "1453296",
                        "tag": "Todos",
                        "razaoSocial": "DEPRACON MADEIRAS LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253420,
                        "codigo": "1489017",
                        "tag": "Todos",
                        "razaoSocial": "LILIA APARECIDA ALVES GAMA BLOCOS",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 253425,
                        "codigo": "1501942",
                        "tag": "Todos",
                        "razaoSocial": "DEIVISSON PAULO RODRIGUES",
                        "media3Meses": 2.6666666666666665,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            }
                        ]
                    },
                    {
                        "id": 253428,
                        "codigo": "1506153",
                        "tag": "Todos",
                        "razaoSocial": "NEGRIS CONSTRUCAO LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253527,
                        "codigo": "1721548",
                        "tag": "Todos",
                        "razaoSocial": "REGIL MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253532,
                        "codigo": "1655106",
                        "tag": "Todos",
                        "razaoSocial": "ALIANCA CONSTRUTORA & CORRETORA LTD",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "SERVIÇOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253537,
                        "codigo": "1490251",
                        "tag": "Todos",
                        "razaoSocial": "ATILA FERRARI",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253539,
                        "codigo": "1427292",
                        "tag": "Todos",
                        "razaoSocial": "MININO MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 253628,
                        "codigo": "1505769",
                        "tag": "Todos",
                        "razaoSocial": "FERRARI CONSTRULAR MATERIAL DE",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253738,
                        "codigo": "1749106",
                        "tag": "Todos",
                        "razaoSocial": "GV CONSTRUTORA LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253739,
                        "codigo": "1684650",
                        "tag": "Todos",
                        "razaoSocial": "PEREIRA E ATAIDES LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253741,
                        "codigo": "1459970",
                        "tag": "Todos",
                        "razaoSocial": "MARCON MADEIRAS LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253746,
                        "codigo": "1694092",
                        "tag": "Todos",
                        "razaoSocial": "CONSTRUTORA MARTELLO LTDA",
                        "media3Meses": 2,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 253861,
                        "codigo": "1500561",
                        "tag": "Todos",
                        "razaoSocial": "INCOMOL COMERCIO DE MADEIRA E",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 269265,
                        "codigo": "1494251",
                        "tag": "Todos",
                        "razaoSocial": "CONSTRULAR BORSOI LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 293920,
                        "codigo": "1427207",
                        "tag": "Todos",
                        "razaoSocial": "PINAFFO E ZANI LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 295410,
                        "codigo": "1492219",
                        "tag": "Todos",
                        "razaoSocial": "UESLEI MUNIZ DA SILVA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 295420,
                        "codigo": "1456741",
                        "tag": "Todos",
                        "razaoSocial": "IVANIA RAASCH",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 295423,
                        "codigo": "1459722",
                        "tag": "Todos",
                        "razaoSocial": "ALVES SHOPPING DA CONSTRUCAO LTDA",
                        "media3Meses": 6.666666666666667,
                        "pedidosMesAtual": 3,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 8
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 8
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 396244,
                        "codigo": "1779227",
                        "tag": "Todos",
                        "razaoSocial": "CLSSOUZA INDUSTRIA E COMERCIO DE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 447009,
                        "codigo": "1826560",
                        "tag": "Todos",
                        "razaoSocial": "P H C DE LEMOS TRANSPORTES",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 659718,
                        "codigo": "1840702",
                        "tag": "Todos",
                        "razaoSocial": "ECO MONTAGEM E MANUTENCAO LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 660482,
                        "codigo": "1841011",
                        "tag": "Todos",
                        "razaoSocial": "PEPE PREMOLDADOS E CONSTRUCOES LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 661272,
                        "codigo": "1841524",
                        "tag": "Todos",
                        "razaoSocial": "BELA VISTA SERVICOS E COMERCIO LTDA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "SERVIÇOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "SERVIÇOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 1045116,
                        "codigo": "1857158",
                        "tag": "Todos",
                        "razaoSocial": "CASAS DAS TINTAS LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1077801,
                        "codigo": "1874846",
                        "tag": "Todos",
                        "razaoSocial": "CONCEICAO APARECIDA ZORTEA LIMA",
                        "media3Meses": 2.6666666666666665,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            }
                        ]
                    },
                    {
                        "id": 0,
                        "codigo": "CreatedAt",
                        "createdAt": "2026-07-08T09:10:09.0222573"
                    }
                ]
            },
            {
                "id": 1238,
                "codigoVendedor": "269684",
                "nomeVendedor": "THIAGO FERREIRA DOS SANTOS",
                "basesAutosservico": [
                    {
                        "id": -1,
                        "tag": "Card-Rota",
                        "card": {
                            "totalPedidos": 0,
                            "percentTotalPedidos": 1,
                            "percentPedidosWebCliente": 0,
                            "mixPedidosWebCliente": 0,
                            "percentPedidosWebVendedor": 0,
                            "mixPedidosWebVendedor": 0,
                            "percentOutros": 0,
                            "mixOutros": 0
                        }
                    },
                    {
                        "id": -2,
                        "tag": "Card-Todos",
                        "card": {
                            "totalPedidos": 19,
                            "percentTotalPedidos": -1,
                            "percentPedidosWebCliente": 0.5263157894736842,
                            "mixPedidosWebCliente": 1.2857142857142858,
                            "percentPedidosWebVendedor": 0.3684210526315789,
                            "mixPedidosWebVendedor": 1,
                            "percentOutros": 0.10526315789473684,
                            "mixOutros": 1
                        }
                    },
                    {
                        "id": 7187,
                        "codigo": "1007420",
                        "tag": "Todos",
                        "razaoSocial": "ARACON MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 8336,
                        "codigo": "1708820",
                        "tag": "Todos",
                        "razaoSocial": "GOUVEIA MATERIAL DE CONSTRUCAO",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 8962,
                        "codigo": "1750085",
                        "tag": "Todos",
                        "razaoSocial": "11 022 246 TIAGO SATHLER DE SOUZA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 8963,
                        "codigo": "1710943",
                        "tag": "Todos",
                        "razaoSocial": "R A CONTILDES MATERIAL DE CONSTRUCA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 16812,
                        "codigo": "1789734",
                        "tag": "Todos",
                        "razaoSocial": "MJR DISTRIBUIDORA DE FERRO E CIMENT",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 19292,
                        "codigo": "1774511",
                        "tag": "Todos",
                        "razaoSocial": "ROSIMAR NEVES 78129532700",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 19717,
                        "codigo": "1306145",
                        "tag": "Todos",
                        "razaoSocial": "PALACIO DA CONSTRUCAO DE JACONE",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 24886,
                        "codigo": "1685097",
                        "tag": "Todos",
                        "razaoSocial": "M E L F   MATERIAIS DE CONSTRUCAO E",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 28293,
                        "codigo": "1670763",
                        "tag": "Todos",
                        "razaoSocial": "G R  DISTRIBUIDORA DE CIMENTO EIREL",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 30670,
                        "codigo": "1785039",
                        "tag": "Todos",
                        "razaoSocial": "RAFAEL DE OLIVEIRA PEREIRA RODRIGUE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 31122,
                        "codigo": "1720663",
                        "tag": "Todos",
                        "razaoSocial": "ESTARNECKS MATERIAL DE CONSTRUCAO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 54096,
                        "codigo": "1285394",
                        "tag": "Todos",
                        "razaoSocial": "CONSTRULAR DE CASIMIRO DE ABREU LTD",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 54314,
                        "codigo": "1064907",
                        "tag": "Todos",
                        "razaoSocial": "MATERIAIS DE CONSTRUCAO HAWAI EIREL",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 54516,
                        "codigo": "1056403",
                        "tag": "Todos",
                        "razaoSocial": "LOSPIPOS MATERIAL DE CONSTRUCAO LTD",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 55135,
                        "codigo": "1494940",
                        "tag": "Todos",
                        "razaoSocial": "PORTOMAC MATERIAL DE CONSTRUCAO LTD",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 56158,
                        "codigo": "1273233",
                        "tag": "Todos",
                        "razaoSocial": "WINTERLAJE COMERCIO DE MATERIAIS DE",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 56300,
                        "codigo": "1240806",
                        "tag": "Todos",
                        "razaoSocial": "GAMIT MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58144,
                        "codigo": "1798039",
                        "tag": "Todos",
                        "razaoSocial": "FRANCISCONI MATERIAL DE CONSTRUCAO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58386,
                        "codigo": "1744259",
                        "tag": "Todos",
                        "razaoSocial": "M. I. TELES NETO MATERIAL DE",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58397,
                        "codigo": "1736168",
                        "tag": "Todos",
                        "razaoSocial": "J  I  RODOLPHI MATERIAIS DE",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58404,
                        "codigo": "1751256",
                        "tag": "Todos",
                        "razaoSocial": "MURALHA MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58434,
                        "codigo": "1753193",
                        "tag": "Todos",
                        "razaoSocial": "DU MAEL MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58464,
                        "codigo": "1740458",
                        "tag": "Todos",
                        "razaoSocial": "R P  DUARTE CAVALCANTI LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58480,
                        "codigo": "1720958",
                        "tag": "Todos",
                        "razaoSocial": "SOLAGOS DISTRIBUIDORA DE TINTAS LTD",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58507,
                        "codigo": "1730574",
                        "tag": "Todos",
                        "razaoSocial": "ZILTACY DE SOUZA VEIGA 57081603734",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58535,
                        "codigo": "1726562",
                        "tag": "Todos",
                        "razaoSocial": "LMB BAZAR LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58650,
                        "codigo": "1705981",
                        "tag": "Todos",
                        "razaoSocial": "N MAGALHAES LOPES",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58734,
                        "codigo": "1696725",
                        "tag": "Todos",
                        "razaoSocial": "N B FERREIRA PARAFUSOS EM GERAL",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58784,
                        "codigo": "1695836",
                        "tag": "Todos",
                        "razaoSocial": "ZEFLOR MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58970,
                        "codigo": "1431989",
                        "tag": "Todos",
                        "razaoSocial": "R F J MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 59635,
                        "codigo": "1575896",
                        "tag": "Todos",
                        "razaoSocial": "M A MACEDO OLIVEIRA COMERCIO E",
                        "media3Meses": 3.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 113019,
                        "codigo": "1800790",
                        "tag": "Todos",
                        "razaoSocial": "DILCILEI M MARTINS MATERIAIS DE",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 114514,
                        "codigo": "1800662",
                        "tag": "Todos",
                        "razaoSocial": "C.C.S. OLIVEIRA MATERIAIS DE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 249886,
                        "codigo": "1736159",
                        "tag": "Todos",
                        "razaoSocial": "PORTO NOVO DO PERO MATERIAL DE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 251032,
                        "codigo": "1738736",
                        "tag": "Todos",
                        "razaoSocial": "MN MASINI COMERCIO DO CONSTRUTOR",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 251317,
                        "codigo": "1738110",
                        "tag": "Todos",
                        "razaoSocial": "S  M PAVAO SANTOS",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 251337,
                        "codigo": "1058671",
                        "tag": "Todos",
                        "razaoSocial": "FLAMBOYANT DO LITORAL DISTRIBUIDORA",
                        "media3Meses": 2,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 251463,
                        "codigo": "1061412",
                        "tag": "Todos",
                        "razaoSocial": "RIO LAGOS MATERIAIS DE CONSTRUCAO E",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 251488,
                        "codigo": "1735798",
                        "tag": "Todos",
                        "razaoSocial": "DEMARTINI MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 251988,
                        "codigo": "1663648",
                        "tag": "Todos",
                        "razaoSocial": "JR CASA & CONSTRUCAO LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 253159,
                        "codigo": "1703497",
                        "tag": "Todos",
                        "razaoSocial": "LUAR MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253162,
                        "codigo": "1615196",
                        "tag": "Todos",
                        "razaoSocial": "R L CRISPIM MATERIAL DE CONSTRUCAO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253163,
                        "codigo": "1724125",
                        "tag": "Todos",
                        "razaoSocial": "MV DE IGUABA LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 253165,
                        "codigo": "1733660",
                        "tag": "Todos",
                        "razaoSocial": "KAIROS MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253231,
                        "codigo": "1154836",
                        "tag": "Todos",
                        "razaoSocial": "DGM DE BUZIOS MATERIAIS DE CONSTRUC",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253274,
                        "codigo": "1720714",
                        "tag": "Todos",
                        "razaoSocial": "S  M  CAMPOS MATERIAIS DE CONSTRUCA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 253292,
                        "codigo": "1705615",
                        "tag": "Todos",
                        "razaoSocial": "R S D PACHECO COMERCIO DE MATERIAS",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253333,
                        "codigo": "1229520",
                        "tag": "Todos",
                        "razaoSocial": "CONSTRUVILA MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253401,
                        "codigo": "1796029",
                        "tag": "Todos",
                        "razaoSocial": "55 673 369 IGOR LORMAN DE OLIVEIRA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253403,
                        "codigo": "1540870",
                        "tag": "Todos",
                        "razaoSocial": "BWCC MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 11.333333333333334,
                        "pedidosMesAtual": 4,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 8
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 16
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 4
                            }
                        ]
                    },
                    {
                        "id": 253431,
                        "codigo": "1157589",
                        "tag": "Todos",
                        "razaoSocial": "AURELIMAR MATERIAIS DE CONSTRUCAO L",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253596,
                        "codigo": "1733881",
                        "tag": "Todos",
                        "razaoSocial": "RUMO CERTO MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 274713,
                        "codigo": "1368372",
                        "tag": "Todos",
                        "razaoSocial": "CONSTROFREIRE MATERIAL DE CONSTRUCA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 291203,
                        "codigo": "1376394",
                        "tag": "Todos",
                        "razaoSocial": "PORTAL COMITRA CASA E CONSTRUCAO LT",
                        "media3Meses": 2.6666666666666665,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "SERVIÇOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 291208,
                        "codigo": "1367472",
                        "tag": "Todos",
                        "razaoSocial": "CONSTRUCAO & LAZER LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 291215,
                        "codigo": "1270117",
                        "tag": "Todos",
                        "razaoSocial": "SOLIDER COMERCIO E SERVICOS LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 293051,
                        "codigo": "1284113",
                        "tag": "Todos",
                        "razaoSocial": "MAIS OPCAO MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 299377,
                        "codigo": "1253397",
                        "tag": "Todos",
                        "razaoSocial": "JUMOR MATERIAS DE CONSTRUCAO LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 299408,
                        "codigo": "1148623",
                        "tag": "Todos",
                        "razaoSocial": "MIRANDA MATERIAIS DE CONSTRUCA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 360195,
                        "codigo": "1817143",
                        "tag": "Todos",
                        "razaoSocial": "KEILA FONSECA SILVA 12661087770",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 398083,
                        "codigo": "1820407",
                        "tag": "Todos",
                        "razaoSocial": "GSRLR BUZIOS MATERIAIS DE CONSTRUCA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 603722,
                        "codigo": "1774794",
                        "tag": "Todos",
                        "razaoSocial": "CONSTRUJOTA MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 646193,
                        "codigo": "1836324",
                        "tag": "Todos",
                        "razaoSocial": "50 987 321 SONIA MARIA GOMES DA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 1064123,
                        "codigo": "1867300",
                        "tag": "Todos",
                        "razaoSocial": "CENTRAL SETE MATERIAL ELETRICO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1064730,
                        "codigo": "1867835",
                        "tag": "Todos",
                        "razaoSocial": "42 558 970 DIEGO DA CONCEICAO SILVA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1073205,
                        "codigo": "1871701",
                        "tag": "Todos",
                        "razaoSocial": "COELHO BORGES CONSTRUCOES E REFORMA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1073851,
                        "codigo": "1872126",
                        "tag": "Todos",
                        "razaoSocial": "RRB BAZAR E MATERIAL DE CONSTRUCAO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 0,
                        "codigo": "CreatedAt",
                        "createdAt": "2026-07-08T09:10:08.8445193"
                    }
                ]
            },
            {
                "id": 1492,
                "codigoVendedor": "90095891",
                "nomeVendedor": "FONSECA E MOURA",
                "basesAutosservico": [
                    {
                        "id": -1,
                        "tag": "Card-Rota",
                        "card": {
                            "totalPedidos": 0,
                            "percentTotalPedidos": 1,
                            "percentPedidosWebCliente": 0,
                            "mixPedidosWebCliente": 0,
                            "percentPedidosWebVendedor": 0,
                            "mixPedidosWebVendedor": 0,
                            "percentOutros": 0,
                            "mixOutros": 0
                        }
                    },
                    {
                        "id": -2,
                        "tag": "Card-Todos",
                        "card": {
                            "totalPedidos": 38,
                            "percentTotalPedidos": -1,
                            "percentPedidosWebCliente": 0.13157894736842105,
                            "mixPedidosWebCliente": 3,
                            "percentPedidosWebVendedor": 0.7894736842105263,
                            "mixPedidosWebVendedor": 1.1428571428571428,
                            "percentOutros": 0.07894736842105263,
                            "mixOutros": 1.3333333333333333
                        }
                    },
                    {
                        "id": 8479,
                        "codigo": "1094230",
                        "tag": "Todos",
                        "razaoSocial": "MATERIAIS DE CONSTRUCAO MEIROCH LTD",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 19135,
                        "codigo": "1403205",
                        "tag": "Todos",
                        "razaoSocial": "MATERIAIS DE CONSTRUCAO E MADEIREIR",
                        "media3Meses": 9,
                        "pedidosMesAtual": 3,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0.6666666666666666,
                        "percentOutros": 0.3333333333333333,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 8
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 15
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 11
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 10
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 13
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 19845,
                        "codigo": "1411794",
                        "tag": "Todos",
                        "razaoSocial": "SC2003 MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53366,
                        "codigo": "1628873",
                        "tag": "Todos",
                        "razaoSocial": "SOUZA E PERES MATERIAIS DE CONSTRUC",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            }
                        ]
                    },
                    {
                        "id": 53379,
                        "codigo": "1654805",
                        "tag": "Todos",
                        "razaoSocial": "ED FERREIRA MATERIAL DE CONSTRUCAO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 53415,
                        "codigo": "1611366",
                        "tag": "Todos",
                        "razaoSocial": "TOTAL GUEDES MATERIAIS DE CONSTRUCA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53832,
                        "codigo": "1419246",
                        "tag": "Todos",
                        "razaoSocial": "MARCON PADUA MATERIAIS DE CONSTRUCA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 64119,
                        "codigo": "1653489",
                        "tag": "Todos",
                        "razaoSocial": "F  J  ALMEIDA PESSOA MATERIAIS DE",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 112457,
                        "codigo": "1792914",
                        "tag": "Todos",
                        "razaoSocial": "CASA DO CAMPO DE VARRE-SAI LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 249539,
                        "codigo": "1419187",
                        "tag": "Todos",
                        "razaoSocial": "EVAN MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 5,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 8
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 249545,
                        "codigo": "1219167",
                        "tag": "Todos",
                        "razaoSocial": "EDUARDO DARGAN BOECHAT MATERIAIS DE",
                        "media3Meses": 3,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 249824,
                        "codigo": "1611781",
                        "tag": "Todos",
                        "razaoSocial": "MATERIAL DE CONSTRUCAO FERNANDES E",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 249883,
                        "codigo": "1574236",
                        "tag": "Todos",
                        "razaoSocial": "NOVA LIBERDADE MATERIAIS DE",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 249887,
                        "codigo": "1425066",
                        "tag": "Todos",
                        "razaoSocial": "MATERIAL DE CONSTRUCAO IRMAOS",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250341,
                        "codigo": "1495308",
                        "tag": "Todos",
                        "razaoSocial": "COMERCIAL VALE DA SERRA LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 250453,
                        "codigo": "1670214",
                        "tag": "Todos",
                        "razaoSocial": "MATERIAIS DE CONSTRUCAO BEIRA RIO",
                        "media3Meses": 4.333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250522,
                        "codigo": "1616355",
                        "tag": "Todos",
                        "razaoSocial": "T S MADEIRAS  CONSTRUCAO E MATERIAL",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250537,
                        "codigo": "1060396",
                        "tag": "Todos",
                        "razaoSocial": "CONSTRUCENTER CHIARELLI MATERIAIS D",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250554,
                        "codigo": "1495326",
                        "tag": "Todos",
                        "razaoSocial": "COMERCIAL VALE DA SERRA LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250556,
                        "codigo": "1574210",
                        "tag": "Todos",
                        "razaoSocial": "PJ LOPES MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250557,
                        "codigo": "1425061",
                        "tag": "Todos",
                        "razaoSocial": "CASA CORAGEM LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 250623,
                        "codigo": "1419244",
                        "tag": "Todos",
                        "razaoSocial": "GERMAR MATERIAIS ELETRO HIDRAULICOS",
                        "media3Meses": 4.333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250626,
                        "codigo": "1419635",
                        "tag": "Todos",
                        "razaoSocial": "ECC EMPREENDIMENTOS CASA E CONSTRUC",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250630,
                        "codigo": "1686105",
                        "tag": "Todos",
                        "razaoSocial": "MADECOM MATERIAIS DE CONSTRUCAO LTD",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250661,
                        "codigo": "1216489",
                        "tag": "Todos",
                        "razaoSocial": "SIVALDO FERREIRA TERRACAO LTDA",
                        "media3Meses": 12.666666666666666,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0.5,
                        "percentPedidosWebVendedor": 0.5,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 8
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 12
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 11
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 8
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 13
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250713,
                        "codigo": "1420355",
                        "tag": "Todos",
                        "razaoSocial": "CASA BRAZ DE APERIBE MATERIAIS DE",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250718,
                        "codigo": "1419233",
                        "tag": "Todos",
                        "razaoSocial": "CRAVEL COMERCIO  REPRESENTACAO E",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250719,
                        "codigo": "1419183",
                        "tag": "Todos",
                        "razaoSocial": "DIGEL DE ITAOCARA MATERIAIS DE",
                        "media3Meses": 4.333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 250720,
                        "codigo": "1397516",
                        "tag": "Todos",
                        "razaoSocial": "DEMAVIL DEPOSITO DE MADEIRA MACHADO",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            }
                        ]
                    },
                    {
                        "id": 251332,
                        "codigo": "1049075",
                        "tag": "Todos",
                        "razaoSocial": "TERRACAO MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 251420,
                        "codigo": "1059698",
                        "tag": "Todos",
                        "razaoSocial": "MATERIAIS DE CONSTRUCAO AEROPORTO L",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253346,
                        "codigo": "1758716",
                        "tag": "Todos",
                        "razaoSocial": "CIMENLOG LTDA",
                        "media3Meses": 2.6666666666666665,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 253373,
                        "codigo": "1495315",
                        "tag": "Todos",
                        "razaoSocial": "COMERCIAL VALE DA SERRA LTDA",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            }
                        ]
                    },
                    {
                        "id": 253405,
                        "codigo": "1434433",
                        "tag": "Todos",
                        "razaoSocial": "H V MAGALHAES CONSTRUCAO",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253430,
                        "codigo": "1191075",
                        "tag": "Todos",
                        "razaoSocial": "PORTUGAL PORTELENSE MATERIAIS DE",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253472,
                        "codigo": "1574214",
                        "tag": "Todos",
                        "razaoSocial": "UNIAO MATERIAIS DE CONSTRUCAO & CON",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253498,
                        "codigo": "1409444",
                        "tag": "Todos",
                        "razaoSocial": "EVEREST NORTE MAT ELETRICOS E HIDRA",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253500,
                        "codigo": "1371805",
                        "tag": "Todos",
                        "razaoSocial": "BLANC DE PADUA MATERIAIS DE",
                        "media3Meses": 2,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 253511,
                        "codigo": "1684389",
                        "tag": "Todos",
                        "razaoSocial": "NEIVA MATERIAIS DE CONSTRUCAO EIREL",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 253564,
                        "codigo": "1610236",
                        "tag": "Todos",
                        "razaoSocial": "IDEAL FREIRE EMPREENDIMENTOS",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WHATSAPP",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253591,
                        "codigo": "1524191",
                        "tag": "Todos",
                        "razaoSocial": "JAMILTON MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 3,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 253814,
                        "codigo": "1559257",
                        "tag": "Todos",
                        "razaoSocial": "BM ATACADISTA DE PADUA LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253855,
                        "codigo": "1283485",
                        "tag": "Todos",
                        "razaoSocial": "CASA J A PORTUGAL MATERIAIS DE",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 276261,
                        "codigo": "1127909",
                        "tag": "Todos",
                        "razaoSocial": "REAL MC & SERVICOS LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 287900,
                        "codigo": "1060187",
                        "tag": "Todos",
                        "razaoSocial": "JOVEL MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 287908,
                        "codigo": "1060191",
                        "tag": "Todos",
                        "razaoSocial": "JOVEL MATERIAIS DE CONSTRUCAO LTDA",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 287910,
                        "codigo": "1059553",
                        "tag": "Todos",
                        "razaoSocial": "DADE MATERIAIS DE CONSTRUCAO E TRAN",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 292713,
                        "codigo": "1127212",
                        "tag": "Todos",
                        "razaoSocial": "AREAL DAERP EIRELI",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 299072,
                        "codigo": "1060101",
                        "tag": "Todos",
                        "razaoSocial": "VAL VAL MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 299457,
                        "codigo": "1135002",
                        "tag": "Todos",
                        "razaoSocial": "FERCICLE COMERCIAL LTDA",
                        "media3Meses": 2,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 382004,
                        "codigo": "1817770",
                        "tag": "Todos",
                        "razaoSocial": "MARTINS VS COMERCIAL LTDA",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            }
                        ]
                    },
                    {
                        "id": 395883,
                        "codigo": "1819133",
                        "tag": "Todos",
                        "razaoSocial": "SIVALDO FERREIRA TERRACAO LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 471697,
                        "codigo": "1828690",
                        "tag": "Todos",
                        "razaoSocial": "J A CONSTRUTORA COMERCIO E",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 662245,
                        "codigo": "1842098",
                        "tag": "Todos",
                        "razaoSocial": "40 505 498 ANAELEN ORDIZO PONTES",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 663485,
                        "codigo": "1842882",
                        "tag": "Todos",
                        "razaoSocial": "54 031 313 ELEM PINTO DE ASSIS",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 672336,
                        "codigo": "1848145",
                        "tag": "Todos",
                        "razaoSocial": "R & M EMPREENDIMENTOS LTDA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 675016,
                        "codigo": "1461377",
                        "tag": "Todos",
                        "razaoSocial": "PJ CONSTRUIR MATERIAL DE CONSTRUCAO",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 0,
                        "codigo": "CreatedAt",
                        "createdAt": "2026-07-08T09:10:09.0144688"
                    }
                ]
            },
            {
                "id": 1399,
                "codigoVendedor": "90095895",
                "nomeVendedor": "ROSA EMILIO REPRESENTACOES",
                "basesAutosservico": [
                    {
                        "id": -1,
                        "tag": "Card-Rota",
                        "card": {
                            "totalPedidos": 0,
                            "percentTotalPedidos": 1,
                            "percentPedidosWebCliente": 0,
                            "mixPedidosWebCliente": 0,
                            "percentPedidosWebVendedor": 0,
                            "mixPedidosWebVendedor": 0,
                            "percentOutros": 0,
                            "mixOutros": 0
                        }
                    },
                    {
                        "id": -2,
                        "tag": "Card-Todos",
                        "card": {
                            "totalPedidos": 17,
                            "percentTotalPedidos": -1,
                            "percentPedidosWebCliente": 0.35294117647058826,
                            "mixPedidosWebCliente": 1.3333333333333333,
                            "percentPedidosWebVendedor": 0.4117647058823529,
                            "mixPedidosWebVendedor": 1.1428571428571428,
                            "percentOutros": 0.23529411764705882,
                            "mixOutros": 1
                        }
                    },
                    {
                        "id": 14090,
                        "codigo": "1719976",
                        "tag": "Todos",
                        "razaoSocial": "OURO FINO CASA COMPLETA LTDA",
                        "media3Meses": 3.3333333333333335,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 52864,
                        "codigo": "1721842",
                        "tag": "Todos",
                        "razaoSocial": "DISTRIBUIDORA RS LTDA",
                        "media3Meses": 4.666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 5
                            }
                        ]
                    },
                    {
                        "id": 53171,
                        "codigo": "1712577",
                        "tag": "Todos",
                        "razaoSocial": "COMERCIAL DELPUPO LTDA",
                        "media3Meses": 4.333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 8
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53348,
                        "codigo": "1624423",
                        "tag": "Todos",
                        "razaoSocial": "ALEMAO MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53661,
                        "codigo": "1487109",
                        "tag": "Todos",
                        "razaoSocial": "COMERCIAL MARCILIO DE NORONHA LTDA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53672,
                        "codigo": "1482729",
                        "tag": "Todos",
                        "razaoSocial": "COMERCIAL SERRA BRASIL MATERIAL DE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53753,
                        "codigo": "1450123",
                        "tag": "Todos",
                        "razaoSocial": "OURO FINO CASA COMPLETA LTDA",
                        "media3Meses": 12.666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 8
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 16
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 19
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 8
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53831,
                        "codigo": "1412545",
                        "tag": "Todos",
                        "razaoSocial": "PONTAL DOS CASTELHANOS MATERIAL DE",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53847,
                        "codigo": "1413799",
                        "tag": "Todos",
                        "razaoSocial": "BESSERT MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 55435,
                        "codigo": "1450852",
                        "tag": "Todos",
                        "razaoSocial": "FASSARELLA E NICOLI MATERIAL DE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 55442,
                        "codigo": "1450875",
                        "tag": "Todos",
                        "razaoSocial": "DEBRAM MATERIAL DE CONSTRUCAO EIREL",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 55722,
                        "codigo": "1408971",
                        "tag": "Todos",
                        "razaoSocial": "DISMAGUA COMERCIAL LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 55726,
                        "codigo": "1414165",
                        "tag": "Todos",
                        "razaoSocial": "MARLIN MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 58614,
                        "codigo": "1476682",
                        "tag": "Todos",
                        "razaoSocial": "ALR MATERIAL DE CONSTRUCAO E",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 60738,
                        "codigo": "1455109",
                        "tag": "Todos",
                        "razaoSocial": "N C E GALDINO LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 62055,
                        "codigo": "1777603",
                        "tag": "Todos",
                        "razaoSocial": "SERTHA FABRICA DE BLOCOS LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 249814,
                        "codigo": "1408952",
                        "tag": "Todos",
                        "razaoSocial": "COMERCIAL DELPUPO LTDA",
                        "media3Meses": 2.6666666666666665,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 250346,
                        "codigo": "1515325",
                        "tag": "Todos",
                        "razaoSocial": "ATACADO BELISARIO DA CONSTRUCAO LTD",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 251531,
                        "codigo": "1634543",
                        "tag": "Todos",
                        "razaoSocial": "CASA DO CIMENTO COMERCIO E INDUSTRI",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 251555,
                        "codigo": "1449891",
                        "tag": "Todos",
                        "razaoSocial": "IRENE PIMENTEL LOURENSUTE",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 251580,
                        "codigo": "1412835",
                        "tag": "Todos",
                        "razaoSocial": "VOLKERS MATERIAL DE CONSTRUCAO EIRE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 251613,
                        "codigo": "1150654",
                        "tag": "Todos",
                        "razaoSocial": "MALACOSKI MATERIAL DE CONSTRUCAO",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253134,
                        "codigo": "1511034",
                        "tag": "Todos",
                        "razaoSocial": "BIGOSSI MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253198,
                        "codigo": "1567719",
                        "tag": "Todos",
                        "razaoSocial": "HOME MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253418,
                        "codigo": "1447177",
                        "tag": "Todos",
                        "razaoSocial": "CECILIOTE   MATERIAL DE CONSTRUCAO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253519,
                        "codigo": "1412759",
                        "tag": "Todos",
                        "razaoSocial": "CLAUDIO COMERCIO E REPRESENTACOES E",
                        "media3Meses": 4.333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 9
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 8
                            }
                        ]
                    },
                    {
                        "id": 253576,
                        "codigo": "1501815",
                        "tag": "Todos",
                        "razaoSocial": "BRAVIM E LEMOS MATERIAL DE CONSTRUC",
                        "media3Meses": 10.333333333333334,
                        "pedidosMesAtual": 5,
                        "percentPedidosWebCliente": 0.8,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0.2,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "SERVIÇOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 18
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 11
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 12
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 13
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 10
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253632,
                        "codigo": "1799370",
                        "tag": "Todos",
                        "razaoSocial": "PONTUAL MATERIAL PARA CONSTRUCAO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 290226,
                        "codigo": "1483086",
                        "tag": "Todos",
                        "razaoSocial": "BOZI MATERIAIS PARA CONSTRUCAO LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 299061,
                        "codigo": "1003821",
                        "tag": "Todos",
                        "razaoSocial": "AGRIZZI MATERIAIS PARA CONSTRUCAO C",
                        "media3Meses": 3,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0.5,
                        "percentOutros": 0.5,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "SERVIÇOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1042461,
                        "codigo": "1856037",
                        "tag": "Todos",
                        "razaoSocial": "J L A  MATERIAL DE CONSTRUCAO LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1087692,
                        "codigo": "1881670",
                        "tag": "Todos",
                        "razaoSocial": "BRAVIM E LEMOS MATERIAL DE",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0.5,
                        "percentOutros": 0.5,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 0,
                        "codigo": "CreatedAt",
                        "createdAt": "2026-07-08T09:10:08.8942168"
                    }
                ]
            },
            {
                "id": 1152,
                "codigoVendedor": "273055",
                "nomeVendedor": "MORENA AGUIAR SOUZA DA SILVA",
                "basesAutosservico": [
                    {
                        "id": -1,
                        "tag": "Card-Rota",
                        "card": {
                            "totalPedidos": 0,
                            "percentTotalPedidos": 1,
                            "percentPedidosWebCliente": 0,
                            "mixPedidosWebCliente": 0,
                            "percentPedidosWebVendedor": 0,
                            "mixPedidosWebVendedor": 0,
                            "percentOutros": 0,
                            "mixOutros": 0
                        }
                    },
                    {
                        "id": -2,
                        "tag": "Card-Todos",
                        "card": {
                            "totalPedidos": 3,
                            "percentTotalPedidos": -1,
                            "percentPedidosWebCliente": 0.3333333333333333,
                            "mixPedidosWebCliente": 1,
                            "percentPedidosWebVendedor": 0,
                            "mixPedidosWebVendedor": 0,
                            "percentOutros": 0.6666666666666666,
                            "mixOutros": 1.5
                        }
                    },
                    {
                        "id": 29293,
                        "codigo": "1809331",
                        "tag": "Todos",
                        "razaoSocial": "KARINA KATIA DE ARAUJO AFONSO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 53705,
                        "codigo": "1481812",
                        "tag": "Todos",
                        "razaoSocial": "J  BAIA MATERIAIS DE CONSTRUCAO LTD",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 56384,
                        "codigo": "1170010",
                        "tag": "Todos",
                        "razaoSocial": "MARCIO BORGES RODRIGUES",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 56413,
                        "codigo": "1159802",
                        "tag": "Todos",
                        "razaoSocial": "AGNALDO FRANCISCO DE OLIVEIRA E CIA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 56934,
                        "codigo": "1060489",
                        "tag": "Todos",
                        "razaoSocial": "SUPERMERCADO MARILAR LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 206663,
                        "codigo": "1791152",
                        "tag": "Todos",
                        "razaoSocial": "CLAUDIA ALFENAS DA SILVA LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "SERVIÇOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 217784,
                        "codigo": "1587615",
                        "tag": "Todos",
                        "razaoSocial": "LIDERANCA CIMENTO LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 6
                            }
                        ]
                    },
                    {
                        "id": 1087839,
                        "codigo": "1881801",
                        "tag": "Todos",
                        "razaoSocial": "COMERCIAL PINTON 2 LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 1089040,
                        "codigo": "1882592",
                        "tag": "Todos",
                        "razaoSocial": "54 039 252 WILTER PIRES DA SILVA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1091809,
                        "codigo": "1884545",
                        "tag": "Todos",
                        "razaoSocial": "MATERIAL DE CONSTRUCAO  TRANSPORTES",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 0,
                        "codigo": "CreatedAt",
                        "createdAt": "2026-07-08T09:10:08.8753239"
                    }
                ]
            },
            {
                "id": 352,
                "codigoVendedor": "208195",
                "nomeVendedor": "ITALA VANESSA ALVES BEZERRA DE SOUSA",
                "basesAutosservico": [
                    {
                        "id": -1,
                        "tag": "Card-Rota",
                        "card": {
                            "totalPedidos": 0,
                            "percentTotalPedidos": 1,
                            "percentPedidosWebCliente": 0,
                            "mixPedidosWebCliente": 0,
                            "percentPedidosWebVendedor": 0,
                            "mixPedidosWebVendedor": 0,
                            "percentOutros": 0,
                            "mixOutros": 0
                        }
                    },
                    {
                        "id": -2,
                        "tag": "Card-Todos",
                        "card": {
                            "totalPedidos": 2,
                            "percentTotalPedidos": -1,
                            "percentPedidosWebCliente": 0,
                            "mixPedidosWebCliente": 0,
                            "percentPedidosWebVendedor": 0,
                            "mixPedidosWebVendedor": 0,
                            "percentOutros": 1,
                            "mixOutros": 1
                        }
                    },
                    {
                        "id": 29484,
                        "codigo": "1809325",
                        "tag": "Todos",
                        "razaoSocial": "JUSFRIO COMERCIO DE PECAS E",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 32879,
                        "codigo": "1809596",
                        "tag": "Todos",
                        "razaoSocial": "RESIDENCIAL MONTE CARLO INCORPORACA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 51023,
                        "codigo": "1811452",
                        "tag": "Todos",
                        "razaoSocial": "CONDOMINIO EDIFICIO COMERCIO E",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CPP_CRC",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "CPP_CRC",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "CPP_CRC",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "CPP_CRC",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 166697,
                        "codigo": "10090026",
                        "tag": "Todos",
                        "razaoSocial": "ELISEU ALVES",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 166731,
                        "codigo": "3164908",
                        "tag": "Todos",
                        "razaoSocial": "ELISEU ALVES",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 257043,
                        "codigo": "1528224",
                        "tag": "Todos",
                        "razaoSocial": "SPINNE PARTICIPACOES S S LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CPP_CRC",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 264035,
                        "codigo": "3274176",
                        "tag": "Todos",
                        "razaoSocial": "GIANCARLO CORREA DE SOUZA DA SILVA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CPP_CRC",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 275384,
                        "codigo": "1721662",
                        "tag": "Todos",
                        "razaoSocial": "ROMANOF LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 275433,
                        "codigo": "1775405",
                        "tag": "Todos",
                        "razaoSocial": "3HP AUTOMACAO S A",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 275463,
                        "codigo": "10090285",
                        "tag": "Todos",
                        "razaoSocial": "RENATA FISCHER FERNANDES",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 278837,
                        "codigo": "1725030",
                        "tag": "Todos",
                        "razaoSocial": "REACTY 001 AGOSTINHO MENDICUTE SPE",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 287127,
                        "codigo": "1795387",
                        "tag": "Todos",
                        "razaoSocial": "JUSFRIO COMERCIO DE PECAS E",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 359886,
                        "codigo": "1816896",
                        "tag": "Todos",
                        "razaoSocial": "ALLSON S PARTICIPACOES LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 445530,
                        "codigo": "1825395",
                        "tag": "Todos",
                        "razaoSocial": "TERRAZ EMPREENDIMENTOS SPE LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 638075,
                        "codigo": "1832366",
                        "tag": "Todos",
                        "razaoSocial": "MA 17 EMPREENDIMENTO IMOBILIARIO SP",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 657349,
                        "codigo": "1839199",
                        "tag": "Todos",
                        "razaoSocial": "ENGEPROL ENGENHARIA CONSTRUCOES E C",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 666722,
                        "codigo": "3294219",
                        "tag": "Todos",
                        "razaoSocial": "GIANCARLO FRANCESCO CIVITA",
                        "media3Meses": 2.6666666666666665,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 669684,
                        "codigo": "3294426",
                        "tag": "Todos",
                        "razaoSocial": "MARIANA ROCHA KANNER VITAL BRAZIL T",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 673362,
                        "codigo": "1848734",
                        "tag": "Todos",
                        "razaoSocial": "ALEGRA PATRIMONIAL II LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1041180,
                        "codigo": "1855358",
                        "tag": "Todos",
                        "razaoSocial": "TRYO SPE LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1048446,
                        "codigo": "3268738",
                        "tag": "Todos",
                        "razaoSocial": "RAFAEL DE MORAES VICINTIN",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 1048818,
                        "codigo": "10095535",
                        "tag": "Todos",
                        "razaoSocial": "YARA MARIA ARAUJO BARRETO DE ALMEID",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1069052,
                        "codigo": "1868913",
                        "tag": "Todos",
                        "razaoSocial": "HI ASSISTENCIA TECNICA LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 1069421,
                        "codigo": "1869271",
                        "tag": "Todos",
                        "razaoSocial": "SOLINT CONSTRUTORA LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 1069933,
                        "codigo": "1869536",
                        "tag": "Todos",
                        "razaoSocial": "CONSTRUTORA HOSS LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1075472,
                        "codigo": "1873220",
                        "tag": "Todos",
                        "razaoSocial": "GRP PARTICIPACOES LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1076019,
                        "codigo": "1873627",
                        "tag": "Todos",
                        "razaoSocial": "MUNTE BELA VISTA EMPREENDIMENTO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1082434,
                        "codigo": "1877955",
                        "tag": "Todos",
                        "razaoSocial": "BINAR COMERCIAL CONSTRUTORA LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1083984,
                        "codigo": "1878903",
                        "tag": "Todos",
                        "razaoSocial": "MAREMA INCORPORADORA E",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1085995,
                        "codigo": "1880481",
                        "tag": "Todos",
                        "razaoSocial": "IGREJA EVANGELICA PENTECOSTAL",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1087398,
                        "codigo": "1881451",
                        "tag": "Todos",
                        "razaoSocial": "OMNITEK TECNOLOGIA LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1089862,
                        "codigo": "1883160",
                        "tag": "Todos",
                        "razaoSocial": "DPT ENGENHARIA E ARQUITETURA LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 1090132,
                        "codigo": "3300062",
                        "tag": "Todos",
                        "razaoSocial": "CRISTIANO CELESTINO DE JESUS",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1090755,
                        "codigo": "3300137",
                        "tag": "Todos",
                        "razaoSocial": "ROBERTO FAHL FINTA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1091860,
                        "codigo": "1884610",
                        "tag": "Todos",
                        "razaoSocial": "CONSORCIO HR",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1092721,
                        "codigo": "1884667",
                        "tag": "Todos",
                        "razaoSocial": "TUDOR ENGENHARIA LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1095322,
                        "codigo": "1886741",
                        "tag": "Todos",
                        "razaoSocial": "GDO CONSTRUTORA & INCORPORADORA LTD",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "IMO",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1106325,
                        "codigo": "3300633",
                        "tag": "Todos",
                        "razaoSocial": "FERNANDO ANTONIO SIMOES",
                        "media3Meses": 4,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 8
                            }
                        ]
                    },
                    {
                        "id": 1108958,
                        "codigo": "1889413",
                        "tag": "Todos",
                        "razaoSocial": "PTF ARQUITETURA E DECORACAO LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 1108987,
                        "codigo": "1889442",
                        "tag": "Todos",
                        "razaoSocial": "CIVILMON CONSTRUCOES LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CPP_VE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1109012,
                        "codigo": "1889424",
                        "tag": "Todos",
                        "razaoSocial": "CIVILMON CONSTRUCOES LTDA",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 0,
                        "codigo": "CreatedAt",
                        "createdAt": "2026-07-08T09:10:08.9159334"
                    }
                ]
            },
            {
                "id": 1276,
                "codigoVendedor": "90121955",
                "nomeVendedor": "CLIENTE FECHADO",
                "basesAutosservico": [
                    {
                        "id": -1,
                        "tag": "Card-Rota",
                        "card": {
                            "totalPedidos": 0,
                            "percentTotalPedidos": 1,
                            "percentPedidosWebCliente": 0,
                            "mixPedidosWebCliente": 0,
                            "percentPedidosWebVendedor": 0,
                            "mixPedidosWebVendedor": 0,
                            "percentOutros": 0,
                            "mixOutros": 0
                        }
                    },
                    {
                        "id": -2,
                        "tag": "Card-Todos",
                        "card": {
                            "totalPedidos": 1,
                            "percentTotalPedidos": 0,
                            "percentPedidosWebCliente": 0,
                            "mixPedidosWebCliente": 0,
                            "percentPedidosWebVendedor": 1,
                            "mixPedidosWebVendedor": 1,
                            "percentOutros": 0,
                            "mixOutros": 0
                        }
                    },
                    {
                        "id": 30845,
                        "codigo": "1699557",
                        "tag": "Todos",
                        "razaoSocial": "CENTRO DAS CONSTRUCOES LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 112734,
                        "codigo": "1800565",
                        "tag": "Todos",
                        "razaoSocial": "RENOVA E INOVA BAZAR E MATERIAL DE",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 112865,
                        "codigo": "1800699",
                        "tag": "Todos",
                        "razaoSocial": "47 132 883 NORAIR CORDEIRO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 0,
                        "codigo": "CreatedAt",
                        "createdAt": "2026-07-08T09:10:08.8942528"
                    }
                ]
            },
            {
                "id": 1493,
                "codigoVendedor": "90122641",
                "nomeVendedor": "LR ENGENHARIA E REPRESENTACOES",
                "basesAutosservico": [
                    {
                        "id": -1,
                        "tag": "Card-Rota",
                        "card": {
                            "totalPedidos": 0,
                            "percentTotalPedidos": 1,
                            "percentPedidosWebCliente": 0,
                            "mixPedidosWebCliente": 0,
                            "percentPedidosWebVendedor": 0,
                            "mixPedidosWebVendedor": 0,
                            "percentOutros": 0,
                            "mixOutros": 0
                        }
                    },
                    {
                        "id": -2,
                        "tag": "Card-Todos",
                        "card": {
                            "totalPedidos": 11,
                            "percentTotalPedidos": -1,
                            "percentPedidosWebCliente": 0.36363636363636365,
                            "mixPedidosWebCliente": 2.5,
                            "percentPedidosWebVendedor": 0.45454545454545453,
                            "mixPedidosWebVendedor": 2.25,
                            "percentOutros": 0.18181818181818182,
                            "mixOutros": 1.5
                        }
                    },
                    {
                        "id": 54032,
                        "codigo": "1285365",
                        "tag": "Todos",
                        "razaoSocial": "A  S  GONCALVES COMERCIO DE",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 56081,
                        "codigo": "1320328",
                        "tag": "Todos",
                        "razaoSocial": "BAZAR E MATERIAL DE CONSTRUCAO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 56903,
                        "codigo": "1060215",
                        "tag": "Todos",
                        "razaoSocial": "A G H R  BAZAR LTDA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 56993,
                        "codigo": "1059596",
                        "tag": "Todos",
                        "razaoSocial": "E BRAGA DE AZEREDO LTDA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 57037,
                        "codigo": "1059672",
                        "tag": "Todos",
                        "razaoSocial": "COMERCIO E REPRESENTACOES ITACAL",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 58618,
                        "codigo": "1706109",
                        "tag": "Todos",
                        "razaoSocial": "M RODRIGUES RANGEL LTDA",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            }
                        ]
                    },
                    {
                        "id": 59845,
                        "codigo": "1060244",
                        "tag": "Todos",
                        "razaoSocial": "CASA NOSSA MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 59850,
                        "codigo": "1664670",
                        "tag": "Todos",
                        "razaoSocial": "SOLUVALE COMERCIO E LOCACAO DE",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 134283,
                        "codigo": "1278830",
                        "tag": "Todos",
                        "razaoSocial": "E F A CHAGAS MATERIAIS DE CONSTRUCO",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 249605,
                        "codigo": "1526929",
                        "tag": "Todos",
                        "razaoSocial": "MDA CONSTRUTORA LTDA",
                        "media3Meses": 6.666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 10
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 18
                            }
                        ]
                    },
                    {
                        "id": 250711,
                        "codigo": "1669286",
                        "tag": "Todos",
                        "razaoSocial": "CASA DO CIMENTO MATERIAL DE",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 251462,
                        "codigo": "1064158",
                        "tag": "Todos",
                        "razaoSocial": "MALURDES MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 2.3333333333333335,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 7
                            }
                        ]
                    },
                    {
                        "id": 253461,
                        "codigo": "1655939",
                        "tag": "Todos",
                        "razaoSocial": "R VIEIRA RANGEL LTDA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 253555,
                        "codigo": "1715595",
                        "tag": "Todos",
                        "razaoSocial": "CONSTRULAR MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 13,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 15
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 18
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 9
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 16
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 18
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 9
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 253570,
                        "codigo": "1759512",
                        "tag": "Todos",
                        "razaoSocial": "MOREIRA RIBEIRO MATERIAL DE",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 253590,
                        "codigo": "1679059",
                        "tag": "Todos",
                        "razaoSocial": "CIMEMPRIMO DISTRIBUICAO DE CIMENTO",
                        "media3Meses": 5.666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 8
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 12
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 5
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 272095,
                        "codigo": "1296535",
                        "tag": "Todos",
                        "razaoSocial": "ANTONIO JORGE RIBEIRO COMERCIO DE",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 292733,
                        "codigo": "1176972",
                        "tag": "Todos",
                        "razaoSocial": "MACONGAS MATERIAIS DE CONSTRUCAO",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 294414,
                        "codigo": "1284470",
                        "tag": "Todos",
                        "razaoSocial": "L PEREIRA DE ARAUJO",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 295437,
                        "codigo": "1389182",
                        "tag": "Todos",
                        "razaoSocial": "NOVA DIVINEIA MATERIAIS DE",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 3
                            }
                        ]
                    },
                    {
                        "id": 373819,
                        "codigo": "1427410",
                        "tag": "Todos",
                        "razaoSocial": "ESTEFANIA DA SILVA CRUZ BARBOSA",
                        "media3Meses": 2.6666666666666665,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 643074,
                        "codigo": "1834980",
                        "tag": "Todos",
                        "razaoSocial": "BRUNO DA SILVA MIRANDA DISTRIBUIDOR",
                        "media3Meses": 1.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            }
                        ]
                    },
                    {
                        "id": 665853,
                        "codigo": "1844459",
                        "tag": "Todos",
                        "razaoSocial": "SUPREMO DISTRIBUIDORA DE MATERIAL D",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 673759,
                        "codigo": "1848955",
                        "tag": "Todos",
                        "razaoSocial": "SERGIO LUIZ DE FRANCA",
                        "media3Meses": 1,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 895254,
                        "codigo": "1059476",
                        "tag": "Todos",
                        "razaoSocial": "A  M  S  PETRONILHA",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1059806,
                        "codigo": "1864837",
                        "tag": "Todos",
                        "razaoSocial": "BRUNO DA SILVA MIRANDA DISTRIBUIDOR",
                        "media3Meses": 17,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "SERVIÇOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 24
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 67
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 62
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 16
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 30
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 6
                            }
                        ]
                    },
                    {
                        "id": 1059807,
                        "codigo": "1864825",
                        "tag": "Todos",
                        "razaoSocial": "SUPREMO DISTRIBUIDORA DE MATERIAL D",
                        "media3Meses": 16.666666666666668,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "SERVIÇOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 26
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 7
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 42
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 44
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 1080166,
                        "codigo": "1876432",
                        "tag": "Todos",
                        "razaoSocial": "VILHETE RAMOS COMERCIO E SERVICOS",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1081385,
                        "codigo": "1877324",
                        "tag": "Todos",
                        "razaoSocial": "WALAS SOARES DA SILVA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1081387,
                        "codigo": "1877310",
                        "tag": "Todos",
                        "razaoSocial": "IRMAOS VELASCO EMPREENDIMENTOS E",
                        "media3Meses": 3,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 1,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 6
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 2
                            }
                        ]
                    },
                    {
                        "id": 1084312,
                        "codigo": "1879178",
                        "tag": "Todos",
                        "razaoSocial": "63.080.124 VICTOR MANUEL ANDRADE",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1109244,
                        "codigo": "1889643",
                        "tag": "Todos",
                        "razaoSocial": "M  SANTANA VENANCIO SARDINHA PEDRA",
                        "media3Meses": 0.3333333333333333,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 0,
                        "codigo": "CreatedAt",
                        "createdAt": "2026-07-08T09:10:09.0142552"
                    }
                ]
            },
            {
                "id": 517,
                "codigoVendedor": "00249759",
                "nomeVendedor": "ADEMIS DOUGLAS DA SILVA CRUZ",
                "basesAutosservico": [
                    {
                        "id": -1,
                        "tag": "Card-Rota",
                        "card": {
                            "totalPedidos": 0,
                            "percentTotalPedidos": 1,
                            "percentPedidosWebCliente": 0,
                            "mixPedidosWebCliente": 0,
                            "percentPedidosWebVendedor": 0,
                            "mixPedidosWebVendedor": 0,
                            "percentOutros": 0,
                            "mixOutros": 0
                        }
                    },
                    {
                        "id": -2,
                        "tag": "Card-Todos",
                        "card": {
                            "totalPedidos": 19,
                            "percentTotalPedidos": -1,
                            "percentPedidosWebCliente": 0.5789473684210527,
                            "mixPedidosWebCliente": 1.5,
                            "percentPedidosWebVendedor": 0,
                            "mixPedidosWebVendedor": 0,
                            "percentOutros": 0.42105263157894735,
                            "mixOutros": 2
                        }
                    },
                    {
                        "id": 263139,
                        "codigo": "1774986",
                        "tag": "Todos",
                        "razaoSocial": "FIEL DISTRIBUIDORA DE CIMENTO LTDA",
                        "media3Meses": 4.666666666666667,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 8
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 3
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 5
                            }
                        ]
                    },
                    {
                        "id": 263154,
                        "codigo": "1455713",
                        "tag": "Todos",
                        "razaoSocial": "CIMENTEX DISTRIBUIDORA DE CIMENTO E",
                        "media3Meses": 0.6666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 30
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 47
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 14
                            },
                            {
                                "grupoNegocioMapa": "WEB_VENDEDOR",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 263157,
                        "codigo": "1633325",
                        "tag": "Todos",
                        "razaoSocial": "S F  DISTRIBUIDORA DE CIMENTO LTDA",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 263179,
                        "codigo": "1383184",
                        "tag": "Todos",
                        "razaoSocial": "PETROFER COMERCIO DE PRODUTOS SIDER",
                        "media3Meses": 7,
                        "pedidosMesAtual": 1,
                        "percentPedidosWebCliente": 1,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 20
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 263197,
                        "codigo": "1653013",
                        "tag": "Todos",
                        "razaoSocial": "W L LEITE REPRESENTACAO LTDA",
                        "media3Meses": 50.666666666666664,
                        "pedidosMesAtual": 18,
                        "percentPedidosWebCliente": 0.5555555555555556,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0.4444444444444444,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 23
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 22
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 33
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 16
                            },
                            {
                                "grupoNegocioMapa": "RECEPTIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 8
                            },
                            {
                                "grupoNegocioMapa": "SERVIÇOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 20
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 50
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 42
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 37
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 45
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 10
                            }
                        ]
                    },
                    {
                        "id": 263234,
                        "codigo": "1401747",
                        "tag": "Todos",
                        "razaoSocial": "PETROFER COMERCIO DE PRODUTOS",
                        "media3Meses": 13.666666666666666,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "CONTRATO",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 4
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "OUTROS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-02-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-03-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 20
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 30
                            },
                            {
                                "grupoNegocioMapa": "WEB_CLIENTE",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 10
                            }
                        ]
                    },
                    {
                        "id": 0,
                        "codigo": "CreatedAt",
                        "createdAt": "2026-07-08T09:10:08.9540918"
                    }
                ]
            },
            {
                "id": 1293,
                "codigoVendedor": "90121953",
                "nomeVendedor": "CLIENTE NÃO CONSOME BASICAS",
                "basesAutosservico": [
                    {
                        "id": -1,
                        "tag": "Card-Rota",
                        "card": {
                            "totalPedidos": 0,
                            "percentTotalPedidos": 1,
                            "percentPedidosWebCliente": 0,
                            "mixPedidosWebCliente": 0,
                            "percentPedidosWebVendedor": 0,
                            "mixPedidosWebVendedor": 0,
                            "percentOutros": 0,
                            "mixOutros": 0
                        }
                    },
                    {
                        "id": -2,
                        "tag": "Card-Todos",
                        "card": {
                            "totalPedidos": 2,
                            "percentTotalPedidos": 1,
                            "percentPedidosWebCliente": 0,
                            "mixPedidosWebCliente": 0,
                            "percentPedidosWebVendedor": 0,
                            "mixPedidosWebVendedor": 0,
                            "percentOutros": 1,
                            "mixOutros": 1
                        }
                    },
                    {
                        "id": 1075814,
                        "codigo": "1873451",
                        "tag": "Todos",
                        "razaoSocial": "JOTAEFE MATERIAL DE CONSTRUCAO E",
                        "media3Meses": 0,
                        "pedidosMesAtual": 0,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 0,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 1082629,
                        "codigo": "1878080",
                        "tag": "Todos",
                        "razaoSocial": "56.917.118 CASSIO DE OLIVEIRA",
                        "media3Meses": 1.6666666666666667,
                        "pedidosMesAtual": 2,
                        "percentPedidosWebCliente": 0,
                        "percentPedidosWebVendedor": 0,
                        "percentOutros": 1,
                        "grafico": [
                            {
                                "grupoNegocioMapa": "ATIVOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-04-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-05-01T00:00:00",
                                "quantidadeOrdens": 2
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-06-01T00:00:00",
                                "quantidadeOrdens": 1
                            },
                            {
                                "grupoNegocioMapa": "REMOTOS",
                                "mes": "2026-07-01T00:00:00",
                                "quantidadeOrdens": 1
                            }
                        ]
                    },
                    {
                        "id": 0,
                        "codigo": "CreatedAt",
                        "createdAt": "2026-07-08T09:10:08.9541633"
                    }
                ]
            }
        ]
    ],
    "existentes": []
}
]]